import * as moment from 'moment'
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http } from '@angular/http';
import { CommHttpService } from './comm-http.service';
import { IBaseResponse } from '../models/comm-http/responses/BaseResponse';
import { LoginResponse } from '../models/ss-api/responses/login.response';
import { LoginRequest } from '../models/ss-api/requests/login.request';
import { Subject } from 'rxjs';
import { FullSearchResponse } from '../models/ss-api/responses/full.search.response';
import { LicenseFullResponse } from '../models/ss-api/responses/license.full.response';
import { StringResponse } from '../models/ss-api/responses/string.response';
import { INoteEditRequest } from '../models/ss-api/requests/note.edit.request';
import { INoteAddRequest } from '../models/ss-api/requests/note.add.request';
import { NoteArray, NoteTypes, Note } from '../models/domain/note';
import { NoteHistoryItemArray } from '../models/domain/note.history.item';
import { NotesAll } from '../models/domain/notes.all';
import { SendTwoFactorCodeOptionRequest } from '../models/ss-api/requests/send.two.factor.code.option.request';
import { TwoFactorAuthenticationRequest } from '../models/ss-api/requests/two.factor.authentication.request';
import { TimeGroupArray } from '../models/domain/timeconditions';
import { LicenseSearchResponseArray } from '../models/ss-api/responses/license.search.response';
import { Member } from '../models/domain/member';
import { LicenseUpgradeLogArray } from '../models/domain/license.upgrade.log';
import { CreditCardArray } from '../models/domain/credit.card';
import { TagArray } from '../models/domain/tag';
import { GISUsageLogArray } from '../models/domain/gis.usage.log';
import { GISBundleLogArray } from '../models/domain/gis.bundle.log.item';
import { UpgradeSimulation } from '../models/domain/upgrade.simulation';
import { IByDateRangeRequest } from '../models/ss-api/requests/by.date.range.request';
import { IMemberEditRequest } from '../models/ss-api/requests/member.edit.request';
import { IMemberTagsEditRequest } from '../models/ss-api/requests/tag.edit.request';
import { ILicenseEditRequest } from '../models/ss-api/requests/license.edit.request';
import { IUpgradeSimulationRequest } from '../models/ss-api/requests/upgrade.simulation.request';
import { PinArray, PinItem } from '../models/domain/pin';
import { TicketsCountItemArray } from '../models/domain/ticket.count.item';
import { TicketWidgetItemArray } from '../models/domain/ticket.widget.item';
import { IPinAddRequest } from '../models/ss-api/requests/pin.add.request';
import { TicketStatusArray } from '../models/domain/ticket.status';
import { TicketItem } from '../models/domain/ticket.item';
import { AdminItemArray } from '../models/domain/admin.item';
import { TicketDepartmentArray } from '../models/domain/ticket.department';
import { TicketGlobals } from '../models/domain/ticket.globals';
import { IAddTicketReplyRequest } from '../models/ss-api/requests/add.ticket.reply.request';
import { TicketLogItemArray } from '../models/domain/ticket.log.item';
import { TicketTotals } from '../models/domain/ticket.totals';
import { IUpdateTicketRequest } from '../models/ss-api/requests/update.ticket.request';
import { IOpenNewTicketRequest } from '../models/ss-api/requests/open.new.ticket.request';
import { LicenseTransferLogArray } from '../models/domain/license.transfer.log';
import { MemberDashboard } from '../models/ss-api/responses/member.dashboard.response';
import { TemplatesAndFromResponse } from '../models/ss-api/responses/templates.and.from.response';
import { InvoiceArray } from '../models/domain/invoice';
import { EmailTemplateFullItem } from '../models/domain/email.template.full.item';
import { SendEmailRequest } from '../models/ss-api/requests/send.email.request';
import { EmailLogItemBasicArray, EmailLogItemBasic } from '../models/domain/email.log.item.basics';
import { CreditItemArray } from '../models/domain/credit.item';
import { AddCreditRequest } from '../models/ss-api/requests/add.credit.request';
import { AddDiscountItemRequest } from '../models/ss-api/requests/add.discount.item.request';
import { EditDiscountItemRequest } from '../models/ss-api/requests/edit.discount.item.request';
import { AddInvoiceRequest } from '../models/ss-api/requests/add.invoice.request';
import { InvoicePaymentRequest } from '../models/ss-api/requests/invoice.payment.request';
import { EditInvoiceRequest } from '../models/ss-api/requests/edit.invoice.request';
import { LicenseTransferMemberRequest } from '../models/ss-api/requests/license.transfer.member.request';
import { ReassignLicenseRequest } from '../models/ss-api/requests/reassign.license.request';
import { NewSubscriptionDataResponse } from '../models/ss-api/responses/new.subscription.data.response';
import { ReactivateLicenseRequest } from '../models/ss-api/requests/reactivate.license.request';
import { AddCreditCardRequest } from '../models/ss-api/requests/add.credit.card.request';
import { AddLicenseRequest } from '../models/ss-api/requests/add.license.request';
import { MemberMergeRequest } from '../models/ss-api/requests/member.merge.request';
import { GISPurchaseRefundRequest } from '../models/ss-api/requests/gis.purchase.refund.request';
import { AddFreeGISBundleCreditsRequest } from '../models/ss-api/requests/add.gis.free.credits.request';
import { SalesRepresentativeArray } from '../models/domain/sales.representative';
import { ProductItemBasicsArray } from '../models/domain/product.item.basics';
import { AdvancedSearchResultMemberItemArray, GlobalSearchResults } from '../models/domain/advanced.searche.results';
import { AdvancedSearchItem } from '../models/domain/advanced.search.item';
import { AdminBrowseLogItemArray } from '../models/ss-api/responses/admin.browse.logs.response';
import { SalesStatisticsResult } from '../models/ss-api/responses/sales.statistics.result';
import { GetInvoicesByDateRequest } from './../models/ss-api/requests/get.invoices.by.date.request';
import { SalesStatsRequest } from '../models/ss-api/requests/sales.stats.request';
import { ProductTotalsItemArray } from '../models/ss-api/responses/product.totals.item';
import { ProductsTotalsRequest } from '../models/ss-api/requests/products.totals.request';
import { AddMemberRequest } from '../models/ss-api/requests/add.member.request';
import { TicketAssignAdminRequest } from '../models/ss-api/requests/ticket.assign.admin.request';
import { TicketAssignMemberRequest } from '../models/ss-api/requests/ticket.assign.member.request';
import { CustomTicketItem, TicketStatusTypes, CustomTicketItemArray } from '../models/domain/custom.ticket.item';
import { HubspotTicketItem, HubspotTicketStatusTypes, HubspotTicketItemArray } from '../models/domain/hubspot.ticket.item';
import { AddCustomTicketRequest } from '../models/ss-api/requests/add.custom.ticket.request';
import { EditCustomTicketRequest } from '../models/ss-api/requests/edit.custom.ticket.request';
import { CustomTicketsAdminTotalsArray } from '../models/domain/custom.tickets.admin.totals';
import { CustomTicketsMemberTotalsArray } from '../models/domain/custom.tickets.member.totals';
import { CustomTicketsAdminGlobalsResponse } from '../models/ss-api/responses/custom.tickets.admin.globals.response';
import { CustomTicketsMemberGlobalsResponse } from '../models/ss-api/responses/custom.tickets.member.globals.response';
import { CustomTicketAssignResponse } from '../models/ss-api/responses/custom.ticket.assign.response';
import { CustomTicketWidgetItemArray, CustomTicketWidgetItem } from '../models/domain/custom.ticket.widget';
import { AddCustomTicketReplyRequest } from '../models/ss-api/requests/add.custom.ticket.reply.request';
import { CustomTicketsWidgetsSearchRequest } from '../models/ss-api/requests/custom.tickets.widgets.search.request';
import { HubspotTicketsAdminTotalsArray } from '../models/domain/hubspot.tickets.admin.totals';
import { HubspotTicketsMemberTotalsArray } from '../models/domain/hubspot.tickets.member.totals';
import { HubspotTicketsAdminGlobalsResponse } from '../models/ss-api/responses/hubspot.tickets.admin.globals.response';
import { HubspotTicketsMemberGlobalsResponse } from '../models/ss-api/responses/hubspot.tickets.member.globals.response';
import { HubspotTicketWidgetItemArray, HubspotTicketWidgetItem } from '../models/domain/hubspot.ticket.widget';
import { HubspotTicketsWidgetsSearchRequest } from '../models/ss-api/requests/hubspot.tickets.widgets.search.request';
import { TOSIPArray } from '../models/domain/tos.ip';
import { TOSMacArray } from '../models/domain/tos.mac';
import { TOSComputerArray, TOSMemberComputer, TOSMemberComputerArray } from '../models/domain/tos.computer';
import { AddTOSIPRequest } from '../models/ss-api/requests/add.tos.ip.request';
import { addTOSMacRequest } from '../models/ss-api/requests/add.tos.mac.request';
import { AddTOSComputerRequest } from '../models/ss-api/requests/add.tos.computer.request';
import { GISProductItemArray } from '../models/domain/gis.product.item';
import { GISAddons } from '../models/domain/gis.product.item';
import { OrderGISBundleRequest } from '../models/ss-api/requests/order.gis.bundle.request';
import { MemberNewLoginSessionRequest } from '../models/ss-api/requests/member.new.login.session';
import { TOSActivityLogResponseArray } from '../models/ss-api/responses/tos.activity.log.response';
import { AuditLogItemArray } from '../models/domain/audit.log.item';
import { MemberActivityLogsRequest } from '../models/ss-api/requests/member.activity.logs.request';
import { LicenseActivityLogsRequest } from '../models/ss-api/requests/license.activity.logs.request';
import { ActivityLogsBaseRequest } from '../models/ss-api/requests/activity.logs.base.request';
import { EditTOSIPRequest } from '../models/ss-api/requests/edit.tos.ip.request';
import { VendorArray } from '../models/domain/vendor';
import { EditVendorRequest } from '../models/ss-api/requests/edit.vendor.request';
import { AddVendorRequest } from '../models/ss-api/requests/add.vendor.request';
import { VendorStatisticsItemArray } from '../models/ss-api/responses/vendor.statistics.response';
import { VendorStatisticsRequest } from '../models/ss-api/requests/vendor.statistics.request';
import { VendorItemArray } from '../models/domain/vendor.item';
import { EditVendorItemIgnoreRequest } from '../models/ss-api/requests/edit.vendor.item.ignore.request';
import { SendVendorStatsEmailRequest } from '../models/ss-api/requests/send.vendor.stats.email.request';
import { CreditCardSetActiveRequest } from '../models/ss-api/requests/credit.card.set.active.request';
import { UnlockLoginRequest } from '../models/ss-api/requests/unlock.login.request';
import { LicenseAuditLogsRequest } from '../models/ss-api/requests/license.audit.logs.request';
import { DecryptCreditCardRequest } from '../models/ss-api/requests/decrypt.credit.card.request';
import { CreditCardSetHiddenRequest } from '../models/ss-api/requests/credit.card.set.hidden.request';
import { LicenseReactivateSimulationResponse } from '../models/ss-api/responses/license.reactivate.simulation.response';
import { CreditCardEditRequest } from '../models/ss-api/requests/credit.card.edit.request';
import { GracePeriodReportItemArray } from '../models/ss-api/responses/grace.period.report.response';
import { AdminLogItemArray } from '../models/domain/admin.log.item';
import { LogsResponse } from '../models/ss-api/responses/logs.response';
import { MemberLogItemArray } from '../models/domain/member.log.item';
import { DeleteCreditRequest } from '../models/ss-api/requests/delete.credit.request';
import { InvoicePaymentGatewayLogArray } from '../models/domain/invoice.payment.gateway.log';
import { ActivityItemArray } from '../models/domain/activity.item';
import { TrainingClass, TrainingClassArray } from '../models/domain/training.class';
import { TrainingEvent, TrainingEventArray } from '../models/domain/training.event';
import { TrainingCalendarRequest } from '../models/ss-api/requests/training.calendar.request';
import { AdminTrainingCalendarResponse } from '../models/ss-api/responses/admin.training.calendar.response';
import { environment } from '../../environments/environment';
import { AddTrainingClassRequest } from '../models/ss-api/requests/add.training.class.request';
import { UpdateTrainingClassRequest } from '../models/ss-api/requests/update.training.class.request';
import { RescheduleTrainingEventRequest } from '../models/ss-api/requests/reschedule.training.event.request';
import { UpdateTrainingEventSubscriptionStatusesRequestArray } from '../models/ss-api/requests/update.training.event.subscription.statuses.request';
import { AddTrainingEventRequest } from '../models/ss-api/requests/add.training.event.request';
import { UpdateTrainingEventRequest } from '../models/ss-api/requests/update.training.event.request';
import { GetTrainingEventBasicsByClassIDRequest } from '../models/ss-api/requests/get.training.event.basics.by.class.id.request';
import { RescheduleTrainingEventResponse } from '../models/ss-api/responses/reschedule.training.event.response';
import { SendTestEmailsForTrainingEventRequest } from '../models/ss-api/requests/send.test.emails.for.training.event.request';
import { SendRealEmailsForTrainingEventRequest } from '../models/ss-api/requests/send.real.emails.for.training.event.request';
import { SendEmailForTrainingEventSubscriptionRequest } from '../models/ss-api/requests/send.email.for.training.event.subscription.request';
import { TrainingPreviewEmailsResponse } from '../models/ss-api/responses/training.preview.emails.response';
import { PreviewEmailsForTrainingEventRequest } from '../models/ss-api/requests/preview.emails.for.training.event.request';
import { TrainingHistoryResponseArray } from '../models/ss-api/responses/training.history.response';
import { TrainingEventSubscriptionCertificateResponse } from '../models/ss-api/responses/training.event.subscription.certificate.response';
import { AddTrainingEventSubscriptionOnlyRequest } from '../models/ss-api/requests/add.training.event.subscription.only.request';
import { UpdateTrainingEventSubscriptionRequest } from '../models/ss-api/requests/update.training.event.subscription.request';
import { AddTrainingEventResponse } from '../models/ss-api/responses/add.training.event.response';
import { DeleteTrainingEventResponse } from '../models/ss-api/responses/delete.training.event.response';
import { UpdateTrainingEventResponse } from '../models/ss-api/responses/update.training.event.response';
import { AddTrainingEventSubscriptionResponse } from '../models/ss-api/responses/add.training.event.subscription.response';
import { UpdateTrainingEventSubscriptionResponse } from '../models/ss-api/responses/update.training.event.subscription.response';
import { UpdateTrainingEventSubscriptionStatusesResponse } from '../models/ss-api/responses/update.training.event.subscription.statuses.response';
import { UpdateAdminRequest } from '../models/ss-api/requests/update.admin.request';
import { GetSMTPByEmailResponse } from '../models/ss-api/responses/get.smtp.by.email.reponse';
import { UpdateSMTPByEmailResponse } from '../models/ss-api/responses/update.smtp.by.email.reponse';
import { GetSMTPByEmailRequest } from '../models/ss-api/requests/get.smtp.by.email.request';
import { UpdateSMTPByEmailRequest } from '../models/ss-api/requests/update.smtp.by.email.request';
import { AddEmailTemplateRequest } from '../models/ss-api/requests/add.email.template.request';
import { UpdateEmailTemplateRequest } from '../models/ss-api/requests/update.email.template.request';
import { DeleteDiscountItemRequest } from '../../app/models/ss-api/requests/delete.discount.item.request';
import { TransferChildToMemberRequest } from '../models/ss-api/requests/transfer.child.to.member.request';
import { ToChargeItemArray } from '../models/ss-api/responses/to.charge.item';
import { GetToChargeRequest } from '../models/ss-api/requests/get.to.charge.request';
import { GUIStatisticsItemArray, GUIStatisticsResult } from '../models/ss-api/responses/gui.statistics.item';
import { GUIStatisticsRequest } from '../models/ss-api/requests/gui.statistics.request';
import { AssetStatisticsItemArray } from '../models/ss-api/responses/Asset.statistics.item';
import { AssetStatisticsRequest } from '../models/ss-api/requests/Asset.statistics.request';
import { SearchHomePageProductBreakdownRequest } from '../models/ss-api/requests/search.home.page.product.breakdown';
import { SearchHomePageVersionBreakdownRequest } from '../models/ss-api/requests/search.home.page.version.breakdown';
import { NewSearchPresetRequest } from '../models/ss-api/requests/new.search.preset.request';
import { AdminSearchItemArray } from '../models/domain/admin.search.item';
import { MobileFilesItemArray } from '../models/domain/mobile.files.item';
import { GISOrderHistoryItemArray } from '../models/domain/gis.order.history.item';
import { BillingCreditsArray } from './../models/ss-api/responses/billing.credits.response';
import { BillingDiscountsArray } from './../models/ss-api/responses/billing.discount.response';
import { GatewayLogParseArray } from '../models/domain/gateway.log.parse';
import { GetGatewayLogParsesRequest } from '../models/ss-api/requests/get.gateway.log.parses.request';
import { GetMemberPasswordResetTokenRequest } from '../models/ss-api/requests/get.member.password.reset.token.request';
import { AbandonedCartItemArray } from '../models/ss-api/responses/abandoned.cart.item';
import { AutomationBillingHistoryItemArray } from '../models/ss-api/responses/automation.billing.history.item';
import { GetAutomationBillingHistoryRequest } from '../models/ss-api/requests/get.automation.billing.history.request';

import { ProductTotalHistoryItemArray } from '../models/ss-api/responses/product.total.history.item';
import { GetProductTotalHistoryRequest } from '../models/ss-api/requests/get.product.total.history.request';
import { CancelYardRequest } from '../models/ss-api/requests/cancel.yard.request';
import { ReactivateLicenseRequestv2 } from '../models/ss-api/requests/reactivate.license.request.v2';
import { ReactivateSimulationRequestv2 } from '../models/ss-api/requests/reactivate.simulation.request.v2';
import { LicenseReactivateSimulationResponsev2 } from '../models/ss-api/responses/license.reactivate.simulation.response.v2';
import { ForceChildToMemberRequest } from '../models/ss-api/requests/force.child.to.member.request';
import { AdminPreferenceItemArray, AdminPreferenceItem } from '../models/domain/admin.preference.item';
import { DeleteAdminPreferenceRequest } from '../models/ss-api/requests/delete.admin.preference.request';
import { GetAdminPreferenceByNameRequest } from '../models/ss-api/requests/get.admin.preference.by.name.request';
import { SaveAdminPreferenceRequest } from '../models/ss-api/requests/save.admin.preference.request';
import { SaveAdminPreferencesRequest } from '../models/ss-api/requests/save.admin.preferences.request';
import { VersionItemArray } from '../models/domain/version.item';
import { AddVersionWithPathRequest } from '../models/ss-api/requests/add.version.with.path.request';
import { AddUpdatePackageRequest } from '../models/ss-api/requests/add.update.package.request';
import { EditUpdatePackageRequest } from '../models/ss-api/requests/edit.update.package.request';
import { UpdateClientSettingsItemArray } from '../models/domain/update.client.settings.item';
import { InstructionItem } from '../models/domain/instruction.item';
import { LiveHubConnectionItemArray } from '../models/domain/livehub.connection.item';
import { GetLiveHubConnectionsRequest } from '../models/ss-api/requests/get.livehub.connections.request';
import { ResendEmailRequest } from '../models/ss-api/requests/resend.email.request';
import { UpdatePackageItemArray } from '../models/domain/update.package.item';
import { CheckUpdatePackageStatusResponse } from '../models/ss-api/responses/check.update.package.status.response';
import { InstructionSet } from '../models/ss-api/responses/instruction.set';
import { GetUpdatePackageInstructionsRequest } from '../models/ss-api/requests/get.update.package.instructions.request';
import { LicenseVideoCardItemArray } from '../models/domain/license.video.card.item';
import { GetLicenseVideoCardsRequest } from '../models/ss-api/requests/get.license.video.cards.request';
import { LicenseReportItemArray } from '../models/domain/license.report.item';
import { LicenseReportRequest } from '../models/ss-api/requests/license.report.request';
import { TOSDetectiveReportArray } from '../models/domain/tos.detective.report';
import { TOSDetectiveRequest } from '../models/ss-api/requests/tos.detective.request';
import { MemberTOSBasicsItemArray } from '../models/domain/member.tos.basics.item';
import { UpdateLicenseTOSDetectiveWhiteListDateRequest } from '../models/ss-api/requests/update.license.tos.detective.white.list.date';
import { ResetPasswordRequest } from '../models/ss-api/requests/reset.password.request';
import { FileUploadItemArray } from '../models/domain/file.upload.item';
import { UpdaterVersionItemArray } from '../models/domain/updater.version.item';
import { AddUpdaterVersionRequest } from '../models/ss-api/requests/add.updater.version.request';
import { UpdateUpdaterVersionRequest } from '../models/ss-api/requests/update.updater.version.request';
import { UpdateVersionWithPathRequest } from '../models/ss-api/requests/update.version.with.path.request';
import { TransformDesignerToMemberRequest } from '../models/ss-api/requests/transform.designer.to.member.request';
import { UpdateVersionForceGroupItemArray } from '../models/domain/update.version.force.group.item';
import { AddUpdateVersionForceGroupRequest } from '../models/ss-api/requests/add.update.version.force.group.request';
import { EditUpdateVersionForceGroupRequest } from '../models/ss-api/requests/edit.update.version.force.group.request';
import { ErrorItemArray } from '../models/domain/error.item';
import { GetErrorsRequest } from '../models/ss-api/requests/get.errors.request';
import { AddHubspotTicketRequest } from '../models/ss-api/requests/add.hubspot.ticket.request';
import { HoldStatisticsItemArray } from '../models/ss-api/responses/hold.statistics.item';
import { HoldStatsRequest } from '../models/ss-api/requests/hold.stats.request';
import { AdminPermissionTypes } from '../models/domain/admin.permission.item';
import { ErrorMessageItemArray } from '../models/domain/error.message.item';
import { UpdateErrorMessageRequest } from '../models/ss-api/requests/update.error.message.request';
import { DuplicateEmailTemplateRequest } from '../models/ss-api/requests/duplicate.email.template.request';
import { RemoveAdminAccessRequest } from '../models/ss-api/requests/remove.admin.access.request';
import { LicensePCItemArray } from '../models/domain/license.pc.item';
import { LicenseEditTransferDetailsRequest } from '../models/ss-api/requests/license.edit.transfer.details.request';
import { GlobalActivitiesRequest } from '../models/ss-api/requests/global.activities.request';
import { GlobalsActivitiesResponse } from '../models/ss-api/responses/global.activities.response';
import { GlobalAdminBrowseLogsRequest } from '../models/ss-api/requests/global.admin.browse.logs.request';
import { GetSalesRepresentativesRequest } from '@models/ss-api/requests/get.sales.representatives.request';
import { MemberVersionItemArray } from '@models/domain/member.version.item';
import { UpdateMemberUsageLogRequest } from '@models/ss-api/requests/update.member.usage.log.request';
import { StoreProjectsRequest } from '@models/ss-api/requests/store.projects.request';
import { GetBenchmarksResponse } from '@models/ss-api/responses/get.benchmarks.response';
import { GetBenchmarksRequest } from '@models/ss-api/requests/get.benchmarks.request';
import { UpdateVideoCardBenchmarkRequest } from '@models/ss-api/requests/update.video.card.benchmark.request';
import { UpdateCPUBenchmarkRequest } from '@models/ss-api/requests/update.cpu.benchmark.request';
import { AddVideoCardBenchmarkRequest } from '@models/ss-api/requests/add.video.card.benchmark.request';
import { AddCPUBenchmarkRequest } from '@models/ss-api/requests/add.cpu.benchmark.request';
import { PostponeGroupItemArray } from '@models/domain/postpone.group.item';
import { HardwareCheckItemArray } from '@models/domain/hardware.check.item';
import { AddVersionHardwareRequirementRequest } from '@models/ss-api/requests/add.version.hardware.requirement.request';
import { UpdateVersionHardwareRequirementRequest } from '@models/ss-api/requests/update.version.hardware.requirement.request';
import { UpdaterVersionForceGroupItemArray } from '@models/domain/updater.version.force.group.item';
import { AuthenticationLogItemArray } from '@models/domain/authentication.log.item';
import { BubbleItemArray } from '@models/domain/bubble.item';
import { BubbleGroupItemArray } from '@models/domain/bubble.group.item';
import { GetBubblesRequest } from '@models/ss-api/requests/get.bubbles.request';
import { AddBubbleRequest } from '@models/ss-api/requests/add.bubble.request';
import { EditBubbleRequest } from '@models/ss-api/requests/edit.bubble.request';
import { GoogleAuthenticatorQRResponse } from '@models/ss-api/responses/google.authenticator.qr.response';
import { LoginWithGoogleRequest } from '@models/ss-api/requests/loginwithgoogle.request';
import { GetAttendanceTrackingRequest } from '@models/ss-api/requests/get.attendance.tracking.request';
import { TrainingAttendanceArray } from '@models/domain/training.attendance';
import { InvoiceRefundRequest } from '@models/ss-api/requests/invoice.refund.request';
import { InvoiceRefundableStatusResponse } from '@models/ss-api/responses/invoice.refundable.status.response';
import { VideoCardBenchmarkItemArray } from '@models/domain/video.card.benchmark.item';
import { CPUBenchmarkItemArray } from '@models/domain/cpu.benchmark.item';
import { ProductSettings, ProductSettingsItemArray } from '@models/domain/product.settings';
import { GlobalMACWhitelistBasicArray } from '@models/ss-api/responses/global.mac.whitelist.basic';
import { GlobalPhoneWhitelistBasicArray } from '@models/ss-api/responses/global.phone.whitelist.basic';
import { GlobalAddressWhitelistBasicArray } from '@models/ss-api/responses/global.address.whitelist.basic';
import { AddGlobalAddressWhitelistRequest } from '@models/ss-api/requests/add.global.address.whitelist.request';
import { EditGlobalAddressWhitelistRequest } from '@models/ss-api/requests/edit.global.address.whitelist.request';
import { ConversationThreadMessageArray } from '@models/domain/conversation.thread.message';
import { UpdateSuccessArray } from '@models/livehub/update.success';
import { AddOnHistoryItemArray } from '@models/domain/addon.history.item';
import { TrialLicenseResponse } from '@models/ss-api/responses/trial.license.response';
import { TrialSetRequest } from '@models/ss-api/requests/trial.set';
import { ActivitySummaryResponse } from '@models/ss-api/responses/activity.summary.response';
import { ProofreadNoteResponse } from '@models/ss-api/responses/proofread.note.response';
import { ProofreadNoteRequest } from '@models/ss-api/requests/proofread.note.request';
import { GisAddonPurchaseRequest } from '@models/ss-api/requests/gis.addon.purchase.request';

class ssApiUrls {

    // activities
    static readonly Activity_Member_Activities: string = 'Activity/Activities/';
    static readonly Activity_Global_Activities: string = 'Activity/GlobalActivities/';

    // authentication
    static readonly Authentication_Login: string = 'Authentication/Login';
    static readonly Authentication_LoginWithGoogle: string = 'Authentication/LoginWithGoogle';
    static readonly Authentication_Logout: string = 'Authentication/Logout';
    static readonly Authentication_Logout_Forget_Device: string = 'Authentication/LogoutForgetDevice';
    static readonly Authentication_GoogleAuthenticatorQR: string = 'Authentication/GoogleAuthenticatorQR';
    static readonly Authentication_SendTwoFactorCode: string = 'Authentication/SendTwoFactorCode';
    static readonly Authentication_TwoFactorAuthentication: string = 'Authentication/TwoFactorAuthentication';
    static readonly Authentication_ChangePassword: string = 'Authentication/ChangePassword';
    static readonly Authentication_MemberNewLoginSession: string = 'Authentication/MemberNewLoginSession';
    static readonly Authentication_ResetPassword: string = 'Authentication/ResetPassword';

    // error messages
    static readonly ErrorMessages_GetErrorMessages: string = 'ErrorMessages/GetErrorMessages';
    static readonly ErrorMessages_UpdateErrorMessage: string = 'ErrorMessages/UpdateErrorMessage';

    // search
    static readonly Search_Full: string = 'Search/Full/';
    static readonly Search_Advanced: string = 'Search/Advanced/';
    static readonly Search_HomePageProductBreakdown: string = 'Search/HomePageProductBreakdown/';
    static readonly Search_HomePageVersionBreakdown: string = 'Search/HomePageVersionBreakdown/';
    static readonly Search_RepeatAdminSearch: string = 'Search/RepeatAdminSearch';
    static readonly Search_NewSearchPreset: string = 'Search/NewSearchPreset/';
    static readonly Search_DeleteAdminSearch: string = 'Search/DeleteAdminSearch/';
    static readonly Search_GetAdminSearchHistory: string = 'Search/GetAdminSearchHistory/';
    static readonly Search_GetAdminSearchPresets: string = 'Search/GetAdminSearchPresets/';

    // products
    static readonly Products_StructureStudiosProductsBasics: string = 'Product/StructureStudiosProductsBasics/';
    static readonly Products_StructureStudiosSettings: string = 'Product/StructureStudiosProductsSettings/';
    static readonly Products_SaveStructureStudiosSettings: string = 'Product/SaveProductSettings/';
    static readonly Products_GISProducts: string = 'Product/GISProducts/';
    static readonly Products_GISAddonProducts: string = 'Product/GISAddonProducts/';

    // history
    static readonly History_AdminBroseLogs: string = 'History/AdminBrowseLogs/';
    static readonly History_GlobalAdminBroseLogs: string = 'History/GlobalAdminBrowseLogs/';

    // licensing
    static readonly Licensing_Full: string = 'Licensing/Full/';
    static readonly Licensing_Edit: string = 'Licensing/Edit/';
    static readonly Licensing_Add: string = 'Licensing/Add/';
    static readonly Licensing_TransferLogs: string = 'Licensing/TransferLogs/';
    static readonly Licensing_AddOnHistory: string = 'Licensing/AddOnHistory/';
    static readonly Licensing_UpgradeLogs: string = 'Licensing/UpgradeLogs/';
    static readonly Licensing_LicenseTransferMember: string = 'Licensing/LicenseTransferMember/';
    static readonly Licensing_Reassign: string = 'Licensing/ReassignAndNotify/';
    static readonly Licensing_ReActivate: string = 'Licensing/ReActivate/';
    static readonly Licensing_ReActivatev2: string = 'Licensing/ReActivatev2/';
    static readonly Licensing_ReActivate_Simulation: string = 'Licensing/ReActivateSimulation/';
    static readonly Licensing_ReActivate_Simulationv2: string = 'Licensing/ReActivateSimulationv2/';
    static readonly Licensing_GetNewSubscriptionData: string = 'Licensing/GetNewSubscriptionData/';
    static readonly Licensing_ClearYardDeviceID: string = 'Licensing/ClearYardDeviceID/';
    static readonly Licensing_GetLicenseReport: string = 'Licensing/GetLicenseReport/';
    static readonly Licensing_FileUploads: string = 'Licensing/FileUploads/';
	static readonly Licensing_GetLicensePCs: string = 'Licensing/GetLicensePCs/';
    static readonly Licensing_DeleteLicensePC: string = 'Licensing/DeleteLicensePC/';
    static readonly Licensing_MakeLicensePCInactive: string = 'Licensing/MakeLicensePCInactive/';
    static readonly Licensing_MakeLicensePCUnavailable: string = 'Licensing/MakeLicensePCUnavailable/';
    static readonly Licensing_MakeLicensePCAvailable: string = 'Licensing/MakeLicensePCAvailable/';
	static readonly Licensing_EditTransferDetails: string = 'Licensing/EditTransferDetails/';

    // billing
    static readonly Billing_InvoicePaymentGatewayLogs: string = 'Billing/GetInvoicePaymentGatewayLogs/'
    static readonly Billing_Invoices: string = 'Billing/Invoices/'
    static readonly Billing_LicenseInvoices: string = 'Billing/LicenseInvoices/'
    static readonly Billing_GetCredit: string = 'Billing/GetCredit/';
    static readonly Billing_AddCredit: string = 'Billing/AddCredit/';
    static readonly Billing_AddDiscountItem: string = 'Billing/AddDiscountItem/';
    static readonly Billing_EditDiscountItem: string = 'Billing/EditDiscountItem/';
    static readonly Billing_DeleteDiscountItem: string = 'Billing/DeleteDiscountItem';
    static readonly Billing_DeleteCredit: string = 'Billing/DeleteCredit/';
    static readonly Billing_AddInvoice: string = 'Billing/AddInvoice/';
    static readonly Billing_EditInvoice: string = 'Billing/EditInvoice/';
    static readonly Billing_DeleteInvoice: string = 'Billing/DeleteInvoice/';
    static readonly Billing_AddTaxInvoice: string = 'Billing/AddTaxInvoice/';
    static readonly Billing_RemoveTaxInvoice: string = 'Billing/RemoveTaxInvoice/';
    static readonly Billing_DeleteAutomationBillingActive: string = 'Billing/DeleteAutomationBillingActive/';
    static readonly Billing_TryInvoicePayment: string = 'Billing/TryInvoicePayment/';
    static readonly Billing_GetGracePeriodReport: string = 'Billing/GetGracePeriodReport/';
    static readonly Billing_ProcessAutomationBilling: string = 'Billing/ProcessAutomationBilling/';
    static readonly Billing_GetToCharge: string = 'Billing/GetToCharge/';
    static readonly Billing_GetInvoicesByDate: string = 'Billing/GetInvoicesByDate/'
    static readonly Billing_GetMemberCredits: string = 'Billing/MemberCredits/'
    static readonly Billing_GetDiscounts: string = 'Billing/Discounts/'
    static readonly Billing_GetGatewayLogParses: string = 'Billing/GetGatewayLogParses/'
    static readonly Billing_GetAutomationBillingHistory: string = 'Billing/GetAutomationBillingHistory/'
	static readonly Billing_RetryAutomatedBilling: string = 'Billing/RetryAutomatedBilling/';
    static readonly Billing_GetInvoiceRefundableStatus: string ='Billing/GetRefundableStatus/';
    static readonly Billing_RefundInvoice: string ='Billing/RefundInvoice/';


    // pins
    static readonly Pins_Add: string = 'Pin/Add/';
    static readonly Pins_Get: string = 'Pin/Get/';
    static readonly Pins_ByAdminID: string = 'Pin/GetByAdminID/';
    static readonly Pins_Delete: string = 'Pin/Delete/';

    // email
    static readonly Email_TemplatesAndFrom = 'Email/TemplatesAndFrom/';
    static readonly Email_TemplateHTML = 'Email/TemplateHTML/';
    static readonly Email_SendEmail = 'Email/SendEmail/';
    static readonly Email_ResendEmail = 'Email/ResendEmail/';
    static readonly Email_GetEmailLogs = 'Email/GetEmailLogs/';
    static readonly Email_GetEmailLog = 'Email/GetEmailLog/';
    static readonly Email_AddEmailTemplate = 'Email/AddEmailTemplate/';
    static readonly Email_UpdateEmailTemplate = 'Email/UpdateEmailTemplate/';
    static readonly Email_DeleteEmailTemplate = 'Email/DeleteEmailTemplate/';
    static readonly Email_DuplicateEmailTemplate = 'Email/DuplicateEmailTemplate/';

    // notes
    static readonly Note_Edit: string = 'Note/Edit/';
    static readonly Note_Add: string = 'Note/Add/';
    static readonly Note_History: string = 'Note/History/';
    static readonly Note_NotesByType: string = 'Note/NotesByType/';
    static readonly Note_Get: string = 'Note/Get/';
    static readonly Note_All: string = 'Note/All/';
    static readonly Note_Family: string = 'Note/Family/';
    static readonly Note_Delete: string = 'Note/Delete/';
    static readonly Note_GetConversationThreadMessages: string = 'Note/GetConversationThreadMessages/';

    // member
    static readonly Member_Dashboard: string = 'Member/Dashboard/';
    static readonly Member_Full: string = 'Member/Full/';
    static readonly Member_Edit: string = 'Member/Edit/';
    static readonly Member_Delete: string = 'Member/Delete/';
    static readonly Member_Merge: string = 'Member/Merge/';
    static readonly Member_Add: string = 'Member/Add/';
    static readonly Member_UnlockLogin: string = 'Member/UnlockLogin/';
    static readonly Transfer_Child_To_Member: string = 'Member/TransferChildToMember/';
    static readonly Force_Child_To_Member: string = 'Member/ForceChildToMember/';
    static readonly Member_GetResetPasswordToken: string = 'Member/GetResetPasswordToken/';
    static readonly Member_TransformDesignerToMember: string = 'Member/TransformDesignerToMember/';
    static readonly Member_RequestReview: string = 'Member/RequestReview/';
    static readonly Member_AIProofreadNote: string = 'Member/AIProofreadNote/';
    static readonly Member_AISummarizeActivity: string = 'Member/AISummarizeActivity/';

    // tags
    static readonly Tag_AvailableTags: string = 'Tag/AvailableTags/';
    static readonly Tag_MemberEdit: string = 'Tag/MemberEdit/';

    // GIS
    static readonly GIS_MemberBundlePurchaseLog: string = 'GIS/MemberBundlePurchaseLogs/';
    static readonly GIS_MemberCreditsUsage: string = 'GIS/MemberUsageLogs/';
    static readonly GIS_SinglePurchaseRefund: string = 'GIS/SinglePurchaseRefund/';
    static readonly GIS_AddFreeBundleCredits: string = 'GIS/AddFreeBundleCredits/';
    static readonly GIS_OrderGISBundle: string = 'GIS/OrderGISBundle/';
    static readonly GIS_UpdateMemberUsageLog: string = 'GIS/UpdateMemberUsageLog/';
    static readonly GIS_OrderHistory: string = 'GIS/OrderHistory/';
    static readonly GIS_DeleteGIS: string = 'GIS/DeleteGIS/';
    static readonly GIS_SwapGISCreditType: string = 'GIS/SwapGISCreditType/';
    static readonly GIS_AddonPurchase: string = 'Product/GISAddonProductPurchase/'

    // Credit Card
    static readonly CCard_Member: string = 'CreditCard/Member/';
    static readonly CCard_MemberUsable: string = 'CreditCard/MemberUsable/';
    static readonly CCard_Add: string = 'CreditCard/Add/';
    static readonly CCard_SetAsDefault: string = 'CreditCard/SetAsDefault/';
    static readonly CCard_Delete: string = 'CreditCard/Delete/';
    static readonly CCard_Edit: string = 'CreditCard/Edit/';
    static readonly CCard_SetActive: string = 'CreditCard/SetActive/';
    static readonly CCard_Decrypt: string = 'CreditCard/Decrypt/';
    static readonly CCard_SetHidden: string = 'CreditCard/SetHidden/';

    // sales
    static readonly Sales_SalesRepresentatives: string = 'Sales/SalesRepresentatives/';
    static readonly Sales_GetAbandonedCarts: string = 'Sales/GetAbandonedCarts/';
    static readonly Sales_HideAbandonedCart: string = 'Sales/HideAbandonedCart/';


    // statistics
    static readonly Statistics_Sales: string = 'Statistics/Sales/';
    static readonly Statistics_ProductsTotals: string = 'Statistics/ProductsTotals/';
    static readonly Statistics_GUIStatistics: string = 'Statistics/GUIStatistics/';
    static readonly Statistics_AssetStatistics: string = 'Statistics/AssetStatistics/';
    static readonly Statistics_HoldStatistics: string = 'Statistics/HoldStatistics/';
    static readonly Statistics_MemberVersions: string = 'Statistics/MemberVersions/';
    static readonly Statistics_StoreProjects: string = 'Statistics/StoreProjects/';
    static readonly Statistics_GetExistingProjectLicenseKeys: string = 'Statistics/GetExistingProjectLicenseKeys/';

    // ticketing
    static readonly Tickets_Totals: string = 'Ticketing/Totals/';
    static readonly Tickets_WidgetsData: string = 'Ticketing/WidgetsData/';
    static readonly Tickets_MemberWidgetsData: string = 'Ticketing/MemberWidgetsData/';
    static readonly Ticket_ByID: string = 'Ticketing/TicketByID/';
    static readonly Ticket_ByNR: string = 'Ticketing/TicketByNr/';
    static readonly Ticket_AdminTotals: string = 'Ticketing/AdminTotals/';
    static readonly Ticket_Departments: string = 'Ticketing/AllTicketDepartments/';
    static readonly Ticket_Globals: string = 'Ticketing/TicketGlobals/';
    static readonly Ticket_Statuses: string = 'Ticketing/AllTicketStatuses/';
    static readonly Ticket_LogsByID: string = 'Ticketing/TicketLogs/';
    static readonly Ticket_AssignMember: string = 'Ticketing/AssignTicketToMember/';
    static readonly Ticket_AssignAdmin: string = 'Ticketing/AssignTicketToAdmin/';
    static readonly Ticket_UnAssignMember: string = 'Ticketing/TicketUnAssignMember/';
    static readonly Ticket_Update: string = 'Ticketing/UpdateTicket/';
    static readonly Ticket_AddReply: string = 'Ticketing/AddTicketReply/';
    static readonly Ticket_OpenNew: string = 'Ticketing/NewTicket/';


    // custom ticketing
    static readonly CustomTicket_OpenNew: string = 'CustomTicketing/AddTicket/'
    static readonly CustomTicket_Reply: string = 'CustomTicketing/AddReply/'
    static readonly CustomTicket_Edit: string = 'CustomTicketing/EditTicket/'
    static readonly CustomTicket_Delete: string = 'CustomTicketing/DeleteTicket/'
    static readonly CustomTicket_GetByStatus: string = 'CustomTicketing/TicketByStatus/'
    static readonly CustomTicket_GetByAdminAndStatus: string = 'CustomTicketing/AdminTicketByStatus/'
    static readonly CustomTicket_GetByMemberAndStatus: string = 'CustomTicketing/MemberTicketByStatus/'
    static readonly CustomTicket_GetByAdmin: string = 'CustomTicketing/AdminTicket/'
    static readonly CustomTicket_GetByMember: string = 'CustomTicketing/MemberTicket/'
    static readonly CustomTicket_GetMemberTotals: string = 'CustomTicketing/MemberTotals/'
    static readonly CustomTicket_GetAdminTotals: string = 'CustomTicketing/AdminTotals/'
    static readonly CustomTicket_GetAdminGlobals: string = 'CustomTicketing/AdminTicketsGlobals/'
    static readonly CustomTicket_GetMemberGlobals: string = 'CustomTicketing/MemberTicketsGlobals/'
    static readonly CustomTicket_GetUnclaimed: string = 'CustomTicketing/UnclaimedTickets/'
    static readonly CustomTicket_AssignMember: string = 'CustomTicketing/AssignMember/'
    static readonly CustomTicket_AssignAdmin: string = 'CustomTicketing/AssignAdmin/'
    static readonly CustomTicket_GetUnclaimedWidgets: string = 'CustomTicketing/UnclaimedWidgets/'
    static readonly CustomTicket_GetByID: string = 'CustomTicketing/TicketByID/'
    static readonly CustomTicket_SearchWidgets: string = 'CustomTicketing/SearchWidgets/'

   
    // hubspot ticketing
    static readonly HubspotTicket_GetByStatus: string = 'HubspotTicketing/TicketByStatus/'
    static readonly HubspotTicket_GetByAdminAndStatus: string = 'HubspotTicketing/AdminTicketByStatus/'
    static readonly HubspotTicket_GetByMemberAndStatus: string = 'HubspotTicketing/MemberTicketByStatus/'
    static readonly HubspotTicket_GetByAdmin: string = 'HubspotTicketing/AdminTicket/'
    static readonly HubspotTicket_GetByMember: string = 'HubspotTicketing/MemberTicket/'
    static readonly HubspotTicket_GetMemberTotals: string = 'HubspotTicketing/MemberTotals/'
    static readonly HubspotTicket_GetAdminTotals: string = 'HubspotTicketing/AdminTotals/'
    static readonly HubspotTicket_GetAdminGlobals: string = 'HubspotTicketing/AdminTicketsGlobals/'
    static readonly HubspotTicket_GetMemberGlobals: string = 'HubspotTicketing/MemberTicketsGlobals/'
    static readonly HubspotTicket_GetUnclaimed: string = 'HubspotTicketing/UnclaimedTickets/'
    static readonly HubspotTicket_AssignMember: string = 'HubspotTicketing/AssignMember/'
    static readonly HubspotTicket_AssignAdmin: string = 'HubspotTicketing/AssignAdmin/'
    static readonly HubspotTicket_GetUnclaimedWidgets: string = 'HubspotTicketing/UnclaimedWidgets/'
    static readonly HubspotTicket_GetByID: string = 'HubspotTicketing/TicketByID/'
    static readonly HubspotTicket_SearchWidgets: string = 'HubspotTicketing/SearchWidgets/' 
    static readonly HubspotTicket_AddHubspotTicket: string = 'HubspotTicketing/AddHubspotTicket/'

    // admin
    static readonly Admin_AllAdmins: string = 'Admin/AllAdmins/';
    static readonly Admin_AdminsByPermissionType: string = 'Admin/AdminsByPermissionType/';
    static readonly Admin_UpdateAdmin: string = 'Admin/UpdateAdmin/';
    static readonly Admin_GetSMTPByEmail: string = 'Admin/GetSMTPByEmail/';
    static readonly Admin_UpdateSMTPByEmail: string = 'Admin/UpdateSMTPByEmail/';
    static readonly Admin_TestSMTPSettings: string = 'Admin/TestSMTPSettings/';
    static readonly Admin_RemoveAdminAccess: string = 'Admin/RemoveAdminAccess/';

    static readonly Admin_GetAdminPreferences: string = 'Admin/GetAdminPreferences/';
    static readonly Admin_GetAdminPreferenceByName: string = 'Admin/GetAdminPreferenceByName/';
    static readonly Admin_DeleteAdminPreference: string = 'Admin/DeleteAdminPreference/';
    static readonly Admin_DeleteAllAdminPreferences: string = 'Admin/DeleteAllAdminPreferences/';
    static readonly Admin_SaveAdminPreference: string = 'Admin/SaveAdminPreference/';
    static readonly Admin_SaveAdminPreferences: string = 'Admin/SaveAdminPreferences/';


    // TOS
    static readonly TOS_WhitelistedIPs: string = 'TOS/WhitelistedIPs/'
    static readonly TOS_FlaggedIPs: string = 'TOS/FlaggedIPs/'
    static readonly TOS_Computers: string = 'TOS/ComputerNames/'
    static readonly TOS_FlaggedMacAddresses: string = 'TOS/FlaggedMacAddresses/'
    static readonly TOS_FlaggedComputers: string = 'TOS/FlaggedComputers/'
    static readonly TOS_AddIP: string = 'TOS/AddIP/'
    static readonly TOS_AddMac: string = 'TOS/AddMac/'
    static readonly TOS_AddComputerRequest: string = 'TOS/AddComputer/'
    static readonly TOS_ActivityLogsForMember: string = 'TOS/ActivityLogsByMember/'
    static readonly TOS_ActivityLogsByLicense: string = 'TOS/ActivityLogsByLicense/'
    static readonly TOS_ActivityLogs: string = 'TOS/ActivityLogs/'
    static readonly TOS_Members: string = 'TOS/TOSMembers/'
    static readonly TOS_EditIP: string = 'TOS/EditIP/'
    static readonly TOS_TOSDetective: string = 'TOS/TOSDetective/'
    static readonly TOS_TOSWhitelistComputer: string = 'TOS/WhitelistComputer/'
    static readonly TOS_TOSRemoveWhitelistComputer: string = 'TOS/RemoveWhitelistComputer/'
    static readonly TOS_UpdateLicenseTOSDetectiveWhiteListDate: string = 'Licensing/UpdateLicenseTOSDetectiveWhiteListDate/'
    static readonly TOS_GlobalMACWhitelists: string = 'TOS/GlobalMACWhitelists/'
    static readonly TOS_RemoveGlobalMACWhitelist: string = 'TOS/RemoveGlobalMACWhitelist/'
    static readonly TOS_AddGlobalMACWhitelist: string = 'TOS/AddGlobalMACWhitelist/'
    static readonly TOS_GlobalPhoneWhitelists: string = 'TOS/GlobalPhoneWhitelists/'
    static readonly TOS_RemoveGlobalPhoneWhitelist: string = 'TOS/RemoveGlobalPhoneWhitelist/'
    static readonly TOS_AddGlobalPhoneWhitelist: string = 'TOS/AddGlobalPhoneWhitelist/'
    static readonly TOS_GlobalAddressWhitelists: string = 'TOS/GlobalAddressWhitelists/'
    static readonly TOS_AddGlobalAddressWhitelist: string = 'TOS/AddGlobalAddressWhitelist/'
    static readonly TOS_EditGlobalAddressWhitelist: string = 'TOS/EditGlobalAddressWhitelist/'
    static readonly TOS_RemoveGlobalAddressWhitelist: string = 'TOS/RemoveGlobalAddressWhitelist/'

    // Audis
    static readonly Audit_LicenseAudits: string = 'Audit/LicenseAudits/';

    // Vendors
    static readonly Vendor_GetAll: string = 'Vendor/AllVendors/'
    static readonly Vendor_Edit: string = 'Vendor/EditVendor/'
    static readonly Vendor_Add: string = 'Vendor/AddVendor/'
    static readonly Vendor_EditItemIgnore: string = 'Vendor/EditVendorItemIgnore/'
    static readonly Vendor_Items: string = 'Vendor/VendorItems/'
    static readonly Vendor_Statistics: string = 'Vendor/VendorStatistics/'
    static readonly Vendor_SendEmailStatistics: string = 'Vendor/SendStatsEmail/'


    // search and get
    static readonly Authentication_Check_Cookie: string = 'Authentication/CheckAuthenticated/';
    static readonly Admin_TimeConditions: string = 'Admin/TimeConditions';
    static readonly Search_License_Basic: string = 'Search/BasicByLicenseKey/';
    static readonly Search_License_Full: string = 'Search/LicenseFull/';
    static readonly Search_Member_Tags: string = 'Search/MemberTags/';
    static readonly Billing_UpgradeSimulation: string = 'Support/UpgradeSimulation/';
    static readonly Management_Decrypt_CreditCard: string = 'Management/DecryptCreditCard/';
    static readonly Search_Member_Notes: string = 'Search/MemberNotes/';
    static readonly Ticket_Process_New: string = 'Support/ProcessNewTicketMessages/';

    // logs
    static readonly AdminLogs_AdminLogsByMemberID: string = 'Logs/AdminLogsByMemberID/';
    static readonly AdminLogs_LogsByMemberID: string = 'Logs/LogsByMemberID/';
    static readonly AdminLogs_AdminLogsByTicketID: string = 'Logs/AdminLogsByTicketID/';

    // training
    static readonly Training_GetTrainingClassByID: string = 'Training/GetTrainingClassByID/';
    static readonly Training_GetAdminTrainingCalendar: string = 'Training/GetAdminTrainingCalendar/';
    static readonly Training_AddTrainingClass: string = 'Training/AddTrainingClass/';
    static readonly Training_UpdateTrainingClass: string = 'Training/UpdateTrainingClass/';
    static readonly Training_RescheduleTrainingEvent: string = 'Training/RescheduleTrainingEvent/';
    static readonly Training_GetTrainingEventByID: string = 'Training/GetTrainingEventByID/';
    static readonly Training_GetAdminTrainingClasses: string = 'Training/GetAdminTrainingClasses/';
    static readonly Training_UpdateTrainingEventSubscriptionStatuses: string = 'Training/UpdateTrainingEventSubscriptionStatuses/';
    static readonly Training_AddTrainingEvent: string = 'Training/AddTrainingEvent/';
    static readonly Training_UpdateTrainingEvent: string = 'Training/UpdateTrainingEvent/';
    static readonly Training_DeleteTrainingEvent: string = 'Training/DeleteTrainingEvent/';
    static readonly Training_DeleteTrainingClass: string = 'Training/DeleteTrainingClass/';
    static readonly Training_GetTrainers: string = 'Training/GetTrainers/';
    static readonly Training_GetTrainingEventBasicsByClassID: string = 'Training/GetTrainingEventBasicsByClassID/';
    static readonly Training_SendTestEmailsForTrainingEvent: string = 'Training/SendTestEmailsForTrainingEvent/';
    static readonly Training_SendRealEmailsForTrainingEvent: string = 'Training/SendRealEmailsForTrainingEvent/';
    static readonly Training_CertificateGenerationForTrainingEventSubscription: string = 'Training/CertificateGenerationForTrainingEventSubscription/';
    static readonly Training_APSPCertificateGenerationForTrainingEventSubscription: string = 'Training/APSPCertificateGenerationForTrainingEventSubscription/';
    static readonly Training_CertificateGenerationForTrainingEvent: string = 'Training/CertificateGenerationForTrainingEvent/';
    static readonly Training_CertificateRemovalForTrainingEventSubscription: string = 'Training/CertificateRemovalForTrainingEventSubscription/';
    static readonly Training_SendEmailForTrainingEventSubscription: string = 'Training/SendEmailForTrainingEventSubscription/';
    static readonly Training_PreviewEmailsForTrainingEvent: string = 'Training/PreviewEmailsForTrainingEvent/';
    static readonly Training_GetTrainingHistoryForMember: string = 'Training/GetTrainingHistoryForMember/';
    static readonly Training_AddTrainingEventSubscription: string = 'Training/AddTrainingEventSubscription/';
    static readonly Training_UpdateTrainingEventSubscription: string = 'Training/UpdateTrainingEventSubscription/';
    static readonly Training_GetAttendanceTracking: string = 'Training/GetAttendanceTracking/';

    // YARD
    static readonly Yard_GetMobileFilesByLicenseID: string = 'Yard/GetMobileFilesByLicenseID/';
    static readonly Yard_GetMobileFilesByMemberID: string = 'Yard/GetMobileFilesByMemberID/';
    static readonly Yard_Cancel: string = 'Yard/Cancel/';

    // Updater
    static readonly Updater_GetActiveVersions: string = 'Updater/GetActiveVersions/';
    static readonly Updater_GetActiveV3Versions: string = 'Updater/GetActiveV3Versions/';
    static readonly Updater_AddVersionWithPath: string = 'Updater/AddVersionWithPath/';
    static readonly Updater_UpdateVersionWithPath: string = 'Updater/UpdateVersionWithPath/';
    static readonly Updater_AddUpdatePackage: string = 'Updater/AddUpdatePackage/';
    static readonly Updater_EditUpdatePackage: string = 'Updater/EditUpdatePackage/';
    static readonly Updater_FinalizeUpdatePackage: string = 'Updater/FinalizeUpdatePackage/';
    static readonly Updater_RestartUpdatePackage: string = 'Updater/RestartUpdatePackage/';
    static readonly Updater_DeleteUpdatePackage: string = 'Updater/DeleteUpdatePackage/';
    static readonly Updater_MakeUpdatePackageAvailable: string = 'Updater/MakeUpdatePackageAvailable/';
    static readonly Updater_GetUpdateClientSettings: string = 'Updater/GetUpdateClientSettings/';
    static readonly Updater_GetUpdatePackages: string = 'Updater/GetUpdatePackages/';
    static readonly Updater_GetUpdatePackageInstructions: string = 'Updater/GetUpdatePackageInstructions/';
    static readonly Updater_DeleteInstructionItem: string = 'Updater/DeleteInstructionItem/';
    static readonly Updater_CheckUpdatePackageStatus: string = 'Updater/CheckUpdatePackageStatus/';
    static readonly Updater_UpdateInstructionSortOrder: string = 'Updater/UpdateInstructionSortOrder/';
    static readonly Updater_GetUpdaterVersions: string = 'Updater/GetUpdaterVersions/';
    static readonly Updater_AddUpdaterVersion: string = 'Updater/AddUpdaterVersion/';
    static readonly Updater_UpdateUpdaterVersion: string = 'Updater/UpdateUpdaterVersion/';
    static readonly Updater_DeleteUpdaterVersion: string = 'Updater/DeleteUpdaterVersion/';
    static readonly Updater_GetUpdateVersionForceGroups: string = 'Updater/GetUpdateVersionForceGroups/';
    static readonly Updater_GetUpdateVersionForceGroupsV3: string = 'Updater/GetUpdateVersionForceGroupsV3/';
    static readonly Updater_GetUpdaterVersionForceGroups: string = 'Updater/GetUpdaterVersionForceGroups/';
    static readonly Updater_AddUpdateVersionForceGroup: string = 'Updater/AddUpdateVersionForceGroup/';
    static readonly Updater_EditUpdateVersionForceGroup: string = 'Updater/EditUpdateVersionForceGroup/';
    static readonly Updater_DeleteUpdateVersionForceGroup: string = 'Updater/DeleteUpdateVersionForceGroup/';
    static readonly Updater_GetBenchmarks: string = 'Updater/GetBenchmarks/';
    static readonly Updater_UpdateVideoCardBenchmark: string = 'Updater/UpdateVideoCardBenchmark/';
    static readonly Updater_UpdateCPUBenchmark: string = 'Updater/UpdateCPUBenchmark/';
    static readonly Updater_AddVideoCardBenchmark: string = 'Updater/AddVideoCardBenchmark/';
    static readonly Updater_AddCPUBenchmark: string = 'Updater/AddCPUBenchmark/';
    static readonly Updater_GetPostponeGroups: string = 'Updater/GetPostponeGroups/';
    static readonly Updater_GetHardwareChecks: string = 'Updater/GetHardwareChecks/';
    static readonly Updater_AddVersionHardwareRequirement: string = 'Updater/AddVersionHardwareRequirement/';
    static readonly Updater_UpdateVersionHardwareRequirement: string = 'Updater/UpdateVersionHardwareRequirement/';
    static readonly Updater_DeleteVersionHardwareRequirement: string = 'Updater/DeleteVersionHardwareRequirement/';

    // Updater - Add/Update Instructions
    static readonly Updater_AddInstructionRegistryAddKey: string = 'Updater/AddInstructionRegistryAddKey/';
    static readonly Updater_AddInstructionRegistryModifyKey: string = 'Updater/AddInstructionRegistryModifyKey/';
    static readonly Updater_AddInstructionRegistryDeleteKey: string = 'Updater/AddInstructionRegistryDeleteKey/';
    static readonly Updater_AddInstructionFileSystemRenameFile: string = 'Updater/AddInstructionFileSystemRenameFile/';
    static readonly Updater_AddInstructionFileSystemRenameDirectory: string = 'Updater/AddInstructionFileSystemRenameDirectory/';
    static readonly Updater_AddInstructionFileSystemDeleteFile: string = 'Updater/AddInstructionFileSystemDeleteFile/';
    static readonly Updater_AddInstructionFileSystemDeleteDirectory: string = 'Updater/AddInstructionFileSystemDeleteDirectory/';
    static readonly Updater_AddInstructionFileSystemCreateDirectory: string = 'Updater/AddInstructionFileSystemCreateDirectory/';
    static readonly Updater_AddInstructionFileSystemCopyFile: string = 'Updater/AddInstructionFileSystemCopyFile/';
    static readonly Updater_AddInstructionFileSystemMoveFile: string = 'Updater/AddInstructionFileSystemMoveFile/';
    static readonly Updater_AddInstructionFileSystemCopyDirectory: string = 'Updater/AddInstructionFileSystemCopyDirectory/';
    static readonly Updater_AddInstructionFileSystemMoveDirectory: string = 'Updater/AddInstructionFileSystemMoveDirectory/';
    static readonly Updater_AddInstructionRegisterComponent: string = 'Updater/AddInstructionRegisterComponent/';
    static readonly Updater_AddInstructionStartProcess: string = 'Updater/AddInstructionStartProcess/';
    static readonly Updater_AddInstructionStopProcess: string = 'Updater/AddInstructionStopProcess/';
    static readonly Updater_AddInstructionStartService: string = 'Updater/AddInstructionStartService/';
    static readonly Updater_AddInstructionStopService: string = 'Updater/AddInstructionStopService/';
    static readonly Updater_AddInstructionUnpackZip: string = 'Updater/AddInstructionUnpackZip/';
    static readonly Updater_AddInstructionDownloadFileFromUrl: string = 'Updater/AddInstructionDownloadFileFromUrl/';
    static readonly Updater_EditInstructionRegistryAddKey: string = 'Updater/EditInstructionRegistryAddKey/';
    static readonly Updater_EditInstructionRegistryModifyKey: string = 'Updater/EditInstructionRegistryModifyKey/';
    static readonly Updater_EditInstructionRegistryDeleteKey: string = 'Updater/EditInstructionRegistryDeleteKey/';
    static readonly Updater_EditInstructionFileSystemRenameFile: string = 'Updater/EditInstructionFileSystemRenameFile/';
    static readonly Updater_EditInstructionFileSystemRenameDirectory: string = 'Updater/EditInstructionFileSystemRenameDirectory/';
    static readonly Updater_EditInstructionFileSystemDeleteFile: string = 'Updater/EditInstructionFileSystemDeleteFile/';
    static readonly Updater_EditInstructionFileSystemDeleteDirectory: string = 'Updater/EditInstructionFileSystemDeleteDirectory/';
    static readonly Updater_EditInstructionFileSystemCreateDirectory: string = 'Updater/EditInstructionFileSystemCreateDirectory/';
    static readonly Updater_EditInstructionFileSystemCopyFile: string = 'Updater/EditInstructionFileSystemCopyFile/';
    static readonly Updater_EditInstructionFileSystemMoveFile: string = 'Updater/EditInstructionFileSystemMoveFile/';
    static readonly Updater_EditInstructionFileSystemCopyDirectory: string = 'Updater/EditInstructionFileSystemCopyDirectory/';
    static readonly Updater_EditInstructionFileSystemMoveDirectory: string = 'Updater/EditInstructionFileSystemMoveDirectory/';
    static readonly Updater_EditInstructionRegisterComponent: string = 'Updater/EditInstructionRegisterComponent/';
    static readonly Updater_EditInstructionStartProcess: string = 'Updater/EditInstructionStartProcess/';
    static readonly Updater_EditInstructionStopProcess: string = 'Updater/EditInstructionStopProcess/';
    static readonly Updater_EditInstructionStartService: string = 'Updater/EditInstructionStartService/';
    static readonly Updater_EditInstructionStopService: string = 'Updater/EditInstructionStopService/';
    static readonly Updater_EditInstructionUnpackZip: string = 'Updater/EditInstructionUnpackZip/';
    static readonly Updater_EditInstructionDownloadFileFromUrl: string = 'Updater/EditInstructionDownloadFileFromUrl/';

    // LiveHub
    static readonly LiveHub_GetConnections: string = 'LiveHub/GetConnections/';
    static readonly LiveHub_GetUpdateLogs: string = 'LiveHub/GetUpdateLogs/';

    // WAREHOUSE
    static readonly Warehouse_GetProductTotalHistory: string = 'Warehouse/GetProductTotalHistory/';
    static readonly Warehouse_GetErrors: string = 'Warehouse/GetErrors/';

    // VIDEO CARDS
    static readonly VideoCard_GetLicenseVideoCards: string = 'VideoCard/GetLicenseVideoCards/';

    // POOL STUDIO (ie Bubbles for now)
    static readonly PoolStudio_GetBubbles: string = 'PoolStudio/GetBubbles/';
    static readonly PoolStudio_GetBubbleGroups: string = 'PoolStudio/GetBubbleGroups/';
    static readonly PoolStudio_AddBubble: string = 'PoolStudio/AddBubble/';
    static readonly PoolStudio_UpdateBubble: string = 'PoolStudio/UpdateBubble/';
    static readonly PoolStudio_DeleteBubble: string = 'PoolStudio/DeleteBubble/';

    // TRIAL
    static readonly Trial_GetForLicense: string = 'Licensing/GetTrial/';
    static readonly Trial_Set: string = 'Licensing/SetTrial/';
}

@Injectable()
export class ssApiService extends CommHttpService {

    //private baseUrl: string = "https://api-ssdb2.structurestudios.com/API/";
    // private baseUrl: string = "http://localhost:58316/api/"
    private baseUrl: string = environment.baseUrl;
    private envName: string = environment.envName;

    // events
    public onActivities = new Subject<IBaseResponse<ActivityItemArray>>();
    public onGlobalActivities = new Subject<IBaseResponse<GlobalsActivitiesResponse>>();

    public onVendorGetAll = new Subject<IBaseResponse<VendorArray>>();
    public onVendorEdit = new Subject<IBaseResponse<string>>();
    public onVendorAdd = new Subject<IBaseResponse<string>>();
    public onVendorEditItemIgnore = new Subject<IBaseResponse<string>>();
    public onVendorItems = new Subject<IBaseResponse<VendorItemArray>>();
    public onVendorStatistics = new Subject<IBaseResponse<VendorStatisticsItemArray>>();
    public onVendorSendEmailStatistics = new Subject<IBaseResponse<string>>();

    public onErrorMessagesGetErrorMessages = new Subject<IBaseResponse<ErrorMessageItemArray>>();
    public onErrorMessagesUpdateErrorMessage = new Subject<IBaseResponse<string>>();

    public onMemberNewLoginSession = new Subject<IBaseResponse<string>>();

    public onGoogleAuthenticatorQR = new Subject<IBaseResponse<GoogleAuthenticatorQRResponse>>();

    public onTOSWhitelistedIPs = new Subject<IBaseResponse<TOSIPArray>>();
    public onTOSFlaggedIPs = new Subject<IBaseResponse<TOSIPArray>>();
    public onTOSMemberWhitelistedIPs = new Subject<IBaseResponse<TOSIPArray>>();
    public onTOSMemberFlaggedIPs = new Subject<IBaseResponse<TOSIPArray>>();
    public onTOSFlaggedMacAddresses = new Subject<IBaseResponse<TOSMacArray>>();
    public onTOSFlaggedComputers = new Subject<IBaseResponse<TOSComputerArray>>();
    public onTOSAddIP = new Subject<IBaseResponse<string>>();
    public onTOSAddMac = new Subject<IBaseResponse<string>>();
    public onTOSAddComputerRequest = new Subject<IBaseResponse<string>>();
    public onTOSActivityLogs = new Subject<IBaseResponse<TOSActivityLogResponseArray>>();
    public onTOSActivityLogsByMember = new Subject<IBaseResponse<TOSActivityLogResponseArray>>();
    public onTOSActivityLogsByLicense = new Subject<IBaseResponse<TOSActivityLogResponseArray>>();
    public onTOSMembers = new Subject<IBaseResponse<MemberTOSBasicsItemArray>>();
    public onTOSEditIP = new Subject<IBaseResponse<string>>();
    public onTOSTOSDetective = new Subject<IBaseResponse<TOSDetectiveReportArray>>();
    public onTOSUpdateLicenseTOSDetectiveWhiteListDate = new Subject<IBaseResponse<string>>();
    public onTOSGlobalMACWhitelists = new Subject<IBaseResponse<GlobalMACWhitelistBasicArray>>();
    public onTOSRemoveGlobalMACWhitelist = new Subject<IBaseResponse<string>>();
    public onTOSAddGlobalMACWhitelist = new Subject<IBaseResponse<string>>();
    public onTOSGlobalPhoneWhitelists = new Subject<IBaseResponse<GlobalPhoneWhitelistBasicArray>>();
    public onTOSRemoveGlobalPhoneWhitelist = new Subject<IBaseResponse<string>>();
    public onTOSAddGlobalPhoneWhitelist = new Subject<IBaseResponse<string>>();
    public onTOSGlobalAddressWhitelists = new Subject<IBaseResponse<GlobalAddressWhitelistBasicArray>>();
    public onTOSAddGlobalAddressWhitelist = new Subject<IBaseResponse<string>>();
    public onTOSEditGlobalAddressWhitelist = new Subject<IBaseResponse<string>>();
    public onTOSRemoveGlobalAddressWhitelist = new Subject<IBaseResponse<string>>();

    public onAuditLicenseAudits = new Subject<IBaseResponse<AuditLogItemArray>>();


    public onTicketsTotals = new Subject<IBaseResponse<TicketsCountItemArray>>();
    public onTicketsWidgetsData = new Subject<IBaseResponse<TicketWidgetItemArray>>();
    public onTicketsMemberWidgetsData = new Subject<IBaseResponse<TicketWidgetItemArray>>();
    public onTicketByID = new Subject<IBaseResponse<TicketItem>>();
    public onTicketByNR = new Subject<IBaseResponse<TicketItem>>();
    public onTicketAdminTotals = new Subject<IBaseResponse<TicketTotals>>();
    public onTicketDepartments = new Subject<IBaseResponse<TicketDepartmentArray>>();
    public onTicketGlobals = new Subject<IBaseResponse<TicketGlobals>>();
    public onTicketStatuses = new Subject<IBaseResponse<TicketStatusArray>>();
    public onTicketLogByID = new Subject<IBaseResponse<TicketLogItemArray>>();
    public onTicketAssignMember = new Subject<IBaseResponse<StringResponse>>();
    public onTicketUnAssignMember = new Subject<IBaseResponse<StringResponse>>();
    public onTicketAssignAdmin = new Subject<IBaseResponse<StringResponse>>();
    public onTicketUpdate = new Subject<IBaseResponse<String>>();
    public onTicketAddReply = new Subject<IBaseResponse<StringResponse>>();
    public onTicketOpenNew = new Subject<IBaseResponse<TicketItem>>();

    public onCustomTicketOpenNew = new Subject<IBaseResponse<CustomTicketItem>>();
    public onCustomTicketReply = new Subject<IBaseResponse<CustomTicketItem>>();
    public onCustomTicketEdit = new Subject<IBaseResponse<String>>();
    public onCustomTicketDelete = new Subject<IBaseResponse<String>>();
    public onCustomTicketsGetByStatus = new Subject<IBaseResponse<CustomTicketItemArray>>();
    public onCustomTicketsGetByAdminAndStatus = new Subject<IBaseResponse<CustomTicketItemArray>>();
    public onCustomTicketsGetByMemberAndStatus = new Subject<IBaseResponse<CustomTicketItemArray>>();
    public onCustomTicketsGetByAdmin = new Subject<IBaseResponse<CustomTicketItemArray>>();
    public onCustomTicketsGetByMember = new Subject<IBaseResponse<CustomTicketItemArray>>();
    public onCustomTicketsGetAdminTotals = new Subject<IBaseResponse<CustomTicketsAdminTotalsArray>>();
    public onCustomTicketsGetMemberTotals = new Subject<IBaseResponse<CustomTicketsMemberTotalsArray>>();
    public onCustomTicketsGetAdminGlobals = new Subject<IBaseResponse<CustomTicketsAdminGlobalsResponse>>();
    public onCustomTicketsGetMemberGlobals = new Subject<IBaseResponse<CustomTicketsMemberGlobalsResponse>>();
    public onCustomTicketsGetUnclaimed = new Subject<IBaseResponse<CustomTicketItemArray>>();
    public onCustomTicketsAssignMember = new Subject<IBaseResponse<CustomTicketAssignResponse>>();
    public onCustomTicketsAssignAdmin = new Subject<IBaseResponse<CustomTicketAssignResponse>>();
    public onCustomTicketsGetUnclaimedWidgets = new Subject<IBaseResponse<CustomTicketWidgetItemArray>>();
    public onCustomTicketsGetByID = new Subject<IBaseResponse<CustomTicketWidgetItem>>();
    public onCustomTicketsSearchWidgets = new Subject<IBaseResponse<CustomTicketWidgetItemArray>>();
    public onCustomTicketsReload = new Subject();

    public onHubspotTicketsGetByStatus = new Subject<IBaseResponse<HubspotTicketItemArray>>();
    public onHubspotTicketsGetByAdminAndStatus = new Subject<IBaseResponse<HubspotTicketItemArray>>();
    public onHubspotTicketsGetByMemberAndStatus = new Subject<IBaseResponse<HubspotTicketItemArray>>();
    public onHubspotTicketsGetByAdmin = new Subject<IBaseResponse<HubspotTicketItemArray>>();
    public onHubspotTicketsGetByMember = new Subject<IBaseResponse<HubspotTicketItemArray>>();
    public onHubspotTicketsGetAdminTotals = new Subject<IBaseResponse<HubspotTicketsAdminTotalsArray>>();
    public onHubspotTicketsGetMemberTotals = new Subject<IBaseResponse<HubspotTicketsMemberTotalsArray>>();
    public onHubspotTicketsGetAdminGlobals = new Subject<IBaseResponse<HubspotTicketsAdminGlobalsResponse>>();
    public onHubspotTicketsGetMemberGlobals = new Subject<IBaseResponse<HubspotTicketsMemberGlobalsResponse>>();
    public onHubspotTicketsGetUnclaimed = new Subject<IBaseResponse<HubspotTicketItemArray>>();
    public onHubspotTicketsGetUnclaimedWidgets = new Subject<IBaseResponse<HubspotTicketWidgetItemArray>>();
    public onHubspotTicketsGetByID = new Subject<IBaseResponse<HubspotTicketWidgetItem>>();
    public onHubspotTicketsSearchWidgets = new Subject<IBaseResponse<HubspotTicketWidgetItemArray>>();
    public onHubspotTicketsReload = new Subject();
    public onHubspotTicketsAddHubspotTicket = new Subject<IBaseResponse<number>>();

    public onLoginResponse = new Subject<IBaseResponse<LoginResponse>>();
    public onLoginWithGoogleResponse = new Subject<IBaseResponse<LoginResponse>>();
    public onLogoutResponse = new Subject<IBaseResponse<string>>();
    public onSendTwoFactorCode = new Subject<IBaseResponse<string>>();
    public onTwoFactorAuthentication = new Subject<IBaseResponse<LoginResponse>>();
    public onChangePassword = new Subject<IBaseResponse<string>>();
    public onResetPassword = new Subject<IBaseResponse<string>>();

    public onStatisticsSales = new Subject<IBaseResponse<SalesStatisticsResult>>();
    public onStatisticsProductsTotals = new Subject<IBaseResponse<ProductTotalsItemArray>>();
    public onStatisticsGUIStatistics = new Subject<IBaseResponse<GUIStatisticsResult>>();
    public onStatisticsAssetStatistics = new Subject<IBaseResponse<AssetStatisticsItemArray>>();
    public onStatisticsHoldStatistics = new Subject<IBaseResponse<HoldStatisticsItemArray>>();
    public onStatisticsMemberVersions = new Subject<IBaseResponse<MemberVersionItemArray>>();
    public onStatisticsStoreProjects = new Subject<IBaseResponse<string>>();
    public onStatisticsGetExistingProjectLicenseKeys = new Subject<IBaseResponse<string[]>>();

    public onHistoryAdminBrowseLogs = new Subject<IBaseResponse<AdminBrowseLogItemArray>>();
    public onHistoryGlobalAdminBrowseLogs = new Subject<IBaseResponse<AdminBrowseLogItemArray>>();

    public onSalesRepresentatives = new Subject<IBaseResponse<SalesRepresentativeArray>>();
    public onSalesGetAbandonedCarts = new Subject<IBaseResponse<AbandonedCartItemArray>>();
    public onSalesHideAbandonedCart = new Subject<IBaseResponse<string>>();

    public onProductStructureStudiosProductsBasics = new Subject<IBaseResponse<ProductItemBasicsArray>>();
    public onProductStructureStudiosProductsSettings = new Subject<IBaseResponse<ProductSettingsItemArray>>();
    public onSaveStructureStudiosProductSettings = new Subject<IBaseResponse<string>>();
    public onProductGISProducts = new Subject<IBaseResponse<GISProductItemArray>>();
    public onProductGISAddonProducts = new Subject<IBaseResponse<any>>();

    public onSearchFull = new Subject<IBaseResponse<FullSearchResponse>>();
    public onSearchAdvanced = new Subject<IBaseResponse<GlobalSearchResults<AdvancedSearchResultMemberItemArray>>>();
    public onSearchHomePageProductBreakdown = new Subject<IBaseResponse<GlobalSearchResults<AdvancedSearchResultMemberItemArray>>>();
    public onSearchRepeatAdminSearch = new Subject<IBaseResponse<GlobalSearchResults<AdvancedSearchResultMemberItemArray>>>();
    public onSearchNewSearchPreset = new Subject<IBaseResponse<number>>();
    public onDeleteAdminSearch = new Subject<IBaseResponse<string>>();
    public onSearchGetAdminSearchHistory = new Subject<IBaseResponse<AdminSearchItemArray>>();
    public onSearchGetAdminSearchPresets = new Subject<IBaseResponse<AdminSearchItemArray>>();

    public onGISSinglePurchaseRefund = new Subject<IBaseResponse<string>>();
    public onGISAddFreeBundleCredits = new Subject<IBaseResponse<string>>();
    public onGISOrderGIsBundle = new Subject<IBaseResponse<string>>();
    public onGISAddonPurchase = new Subject<IBaseResponse<string>>();
    public onGISUpdateMemberUsageLog = new Subject<IBaseResponse<string>>();
    public onGISOrderHistory = new Subject<IBaseResponse<GISOrderHistoryItemArray>>();
    public onGISDeleteGIS = new Subject<IBaseResponse<string>>();
    public onGISSwapGISCreditType = new Subject<IBaseResponse<string>>();

    public onMemberDelete = new Subject<IBaseResponse<string>>();
    public onMemberMerge = new Subject<IBaseResponse<string>>();
    public onMemberTransformDesignerToMember = new Subject<IBaseResponse<string>>();

    public onCreditCardAdd = new Subject<IBaseResponse<string>>();
    public onCreditCardSetAsDefault = new Subject<IBaseResponse<string>>();
    public onCreditCardDelete = new Subject<IBaseResponse<string>>();
    public onCreditCardEdit = new Subject<IBaseResponse<string>>();
    public onCreditCardSetActive = new Subject<IBaseResponse<string>>();
    public onCreditCardDecrypt = new Subject<IBaseResponse<string>>();
    public onCreditCardSetHidden = new Subject<IBaseResponse<string>>();

    public onLicensingFull = new Subject<IBaseResponse<LicenseFullResponse>>();
    public onLicensingAdd = new Subject<IBaseResponse<string>>();
	public onLicenseEdit = new Subject<IBaseResponse<String>>();
	public onLicenseEditTransferDetails = new Subject<IBaseResponse<String>>();
    public onLicensingLicenseTransferMember = new Subject<IBaseResponse<string>>();
    public onLicenseReassignAndNotify = new Subject<IBaseResponse<string>>();
    public onLicenseReActivate = new Subject<IBaseResponse<string>>();
    public onLicenseReActivatev2 = new Subject<IBaseResponse<string>>();
    public onLicenseReActivateSimulation = new Subject<IBaseResponse<LicenseReactivateSimulationResponse>>();
    public onLicenseReActivateSimulationv2 = new Subject<IBaseResponse<LicenseReactivateSimulationResponse>>();
    public onLicenseGetNewSubscriptionData = new Subject<IBaseResponse<NewSubscriptionDataResponse>>();
    public onLicenseClearYardDeviceID = new Subject<IBaseResponse<string>>();
    public onLicenseGetLicenseReport = new Subject<IBaseResponse<LicenseReportItemArray>>();
    public onLicenseFileUploads = new Subject<IBaseResponse<FileUploadItemArray>>();

	public onLicenseGetLicensePCs = new Subject<IBaseResponse<LicensePCItemArray>>();
    public onLicenseDeleteLicensePC = new Subject<IBaseResponse<string>>();
    public onLicenseMakeLicensePCInactive = new Subject<IBaseResponse<string>>();
    public onLicenseMakeLicensePCUnavailable = new Subject<IBaseResponse<string>>();
    public onLicenseMakeLicensePCAvailable = new Subject<IBaseResponse<string>>();
	
    public onInvoicePaymentGatewayLogs = new Subject<IBaseResponse<InvoicePaymentGatewayLogArray>>();
    public onBillingInvoices = new Subject<IBaseResponse<InvoiceArray>>();
    public onBillingLicenseInvoices = new Subject<IBaseResponse<InvoiceArray>>();
    public onBillingGetCredit = new Subject<IBaseResponse<CreditItemArray>>();
    public onBillingAddCredit = new Subject<IBaseResponse<string>>();
    public onBillingAddDiscountItem = new Subject<IBaseResponse<string>>();
    public onBillingEditDiscountItem = new Subject<IBaseResponse<string>>();
    public onBillingDeleteDiscountItem = new Subject<IBaseResponse<string>>();
    public onBillingDeleteCredit = new Subject<IBaseResponse<string>>();
    public onBillingAddInvoice = new Subject<IBaseResponse<string>>();
    public onBillingEditInvoice = new Subject<IBaseResponse<string>>();
    public onBillingDeleteInvoice = new Subject<IBaseResponse<string>>();
    public onBillingAddTaxInvoice = new Subject<IBaseResponse<string>>();
    public onBillingRemoveTaxInvoice = new Subject<IBaseResponse<string>>();
    public onBillingDeleteAutomationBillingActive = new Subject<IBaseResponse<string>>();
    public onBillingTryInvoicePayment = new Subject<IBaseResponse<string>>();
    public onBillingGetGracePeriodReport = new Subject<IBaseResponse<GracePeriodReportItemArray>>();
    public onProcessAutomationBilling = new Subject<IBaseResponse<boolean>>();
    public onBillingGetToCharge = new Subject<IBaseResponse<ToChargeItemArray>>();
    public onBillingGetInvoicesByDate = new Subject<IBaseResponse<InvoiceArray>>();
    public onBillingGetMemberCredits = new Subject<IBaseResponse<BillingCreditsArray>>();
    public onBillingGetDiscounts = new Subject<IBaseResponse<BillingDiscountsArray>>();
    public onBillingGetGatewayLogParses = new Subject<IBaseResponse<GatewayLogParseArray>>();
    public onBillingGetAutomationBillingHistory = new Subject<IBaseResponse<AutomationBillingHistoryItemArray>>();
	public onBillingRetryAutomatedBilling = new Subject<IBaseResponse<AutomationBillingHistoryItemArray>>();
    public onBillingInvoiceRefund = new Subject<IBaseResponse<string>>();
    public onBillingInvoiceRefundableStatus = new Subject<IBaseResponse<InvoiceRefundableStatusResponse>>();


    public onGetPins = new Subject<IBaseResponse<PinArray>>();
    public onPinDelete = new Subject<IBaseResponse<Number>>();
    public onPinAdd = new Subject<IBaseResponse<PinItem>>();
    public onGetPin = new Subject<IBaseResponse<PinItem>>();

    public onNoteEdit = new Subject<IBaseResponse<String>>();
    public onNoteAdd = new Subject<IBaseResponse<String>>();
    public onGetNoteHistory = new Subject<IBaseResponse<NoteArray>>();
    public onGetNotesByType = new Subject<IBaseResponse<NoteArray>>();
    public onGetNote = new Subject<IBaseResponse<Note>>();
    public onNoteDelete = new Subject<IBaseResponse<String>>();
    public onGetConversationThreadMessages = new Subject<IBaseResponse<ConversationThreadMessageArray>>();

    public onMemberAdd = new Subject<IBaseResponse<string>>();
    public onMemberDashboard = new Subject<IBaseResponse<MemberDashboard>>();
    public onMemberFull = new Subject<IBaseResponse<Member>>();
    public onMemberGISCreditsUsage = new Subject<IBaseResponse<GISUsageLogArray>>();
    public onMemberGISBundleLog = new Subject<IBaseResponse<GISBundleLogArray>>();
    public onMemberEdit = new Subject<IBaseResponse<String>>();
    public onMemberTagsEdit = new Subject<IBaseResponse<StringResponse>>();
    public onMemberUnlockLogin = new Subject<IBaseResponse<string>>();
    public onTransferChildToMember = new Subject<IBaseResponse<string>>();
    public onForceChildToMember = new Subject<IBaseResponse<string>>();
    public onGetResetPasswordToken = new Subject<IBaseResponse<string>>();
    public onMemberRequestReview = new Subject<IBaseResponse<string>>();
    public onMemberSummarizeActivity = new Subject<IBaseResponse<ActivitySummaryResponse>>();
    public onMemberProofreadNote = new Subject<IBaseResponse<ProofreadNoteResponse>>();

    public onEmailTemplatesAndFrom = new Subject<IBaseResponse<TemplatesAndFromResponse>>();
    public onEmailTemplateHTML = new Subject<IBaseResponse<EmailTemplateFullItem>>();
    public onSendEmail = new Subject<IBaseResponse<string>>();
    public onResendEmail = new Subject<IBaseResponse<string>>();
    public onEmailGetEmailLogs = new Subject<IBaseResponse<EmailLogItemBasicArray>>();
    public onEmailGetEmailLog = new Subject<IBaseResponse<EmailLogItemBasic>>();
    public onEmailAddEmailTemplate = new Subject<IBaseResponse<number>>();
	public onEmailUpdateEmailTemplate = new Subject<IBaseResponse<number>>();
	public onEmailDuplicateEmailTemplate = new Subject<IBaseResponse<number>>();
    public onEmailDeleteEmailTemplate = new Subject<IBaseResponse<string>>();


    public onSearchAllNotesForMember = new Subject<IBaseResponse<NotesAll>>();
    public onSearchAllNotesForFamily = new Subject<IBaseResponse<NotesAll>>();


    public onSearchTagsAllTypes = new Subject<IBaseResponse<TagArray>>();


    public onAdminAllAdmins = new Subject<IBaseResponse<AdminItemArray>>();
    public onAdminAdminsByPermissionType = new Subject<IBaseResponse<AdminItemArray>>();
    public onUpdateAdmin = new Subject<IBaseResponse<number>>();
    public onGetSMTPByEmail = new Subject<IBaseResponse<GetSMTPByEmailResponse>>();
    public onUpdateSMTPByEmail = new Subject<IBaseResponse<UpdateSMTPByEmailResponse>>();
    public onTestSMTPSettings = new Subject<IBaseResponse<string>>();
    public onRemoveAdminAccess = new Subject<IBaseResponse<number>>();

    public onAdminGetAdminPreferences = new Subject<IBaseResponse<AdminPreferenceItemArray>>();
    public onAdminGetAdminPreferenceByName = new Subject<IBaseResponse<AdminPreferenceItem>>();
    public onAdminDeleteAdminPreference = new Subject<IBaseResponse<string>>();
    public onAdminDeleteAllAdminPreferences = new Subject<IBaseResponse<string>>();
    public onAdminSaveAdminPreference = new Subject<IBaseResponse<string>>();
    public onAdminSaveAdminPreferences = new Subject<IBaseResponse<string>>();


    public onAdminTimeConditions = new Subject<IBaseResponse<TimeGroupArray>>();
    public onSearchLicenseBasic = new Subject<IBaseResponse<LicenseSearchResponseArray>>();
    public onSearchLicenseFull = new Subject<IBaseResponse<LicenseFullResponse>>();
    public onSearchTransferLogs = new Subject<IBaseResponse<LicenseTransferLogArray>>();
    public onAddOnHistory = new Subject<IBaseResponse<AddOnHistoryItemArray>>();
    public onAPIURLSearchUpgradeLogs = new Subject<IBaseResponse<LicenseUpgradeLogArray>>();
    public onSearchCCards = new Subject<IBaseResponse<CreditCardArray>>();
    public onSearchUsableCCards = new Subject<IBaseResponse<CreditCardArray>>();
    public onSearchMemberTags = new Subject<IBaseResponse<TagArray>>();
    public onBillingUpgradeSimulation = new Subject<IBaseResponse<UpgradeSimulation>>();
    public onManagementDecryptCreditCard = new Subject<IBaseResponse<StringResponse>>();
    public onSearchMemberNotes = new Subject<IBaseResponse<NoteArray>>();
    public onAuthenticationCheckCookie = new Subject<IBaseResponse<LoginResponse>>();

    public onTicketProcessNew = new Subject<IBaseResponse<string>>();

    public onAdminList = new Subject<AdminItemArray>();

    public onLogsAdminLogsByMemberID = new Subject<IBaseResponse<AdminLogItemArray>>();
    public onLogsByMemberID = new Subject<IBaseResponse<LogsResponse>>();
    public onLogsAdminLogsByTicketID = new Subject<IBaseResponse<AdminLogItemArray>>();

    public onTrainingClassByID = new Subject<IBaseResponse<TrainingClass>>();
    public onGetAdminTrainingCalendar = new Subject<IBaseResponse<AdminTrainingCalendarResponse>>();
    public onAddTrainingClass = new Subject<IBaseResponse<Number>>();
    public onUpdateTrainingClass = new Subject<IBaseResponse<Number>>();
    public onRescheduleTrainingEvent = new Subject<IBaseResponse<RescheduleTrainingEventResponse>>();
    public onTrainingEventByID = new Subject<IBaseResponse<TrainingEvent>>();
    public onGetAdminTrainingClasses = new Subject<IBaseResponse<TrainingClassArray>>();
    public onUpdateTrainingEventSubscriptionStatuses = new Subject<IBaseResponse<UpdateTrainingEventSubscriptionStatusesResponse>>();
    public onAddTrainingEvent = new Subject<IBaseResponse<AddTrainingEventResponse>>();
    public onUpdateTrainingEvent = new Subject<IBaseResponse<UpdateTrainingEventResponse>>();
    public onDeleteTrainingEvent = new Subject<IBaseResponse<DeleteTrainingEventResponse>>();
    public onDeleteTrainingClass = new Subject<IBaseResponse<string>>();
    public onGetTrainers = new Subject<IBaseResponse<AdminItemArray>>();
    public onGetTrainingEventBasicsByClassID = new Subject<IBaseResponse<TrainingEventArray>>();
    public onGetAttendanceTracking = new Subject<IBaseResponse<TrainingAttendanceArray>>();
    public onSendTestEmailsForTrainingEvent = new Subject<IBaseResponse<string>>();
    public onSendRealEmailsForTrainingEvent = new Subject<IBaseResponse<string>>();
    public onCertificateGenerationForTrainingEventSubscription = new Subject<IBaseResponse<TrainingEventSubscriptionCertificateResponse>>();
    public onCertificateGenerationForTrainingEvent = new Subject<IBaseResponse<string>>();
    public onCertificateRemovalForTrainingEventSubscription = new Subject<IBaseResponse<string>>();
    public onSendEmailForTrainingEventSubscription = new Subject<IBaseResponse<string>>();
    public onPreviewEmailsForTrainingEvent = new Subject<IBaseResponse<TrainingPreviewEmailsResponse>>();
    public onGetTrainingHistoryForMember = new Subject<IBaseResponse<TrainingHistoryResponseArray>>();
    public onAddTrainingEventSubscription = new Subject<IBaseResponse<AddTrainingEventSubscriptionResponse>>();
    public onUpdateTrainingEventSubscription = new Subject<IBaseResponse<UpdateTrainingEventSubscriptionResponse>>();
    public onAPSPCertificateGenerationForTrainingEventSubscription = new Subject<IBaseResponse<TrainingEventSubscriptionCertificateResponse>>();

    public onGetMobileFilesByLicenseID = new Subject<IBaseResponse<MobileFilesItemArray>>();
    public onGetMobileFilesByMemberID = new Subject<IBaseResponse<MobileFilesItemArray>>();

    public onGetProductTotalHistory = new Subject<IBaseResponse<ProductTotalHistoryItemArray>>();
    public onGetWarehouseErrors = new Subject<IBaseResponse<ErrorItemArray>>();

    public onYARDCancel = new Subject<IBaseResponse<string>>();

    public onUpdaterAddUpdaterVersion = new Subject<IBaseResponse<number>>();
    public onUpdaterUpdateUpdaterVersion = new Subject<IBaseResponse<number>>();
    public onUpdaterGetActiveVersions = new Subject<IBaseResponse<VersionItemArray>>();
    public onUpdaterGetActiveV3Versions = new Subject<IBaseResponse<VersionItemArray>>();
    public onUpdaterAddVersionWithPath = new Subject<IBaseResponse<number>>();
    public onUpdaterUpdateVersionWithPath = new Subject<IBaseResponse<number>>();
    public onUpdaterAddUpdatePackage = new Subject<IBaseResponse<number>>();
    public onUpdaterEditUpdatePackage = new Subject<IBaseResponse<number>>();
    public onUpdaterFinalizeUpdatePackage = new Subject<IBaseResponse<string>>();
    public onUpdaterRestartUpdatePackage = new Subject<IBaseResponse<string>>();
    public onUpdaterGetUpdateClientSettings = new Subject<IBaseResponse<UpdateClientSettingsItemArray>>();
    public onUpdaterGetUpdatePackages = new Subject<IBaseResponse<UpdatePackageItemArray>>();
    public onUpdaterGetUpdatePackageInstructions = new Subject<IBaseResponse<InstructionSet>>();
    public onUpdaterDeleteInstructionItem = new Subject<IBaseResponse<string>>();
    public onUpdaterCheckUpdatePackageStatus = new Subject<IBaseResponse<CheckUpdatePackageStatusResponse>>();
    public onUpdaterDeleteUpdatePackage = new Subject<IBaseResponse<string>>();
    public onUpdaterMakeUpdatePackageAvailable = new Subject<IBaseResponse<string>>();
    public onUpdaterUpdateInstructionSortOrder = new Subject<IBaseResponse<string>>();
    public onUpdaterGetUpdaterVersions = new Subject<IBaseResponse<UpdaterVersionItemArray>>();
    public onUpdaterDeleteUpdateVersion = new Subject<IBaseResponse<string>>();
    public onUpdaterGetUpdateVersionForceGroups = new Subject<IBaseResponse<UpdateVersionForceGroupItemArray>>();
    public onUpdaterGetUpdateVersionForceGroupsV3 = new Subject<IBaseResponse<UpdateVersionForceGroupItemArray>>();
    public onUpdaterGetUpdaterVersionForceGroups = new Subject<IBaseResponse<UpdaterVersionForceGroupItemArray>>();
    public onUpdaterAddUpdateVersionForceGroup = new Subject<IBaseResponse<number>>();
    public onUpdaterEditUpdateVersionForceGroup = new Subject<IBaseResponse<number>>();
    public onUpdaterDeleteUpdateVersionForceGroup = new Subject<IBaseResponse<string>>();
    public onUpdaterGetBenchmarks = new Subject<IBaseResponse<GetBenchmarksResponse>>();
    public onUpdaterUpdateVideoCardBenchmark = new Subject<IBaseResponse<number>>();
    public onUpdaterUpdateCPUBenchmark = new Subject<IBaseResponse<number>>();
    public onUpdaterAddVideoCardBenchmark = new Subject<IBaseResponse<number>>();
    public onUpdaterAddCPUBenchmark = new Subject<IBaseResponse<number>>();
    public onUpdaterGetPostponeGroups = new Subject<IBaseResponse<PostponeGroupItemArray>>();
    public onUpdaterGetHardwareChecks = new Subject<IBaseResponse<HardwareCheckItemArray>>();
    public onUpdaterAddVersionHardwareRequirement = new Subject<IBaseResponse<number>>();
    public onUpdaterUpdateVersionHardwareRequirement = new Subject<IBaseResponse<number>>();
    public onUpdaterDeleteVersionHardwareRequirement = new Subject<IBaseResponse<string>>();

    public onUpdaterAddInstructionRegistryAddKey = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterAddInstructionRegistryModifyKey = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterAddInstructionRegistryDeleteKey = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterAddInstructionFileSystemRenameFile = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterAddInstructionFileSystemRenameDirectory = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterAddInstructionFileSystemDeleteFile = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterAddInstructionFileSystemDeleteDirectory = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterAddInstructionFileSystemCreateDirectory = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterAddInstructionFileSystemCopyFile = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterAddInstructionFileSystemMoveFile = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterAddInstructionFileSystemCopyDirectory = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterAddInstructionFileSystemMoveDirectory = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterAddInstructionRegisterComponent = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterAddInstructionStartProcess = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterAddInstructionStopProcess = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterAddInstructionStartService = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterAddInstructionStopService = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterAddInstructionUnpackZip = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterAddInstructionDownloadFileFromUrl = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterEditInstructionRegistryAddKey = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterEditInstructionRegistryModifyKey = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterEditInstructionRegistryDeleteKey = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterEditInstructionFileSystemRenameFile = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterEditInstructionFileSystemRenameDirectory = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterEditInstructionFileSystemDeleteFile = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterEditInstructionFileSystemDeleteDirectory = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterEditInstructionFileSystemCreateDirectory = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterEditInstructionFileSystemCopyFile = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterEditInstructionFileSystemMoveFile = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterEditInstructionFileSystemCopyDirectory = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterEditInstructionFileSystemMoveDirectory = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterEditInstructionRegisterComponent = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterEditInstructionStartProcess = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterEditInstructionStopProcess = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterEditInstructionStartService = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterEditInstructionStopService = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterEditInstructionUnpackZip = new Subject<IBaseResponse<InstructionItem>>();
    public onUpdaterEditInstructionDownloadFileFromUrl = new Subject<IBaseResponse<InstructionItem>>();

    public onLiveHubGetConnections = new Subject<IBaseResponse<LiveHubConnectionItemArray>>();
    public onLiveHubGetUpdateLogs = new Subject<IBaseResponse<UpdateSuccessArray>>();

    public onGetLicenseVideoCards = new Subject<IBaseResponse<LicenseVideoCardItemArray>>();

    public onPoolStudioGetBubbles = new Subject<IBaseResponse<BubbleItemArray>>();
    public onPoolStudioGetBubbleGroups = new Subject<IBaseResponse<BubbleGroupItemArray>>();
    public onPoolStudioAddBubble = new Subject<IBaseResponse<number>>();
    public onPoolStudioUpdateBubble = new Subject<IBaseResponse<number>>();
    public onPoolStudioDeleteBubble = new Subject<IBaseResponse<string>>();

    public onTrialGetForLicense = new Subject<IBaseResponse<TrialLicenseResponse>>();
    public onTrialSet = new Subject<IBaseResponse<string>>();

    // leave router to protected because of inheritance
    constructor(private http: Http, protected router: Router) {
        super(http);
        this.SetBaseUrl();
    }

    public SetBaseUrl() {
        this.baseUrl = this.GetBaseURL();
    }

    public GetBaseURL(): string {

        console.log("Environment Name:", this.envName);
        console.log( "Base Url:", this.baseUrl);
        console.log("URL:", window.location.hostname);

        
        if (this.envName.includes('local')) {

           // return 'http://localhost:58316/api/';
            return this.baseUrl;

        } else {

            switch (window.location.hostname) {

                case 'ssdb.structurestudios.com': return 'https://api-ssdb2.structurestudios.com/API/';

                case 'ssdb-dev.structurestudios.com': return 'https://api-ssdb2-dev.structurestudios.com/API/';

                case 'ssdb-dev-primo.structurestudios.com': return 'https://api-ssdb-dev-primo.structurestudios.com/API/';
                //case 'ssdb-dev-primo.structurestudios.com': return 'https://api-ssdb2-dev.structurestudios.com/API/';

                case 'panel-ssdb3-node1.structurestudios.com': return 'https://api-ssdb3-node1.structurestudios.com/API/';
                
                case 'ssdb.se3dengine.net': return 'https://api-ssdb3.se3dengine.net/API/';

                case 'localhost': return this.CheckLocalStorageURL();

               default: return 'https://api-ssdb2-dev.structurestudios.com/API/';
            }

        }
       

    }

    public GetMemberURL(): string {

        switch (window.location.hostname) {

            case 'ssdb.structurestudios.com': return 'https://members.structurestudios.com';

            case 'ssdb-dev.structurestudios.com': return 'https://members.structurestudios.com';// 'https://members-panel-dev.structurestudios.com';

            case 'ssdb-dev-primo.structurestudios.com': return 'https://member-panel-dev-primo.structurestudios.com';

            case 'localhost': return 'http://localhost:4300';

            default: return 'https://members.structurestudios.com'; // 'https://members-panel-dev.structurestudios.com';
        }

    }

    private CheckLocalStorageURL(): string {
        let override = localStorage.getItem('override-api-url');

        let url = (override != null || override != undefined) ? override : 'https://api-ssdb3-node2.structurestudios.com/api/' // 'https://api-ssdb2-dev.structurestudios.com/API/';

		//url = "http://10.10.10.148/api/";

		return url;
		// return 'https://api-ssdb2.structurestudios.com/API/'; // LIVE URL -- BEEE CAREFUL!
    }

    public SetLocalStorageURL() {
        localStorage.setItem('override-api-url', 'https://api-ssdb3-node2.structurestudios.com/api/');
        localStorage.setItem('override-api-exp', new Date(new Date().getTime() + 60 * 60000).toString());
        this.SetBaseUrl();
    }

    public ClearLocalStorageURL() {
        localStorage.removeItem('override-api-url');
        localStorage.removeItem('override-api-exp');
        this.SetBaseUrl();
    }

    // Authentication
    public Login(request: LoginRequest): Observable<IBaseResponse<LoginResponse>> {

        let referalMethod = 'Login';

        return this.prepPOST<LoginResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Authentication_Login)
            .map(response => {

                Object.setPrototypeOf(response.Data, LoginResponse.prototype);
                response.Data.FixDates();

                this.onLoginResponse.next(response);
                return response;
            });

    }

    public LoginWithGoogle(request: LoginWithGoogleRequest): Observable<IBaseResponse<LoginResponse>> {

        let referalMethod = 'LoginWithGoogle';

        return this.prepPOST<LoginResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Authentication_LoginWithGoogle)
            .map(response => {

                Object.setPrototypeOf(response.Data, LoginResponse.prototype);
                response.Data.FixDates();

                this.onLoginWithGoogleResponse.next(response);
                return response;
            });

    }

    public GoogleAuthenticatorQR(): Observable<IBaseResponse<GoogleAuthenticatorQRResponse>> {

        let referalMethod = 'GoogleAuthenticatorQR';

        return this.prepGet<GoogleAuthenticatorQRResponse>(referalMethod, this.baseUrl, ssApiUrls.Authentication_GoogleAuthenticatorQR)
            .map(response => {

                this.onGoogleAuthenticatorQR.next(response);
                return response;
            });

    }

    public ResetPassword(request: ResetPasswordRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'Login';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Authentication_ResetPassword)
            .map(response => {
                this.onResetPassword.next(response);
                return response;
            });
    }

    public GetMemberNewLoginSession(request: MemberNewLoginSessionRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'GetMemberNewLoginSession';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Authentication_MemberNewLoginSession)
            .map(response => {

                this.onMemberNewLoginSession.next(response);
                return response;
            });

    }


    public SendTwoFactorCode(request: SendTwoFactorCodeOptionRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'SendTwoFactorCode';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Authentication_SendTwoFactorCode)
            .map(response => {

                this.onSendTwoFactorCode.next(response);
                return response;
            });

    }

    public TwoFactorAuthentication(request: TwoFactorAuthenticationRequest): Observable<IBaseResponse<LoginResponse>> {

        let referalMethod = 'TwoFactorAuthentication';

        return this.prepPOST<LoginResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Authentication_TwoFactorAuthentication)
            .map(response => {

                this.onTwoFactorAuthentication.next(response);
                return response;
            });

    }

    public Logout(forgetDevice: boolean): Observable<IBaseResponse<string>> {
        let referalMethod = 'Logout';

        let url = "";
        if (forgetDevice)
        {
            url = ssApiUrls.Authentication_Logout_Forget_Device
        }
        else
        {
            url = ssApiUrls.Authentication_Logout
        }

        return this.prepPOST<string>(referalMethod, false, this.baseUrl, url)
            .map(response => {
                this.onLogoutResponse.next(response);
                return response;
            });

    }

    //Error Messages
    public GetErrorMessages(): Observable<IBaseResponse<ErrorMessageItemArray>> {

        let referalMethod = 'GetErrorMessages';

        return this.prepGet<ErrorMessageItemArray>(referalMethod, this.baseUrl, ssApiUrls.ErrorMessages_GetErrorMessages)
            .map(response => {
                this.onErrorMessagesGetErrorMessages.next(response);
                return response;
            });

    }

   
    public UpdateErrorMessage(request: UpdateErrorMessageRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'UpdateErrorMessage';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.ErrorMessages_UpdateErrorMessage)
            .map(response => {

                this.onErrorMessagesUpdateErrorMessage.next(response);
                return response;
            });

    }  

    // Activity

    public GetMemberActivities(memberID: number): Observable<IBaseResponse<ActivityItemArray>> {

        let referalMethod = 'GetMemberActivities';

        return this.prepGet<ActivityItemArray>(referalMethod, this.baseUrl, ssApiUrls.Activity_Member_Activities, memberID.toString())
            .map(response => {

                if (response.Result)
                    ActivityItemArray.FixDates(response.Data);

                this.onActivities.next(response);
                return response;
            });

    }

    public GetGlobalActivities(request: GlobalActivitiesRequest): Observable<IBaseResponse<GlobalsActivitiesResponse>> {

        let referalMethod = 'GlobalActivities';

        return this.prepPOST<GlobalsActivitiesResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Activity_Global_Activities)
            .map(response => {

                if (response.Result)
                    ActivityItemArray.FixDates(response.Data.ActivityItems);

                this.onGlobalActivities.next(response);
                return response;
            });

    }
    // Vendors

    public VendorSendStatistics(request: SendVendorStatsEmailRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'VendorSendStatistics';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Vendor_SendEmailStatistics)
            .map(response => {

                this.onVendorSendEmailStatistics.next(response);
                return response;
            });

    }

    public VendorStatistics(request: VendorStatisticsRequest): Observable<IBaseResponse<VendorStatisticsItemArray>> {

        let referalMethod = 'VendorStatistics';

        return this.prepPOST<VendorStatisticsItemArray>(referalMethod, request, this.baseUrl, ssApiUrls.Vendor_Statistics)
            .map(response => {

                if (response.Result)
                    VendorStatisticsItemArray.FixDates(response.Data);

                this.onVendorStatistics.next(response);
                return response;
            });

    }

    public GetAllVendors(): Observable<IBaseResponse<VendorArray>> {

        let referalMethod = 'GetAllVendors';

        return this.prepGet<VendorArray>(referalMethod, this.baseUrl, ssApiUrls.Vendor_GetAll)
            .map(response => {

                if (response.Result)
                    VendorArray.FixDates(response.Data);

                this.onVendorGetAll.next(response);
                return response;
            });

    }

    public GetVendorItems(vendorID: number): Observable<IBaseResponse<VendorItemArray>> {

        let referalMethod = 'GetVendorItems';

        return this.prepGet<VendorItemArray>(referalMethod, this.baseUrl, ssApiUrls.Vendor_Items, vendorID.toString())
            .map(response => {

                if (response.Result)
                    VendorItemArray.FixDates(response.Data);

                this.onVendorItems.next(response);
                return response;
            });

    }


    public EditVendor(request: EditVendorRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'EditVendor';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Vendor_Edit)
            .map(response => {

                this.onVendorEdit.next(response);
                return response;
            });

    }

    public EditVendorItemIgnore(request: EditVendorItemIgnoreRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'EditVendorItemIgnore';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Vendor_EditItemIgnore)
            .map(response => {

                this.onVendorEditItemIgnore.next(response);
                return response;
            });

    }


    public AddVendor(request: AddVendorRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'AddVendor';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Vendor_Add)
            .map(response => {

                this.onVendorAdd.next(response);
                return response;
            });

    }



    // Audit

    public GetAuditLicenseAudits(request: LicenseAuditLogsRequest): Observable<IBaseResponse<AuditLogItemArray>> {

        let referalMethod = 'GetAuditLicenseAudits';

        return this.prepPOST<AuditLogItemArray>(referalMethod, request, this.baseUrl, ssApiUrls.Audit_LicenseAudits)
            .map(response => {

                if (response.Result)
                    AuditLogItemArray.FixDates(response.Data);

                this.onAuditLicenseAudits.next(response);
                return response;
            });

    }


    // TOS

    public UpdateLicenseTOSDetectiveWhiteListDate(request: UpdateLicenseTOSDetectiveWhiteListDateRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'UpdateLicenseTOSDetectiveWhiteListDate';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.TOS_UpdateLicenseTOSDetectiveWhiteListDate)
            .map(response => {

                this.onTOSUpdateLicenseTOSDetectiveWhiteListDate.next(response);
                return response;
            });

    }

    public EditTOSIP(request: EditTOSIPRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'EditTOSIP';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.TOS_EditIP)
            .map(response => {

                this.onTOSEditIP.next(response);
                return response;
            });

    }

    public GetTOSMembers(): Observable<IBaseResponse<MemberTOSBasicsItemArray>> {

        let referalMethod = 'GetTOSMembers';

        return this.prepGet<MemberTOSBasicsItemArray>(referalMethod, this.baseUrl, ssApiUrls.TOS_Members)
            .map(response => {

                this.onTOSMembers.next(response);
                return response;
            });

    }

    public GetTOSActivityLogs(request: ActivityLogsBaseRequest): Observable<IBaseResponse<TOSActivityLogResponseArray>> {

        let referalMethod = 'GetTOSActivityLogs';

        return this.prepPOST<TOSActivityLogResponseArray>(referalMethod, request, this.baseUrl, ssApiUrls.TOS_ActivityLogs)
            .map(response => {

                if (response.Result)
                    TOSActivityLogResponseArray.FixDates(response.Data);

                this.onTOSActivityLogs.next(response);
                return response;
            });

    }

    public GetTOSActivityLogsByLicense(request: LicenseActivityLogsRequest): Observable<IBaseResponse<TOSActivityLogResponseArray>> {

        let referalMethod = 'GetTOSActivityLogsByLicense';

        return this.prepPOST<TOSActivityLogResponseArray>(referalMethod, request, this.baseUrl, ssApiUrls.TOS_ActivityLogsByLicense)
            .map(response => {

                if (response.Result)
                    TOSActivityLogResponseArray.FixDates(response.Data);

                this.onTOSActivityLogsByLicense.next(response);
                return response;
            });

    }

    public GetTOSActivityLogsByMember(request: MemberActivityLogsRequest): Observable<IBaseResponse<TOSActivityLogResponseArray>> {

        let referalMethod = 'GetTOSActivityLogsByMember';

        return this.prepPOST<TOSActivityLogResponseArray>(referalMethod, request, this.baseUrl, ssApiUrls.TOS_ActivityLogsForMember)
            .map(response => {

                if (response.Result)
                    TOSActivityLogResponseArray.FixDates(response.Data);

                this.onTOSActivityLogsByMember.next(response);
                return response;
            });

    }

    public GetTOSWhitelistedIPs(): Observable<IBaseResponse<TOSIPArray>> {

        let referalMethod = 'GetTOSWhitelistedIPs';

        return this.prepGet<TOSIPArray>(referalMethod, this.baseUrl, ssApiUrls.TOS_WhitelistedIPs, '0')
            .map(response => {

                if (response.Result)
                    TOSIPArray.FixDates(response.Data);

                this.onTOSWhitelistedIPs.next(response);
                return response;
            });

    }

    public GetTOSFlaggedIPs(): Observable<IBaseResponse<TOSIPArray>> {

        let referalMethod = 'GetTOSFlaggedIPs';

        return this.prepGet<TOSIPArray>(referalMethod, this.baseUrl, ssApiUrls.TOS_FlaggedIPs, '0')
            .map(response => {

                if (response.Result)
                    TOSIPArray.FixDates(response.Data);

                this.onTOSFlaggedIPs.next(response);
                return response;
            });

    }

    public GetTOSMemberWhitelistedIPs(memberID: number): Observable<IBaseResponse<TOSIPArray>> {

        let referalMethod = 'GetTOSMemberWhitelistedIPs';

        return this.prepGet<TOSIPArray>(referalMethod, this.baseUrl, ssApiUrls.TOS_WhitelistedIPs, memberID.toString())
            .map(response => {

                if (response.Result)
                    TOSIPArray.FixDates(response.Data);

                this.onTOSMemberWhitelistedIPs.next(response);
                return response;
            });

    }

    public GetTOSMemberFlaggedIPs(memberID: number): Observable<IBaseResponse<TOSIPArray>> {

        let referalMethod = 'GetTOSMemberFlaggedIPs';

        return this.prepGet<TOSIPArray>(referalMethod, this.baseUrl, ssApiUrls.TOS_FlaggedIPs, memberID.toString())
            .map(response => {

                if (response.Result)
                    TOSIPArray.FixDates(response.Data);

                this.onTOSFlaggedIPs.next(response);
                return response;
            });

    }

    public GetTOSMemberComputers(memberID: number): Observable<IBaseResponse<TOSMemberComputerArray>> {

        let referalMethod = 'GetTOSMemberComputers';

        return this.prepGet<TOSMemberComputerArray>(referalMethod, this.baseUrl, ssApiUrls.TOS_Computers, memberID.toString())
            .map(response => {

                if (response.Result)
                TOSMemberComputerArray.FixDates(response.Data);

                return response;
            });

    }

    public GetTOSFlaggedMacAddresses(memberID: number): Observable<IBaseResponse<TOSMacArray>> {

        let referalMethod = 'GetTOSFlaggedMacAddresses';

        return this.prepGet<TOSMacArray>(referalMethod, this.baseUrl, ssApiUrls.TOS_FlaggedMacAddresses, memberID.toString())
            .map(response => {

                if (response.Result)
                    TOSMacArray.FixDates(response.Data);

                this.onTOSFlaggedMacAddresses.next(response);
                return response;
            });

    }

    public WhitelistTOSComputer(tosComputer: TOSMemberComputer): Observable<IBaseResponse<string>> {

        let referalMethod = 'WhitelistTOSComputer';

        return this.prepPOST<string>(referalMethod, tosComputer, this.baseUrl, ssApiUrls.TOS_TOSWhitelistComputer)
            .map(response => {
                return response;
            });

    }

    public RemoveWhitelistTOSComputer(tosComputer: TOSMemberComputer): Observable<IBaseResponse<string>> {

        let referalMethod = 'RemoveWhitelistTOSComputer';

        return this.prepPOST<string>(referalMethod, tosComputer, this.baseUrl, ssApiUrls.TOS_TOSRemoveWhitelistComputer)
            .map(response => {
                return response;
            });

    }

    public GetTOSFlaggedComputers(memberID: number): Observable<IBaseResponse<TOSComputerArray>> {

        let referalMethod = 'GetTOSFlaggedComputers';

        return this.prepGet<TOSComputerArray>(referalMethod, this.baseUrl, ssApiUrls.TOS_FlaggedComputers, memberID.toString())
            .map(response => {

                if (response.Result)
                    TOSComputerArray.FixDates(response.Data);

                this.onTOSFlaggedComputers.next(response);
                return response;
            });

    }

    public GetTOSTOSDetective(request: TOSDetectiveRequest): Observable<IBaseResponse<TOSDetectiveReportArray>> {

        let referalMethod = 'TOSDetective';

        return this.prepPOST<TOSDetectiveReportArray>(referalMethod, request, this.baseUrl, ssApiUrls.TOS_TOSDetective)
            .map(response => {
                this.onTOSTOSDetective.next(response);
                return response;
            });

    }

    public AddTOSFlaggedIP(request: AddTOSIPRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'AddTOSFlaggedIP';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.TOS_AddIP)
            .map(response => {
                this.onTOSAddIP.next(response);
                return response;
            });

    }

    public AddTOSFlaggedMac(request: addTOSMacRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'AddTOSFlaggedMac';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.TOS_AddMac)
            .map(response => {
                this.onTOSAddMac.next(response);
                return response;
            });

    }

    public AddTOSFlaggedComputer(request: AddTOSComputerRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'AddTOSFlaggedComputer';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.TOS_AddComputerRequest)
            .map(response => {
                this.onTOSAddComputerRequest.next(response);
                return response;
            });

    }


    // Custom Ticketing

    public AddCustomTicket(request: AddCustomTicketRequest): Observable<IBaseResponse<CustomTicketItem>> {

        let referalMethod = 'AddCustomTicket';

        return this.prepPOST<CustomTicketItem>(referalMethod, request, this.baseUrl, ssApiUrls.CustomTicket_OpenNew)
            .map(response => {
                this.onCustomTicketOpenNew.next(response);
                this.onCustomTicketsReload.next();
                return response;
            });

    }

    public AddCustomTicketReply(request: AddCustomTicketReplyRequest): Observable<IBaseResponse<CustomTicketItem>> {

        let referalMethod = 'AddCustomTicketReply';

        return this.prepPOST<CustomTicketItem>(referalMethod, request, this.baseUrl, ssApiUrls.CustomTicket_Reply)
            .map(response => {
                this.onCustomTicketReply.next(response);
                return response;
            });

    }

    public EditCustomTicket(request: EditCustomTicketRequest): Observable<IBaseResponse<String>> {

        let referalMethod = 'EditCustomTicket';

        return this.prepPOST<String>(referalMethod, request, this.baseUrl, ssApiUrls.CustomTicket_Edit)
            .map(response => {
                this.onCustomTicketEdit.next(response);
                this.onCustomTicketsReload.next();
                return response;
            });

    }

    public DeleteCustomTicket(ticketID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'DeleteTicket';

        return this.prepDelete<string>(referalMethod, this.baseUrl, ssApiUrls.CustomTicket_Delete, ticketID.toString())
            .map(response => {
                this.onCustomTicketDelete.next(response);
                this.onCustomTicketsReload.next();
                return response;
            });

    }


    public GetCustomTicketsByStatus(request: TicketStatusTypes): Observable<IBaseResponse<CustomTicketItemArray>> {

        let referalMethod = 'GetCustomTicketsByStatus';

        return this.prepGet<CustomTicketItemArray>(referalMethod, this.baseUrl, ssApiUrls.CustomTicket_GetByStatus, request.toString())
            .map(response => {

                if (response.Result)
                    CustomTicketItemArray.FixDates(response.Data);

                this.onCustomTicketsGetByStatus.next(response);
                return response;
            });

    }

    public GetCustomTicketsByAdminAndStatus(adminID: number, status: TicketStatusTypes): Observable<IBaseResponse<CustomTicketItemArray>> {

        let referalMethod = 'GetCustomTicketsByAdminAndStatus';
        let data = adminID + '/' + status.toString();

        return this.prepGet<CustomTicketItemArray>(referalMethod, this.baseUrl, ssApiUrls.CustomTicket_GetByAdminAndStatus, data)
            .map(response => {

                if (response.Result)
                    CustomTicketItemArray.FixDates(response.Data);

                this.onCustomTicketsGetByAdminAndStatus.next(response);
                return response;
            });

    }

    public GetCustomTicketsByMemberAndStatus(memberID: number, status: TicketStatusTypes): Observable<IBaseResponse<CustomTicketItemArray>> {

        let referalMethod = 'GetCustomTicketsByMemberAndStatus';
        let data = memberID + '/' + status.toString();

        return this.prepGet<CustomTicketItemArray>(referalMethod, this.baseUrl, ssApiUrls.CustomTicket_GetByMemberAndStatus, data)
            .map(response => {

                if (response.Result)
                    CustomTicketItemArray.FixDates(response.Data);

                this.onCustomTicketsGetByMemberAndStatus.next(response);
                return response;
            });

    }

    public GetCustomTicketsByAdmin(adminID: number): Observable<IBaseResponse<CustomTicketItemArray>> {

        let referalMethod = 'GetCustomTicketsByAdmin';

        return this.prepGet<CustomTicketItemArray>(referalMethod, this.baseUrl, ssApiUrls.CustomTicket_GetByAdmin, adminID.toString())
            .map(response => {

                if (response.Result)
                    CustomTicketItemArray.FixDates(response.Data);

                this.onCustomTicketsGetByAdmin.next(response);
                return response;
            });

    }

    public GetCustomTicketsByMember(memberID: number): Observable<IBaseResponse<CustomTicketItemArray>> {

        let referalMethod = 'GetCustomTicketsByMember';

        return this.prepGet<CustomTicketItemArray>(referalMethod, this.baseUrl, ssApiUrls.CustomTicket_GetByMember, memberID.toString())
            .map(response => {

                if (response.Result)
                    CustomTicketItemArray.FixDates(response.Data);

                this.onCustomTicketsGetByMember.next(response);
                return response;
            });

    }

    public GetCustomTicketsAdminTotals(adminID: number): Observable<IBaseResponse<CustomTicketsAdminTotalsArray>> {

        let referalMethod = 'GetCustomTicketsAdminTotals';

        return this.prepGet<CustomTicketsAdminTotalsArray>(referalMethod, this.baseUrl, ssApiUrls.CustomTicket_GetAdminTotals, adminID.toString())
            .map(response => {

                this.onCustomTicketsGetAdminTotals.next(response);
                return response;
            });

    }

    public GetCustomTicketsMemberTotals(memberID: number): Observable<IBaseResponse<CustomTicketsMemberTotalsArray>> {

        let referalMethod = 'GetCustomTicketsMemberTotals';

        return this.prepGet<CustomTicketsMemberTotalsArray>(referalMethod, this.baseUrl, ssApiUrls.CustomTicket_GetMemberTotals, memberID.toString())
            .map(response => {
                this.onCustomTicketsGetMemberTotals.next(response);
                return response;
            });

    }

    public GetCustomTicketsAdminGlobals(adminID: number): Observable<IBaseResponse<CustomTicketsAdminGlobalsResponse>> {

        let referalMethod = 'GetCustomTicketsAdminGlobals';

        return this.prepGet<CustomTicketsAdminGlobalsResponse>(referalMethod, this.baseUrl, ssApiUrls.CustomTicket_GetAdminGlobals, adminID.toString())
            .map(response => {


                if (response.Result && response.Data.Widgets != undefined)
                    CustomTicketWidgetItemArray.FixDates(response.Data.Widgets);

                this.onCustomTicketsGetAdminGlobals.next(response);
                return response;
            });

    }

    public GetCustomTicketsMemberGlobals(memberID: number): Observable<IBaseResponse<CustomTicketsMemberGlobalsResponse>> {

        let referalMethod = 'GetCustomTicketsMemberGlobals';

        return this.prepGet<CustomTicketsMemberGlobalsResponse>(referalMethod, this.baseUrl, ssApiUrls.CustomTicket_GetMemberGlobals, memberID.toString())
            .map(response => {
                this.onCustomTicketsGetMemberGlobals.next(response);
                return response;
            });

    }

    public GetCustomTicketsUnclaimed(includeClosed: boolean): Observable<IBaseResponse<CustomTicketItemArray>> {

        let referalMethod = 'GetCustomTicketsUnclaimed';

        return this.prepGet<CustomTicketItemArray>(referalMethod, this.baseUrl, ssApiUrls.CustomTicket_GetUnclaimed + includeClosed)
            .map(response => {
                this.onCustomTicketsGetUnclaimed.next(response);
                return response;
            });

    }

    public CustomTicketAssignMember(request: TicketAssignMemberRequest): Observable<IBaseResponse<CustomTicketAssignResponse>> {

        let referalMethod = 'CustomTicketAssignMember';

        return this.prepPOST<CustomTicketAssignResponse>(referalMethod, request, this.baseUrl, ssApiUrls.CustomTicket_AssignMember)
            .map(response => {
                this.onCustomTicketsAssignMember.next(response);
                this.onCustomTicketsReload.next();
                return response;
            });

    }

    public CustomTicketAssignAdmin(request: TicketAssignAdminRequest): Observable<IBaseResponse<CustomTicketAssignResponse>> {

        let referalMethod = 'CustomTicketAssignAdmin';

        return this.prepPOST<CustomTicketAssignResponse>(referalMethod, request, this.baseUrl, ssApiUrls.CustomTicket_AssignAdmin)
            .map(response => {
                this.onCustomTicketsAssignAdmin.next(response);
                this.onCustomTicketsReload.next();
                return response;
            });

    }

    loadTickets(): Observable<any> {
        return this.onCustomTicketsReload.asObservable();
    }

    public CustomTicketUnclaimedWidgets(): Observable<IBaseResponse<CustomTicketWidgetItemArray>> {

        let referalMethod = 'CustomTicketUnclaimedWidgets';

        return this.prepGet<CustomTicketWidgetItemArray>(referalMethod, this.baseUrl, ssApiUrls.CustomTicket_GetUnclaimedWidgets)
            .map(response => {

                if (response.Result)
                    CustomTicketWidgetItemArray.FixDates(response.Data);

                this.onCustomTicketsGetUnclaimedWidgets.next(response);
                this.onCustomTicketsReload.next();
                return response;
            });

    }

    public CustomTicketsSeachWidgets(request: CustomTicketsWidgetsSearchRequest): Observable<IBaseResponse<CustomTicketWidgetItemArray>> {

        let referalMethod = 'CustomTicketsSeachWidgets';

        return this.prepPOST<CustomTicketWidgetItemArray>(referalMethod, request, this.baseUrl, ssApiUrls.CustomTicket_SearchWidgets)
            .map(response => {

                if (response.Result)
                    CustomTicketWidgetItemArray.FixDates(response.Data);

                this.onCustomTicketsSearchWidgets.next(response);
                return response;
            }); ;
    }

    // Hubspot Ticketing

    public AddHubspotTicket(request: AddHubspotTicketRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'AddHubspotTicket';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.HubspotTicket_AddHubspotTicket)
            .map(response => {

                this.onHubspotTicketsAddHubspotTicket.next(response);
                return response;
            });

    } 

    public GetHubspotTicketsByStatus(request: HubspotTicketStatusTypes): Observable<IBaseResponse<HubspotTicketItemArray>> {

        let referalMethod = 'GetHubspotTicketsByStatus';

        return this.prepGet<HubspotTicketItemArray>(referalMethod, this.baseUrl, ssApiUrls.HubspotTicket_GetByStatus, request.toString())
            .map(response => {

                if (response.Result)
                    HubspotTicketItemArray.FixDates(response.Data);

                this.onHubspotTicketsGetByStatus.next(response);
                return response;
            });

    }

    public GetHubspotTicketsByAdminAndStatus(adminID: number, status: HubspotTicketStatusTypes): Observable<IBaseResponse<HubspotTicketItemArray>> {

        let referalMethod = 'GetHubspotTicketsByAdminAndStatus';
        let data = adminID + '/' + status.toString();

        return this.prepGet<HubspotTicketItemArray>(referalMethod, this.baseUrl, ssApiUrls.HubspotTicket_GetByAdminAndStatus, data)
            .map(response => {

                if (response.Result)
                    HubspotTicketItemArray.FixDates(response.Data);

                this.onHubspotTicketsGetByAdminAndStatus.next(response);
                return response;
            });

    }

    public GetHubspotTicketsByMemberAndStatus(memberID: number, status: HubspotTicketStatusTypes): Observable<IBaseResponse<HubspotTicketItemArray>> {

        let referalMethod = 'GetHubspotTicketsByMemberAndStatus';
        let data = memberID + '/' + status.toString();

        return this.prepGet<HubspotTicketItemArray>(referalMethod, this.baseUrl, ssApiUrls.HubspotTicket_GetByMemberAndStatus, data)
            .map(response => {

                if (response.Result)
                    HubspotTicketItemArray.FixDates(response.Data);

                this.onHubspotTicketsGetByMemberAndStatus.next(response);
                return response;
            });

    }

    public GetHubspotTicketsByAdmin(adminID: number): Observable<IBaseResponse<HubspotTicketItemArray>> {

        let referalMethod = 'GetHubspotTicketsByAdmin';

        return this.prepGet<HubspotTicketItemArray>(referalMethod, this.baseUrl, ssApiUrls.HubspotTicket_GetByAdmin, adminID.toString())
            .map(response => {

                if (response.Result)
                    HubspotTicketItemArray.FixDates(response.Data);

                this.onHubspotTicketsGetByAdmin.next(response);
                return response;
            });

    }

    public GetHubspotTicketsByMember(memberID: number): Observable<IBaseResponse<HubspotTicketItemArray>> {

        let referalMethod = 'GetHubspotTicketsByMember';

        return this.prepGet<HubspotTicketItemArray>(referalMethod, this.baseUrl, ssApiUrls.HubspotTicket_GetByMember, memberID.toString())
            .map(response => {

                if (response.Result)
                    HubspotTicketItemArray.FixDates(response.Data);

                this.onHubspotTicketsGetByMember.next(response);
                return response;
            });

    }

    public GetHubspotTicketsAdminTotals(adminID: number): Observable<IBaseResponse<HubspotTicketsAdminTotalsArray>> {

        let referalMethod = 'GetHubspotTicketsAdminTotals';

        return this.prepGet<HubspotTicketsAdminTotalsArray>(referalMethod, this.baseUrl, ssApiUrls.HubspotTicket_GetAdminTotals, adminID.toString())
            .map(response => {

                this.onHubspotTicketsGetAdminTotals.next(response);
                return response;
            });

    }

    public GetHubspotTicketsMemberTotals(memberID: number): Observable<IBaseResponse<HubspotTicketsMemberTotalsArray>> {

        let referalMethod = 'GetHubspotTicketsMemberTotals';

        return this.prepGet<HubspotTicketsMemberTotalsArray>(referalMethod, this.baseUrl, ssApiUrls.HubspotTicket_GetMemberTotals, memberID.toString())
            .map(response => {
                this.onHubspotTicketsGetMemberTotals.next(response);
                return response;
            });

    }

    public GetHubspotTicketsAdminGlobals(adminID: number): Observable<IBaseResponse<HubspotTicketsAdminGlobalsResponse>> {

        let referalMethod = 'GetHubspotTicketsAdminGlobals';

        return this.prepGet<HubspotTicketsAdminGlobalsResponse>(referalMethod, this.baseUrl, ssApiUrls.HubspotTicket_GetAdminGlobals, adminID.toString())
            .map(response => {


                if (response.Result && response.Data.Widgets != undefined)
                    HubspotTicketWidgetItemArray.FixDates(response.Data.Widgets);

                this.onHubspotTicketsGetAdminGlobals.next(response);
                return response;
            });

    }

    public GetHubspotTicketsMemberGlobals(memberID: number): Observable<IBaseResponse<HubspotTicketsMemberGlobalsResponse>> {

        let referalMethod = 'GetHubspotTicketsMemberGlobals';

        return this.prepGet<HubspotTicketsMemberGlobalsResponse>(referalMethod, this.baseUrl, ssApiUrls.HubspotTicket_GetMemberGlobals, memberID.toString())
            .map(response => {
                this.onHubspotTicketsGetMemberGlobals.next(response);
                return response;
            });

    }

    public GetHubspotTicketsUnclaimed(): Observable<IBaseResponse<HubspotTicketItemArray>> {

        let referalMethod = 'GetHubspotTicketsUnclaimed';

        return this.prepGet<HubspotTicketItemArray>(referalMethod, this.baseUrl, ssApiUrls.HubspotTicket_GetUnclaimed)
            .map(response => {
                this.onHubspotTicketsGetUnclaimed.next(response);
                return response;
            });

    }

    loadHubspotTickets(): Observable<any> {
        return this.onHubspotTicketsReload.asObservable();
    }

    public HubspotTicketUnclaimedWidgets(): Observable<IBaseResponse<HubspotTicketWidgetItemArray>> {

        let referalMethod = 'HubspotTicketUnclaimedWidgets';

        return this.prepGet<HubspotTicketWidgetItemArray>(referalMethod, this.baseUrl, ssApiUrls.HubspotTicket_GetUnclaimedWidgets)
            .map(response => {

                if (response.Result)
                    HubspotTicketWidgetItemArray.FixDates(response.Data);

                this.onHubspotTicketsGetUnclaimedWidgets.next(response);
                this.onHubspotTicketsReload.next();
                return response;
            });

    }

    public HubspotTicketsSeachWidgets(request: HubspotTicketsWidgetsSearchRequest): Observable<IBaseResponse<HubspotTicketWidgetItemArray>> {

        let referalMethod = 'HubspotTicketsSeachWidgets';

        return this.prepPOST<HubspotTicketWidgetItemArray>(referalMethod, request, this.baseUrl, ssApiUrls.HubspotTicket_SearchWidgets)
            .map(response => {

                if (response.Result)
                    HubspotTicketWidgetItemArray.FixDates(response.Data);

                this.onHubspotTicketsSearchWidgets.next(response);
                return response;
            }); ;
    }

    // Ticketing

    public GetTicketsTotals(): Observable<IBaseResponse<TicketsCountItemArray>> {

        let referalMethod = 'GetTicketsTotals';

        return this.prepGet<TicketsCountItemArray>(referalMethod, this.baseUrl, ssApiUrls.Tickets_Totals)
            .map(response => {
                this.onTicketsTotals.next(response);
                return response;
            });

    }

    public GetTicketByID(ticketID: number): Observable<IBaseResponse<CustomTicketItem>> {

        let referalMethod = 'GetTicketByID';

        return this.prepGet<CustomTicketItem>(referalMethod, this.baseUrl, ssApiUrls.CustomTicket_GetByID, ticketID.toString())
            .map(response => {

                if (response.Result)
                    CustomTicketItem.FixDates(response.Data);

                this.onCustomTicketsGetByID.next(response);
                return response;
            });

    }


    public GetTicketsWidgetsData(adminID: number, includeClosed: boolean = false, unclaimed: boolean = false): Observable<IBaseResponse<TicketWidgetItemArray>> {

        let referalMethod = 'GetTicketsWidgetsData';
        let data = adminID.toString() + '/' + includeClosed + '/' + unclaimed;

        return this.prepGet<TicketWidgetItemArray>(referalMethod, this.baseUrl, ssApiUrls.Tickets_WidgetsData, data)
            .map(response => {

                this.onTicketsWidgetsData.next(response);
                return response;
            }); ;
    }

    public GetTicketsMemberWidgetsData(memberID: number, includeClosed: boolean = false): Observable<IBaseResponse<TicketWidgetItemArray>> {

        let referalMethod = 'GetTicketsMemberWidgetsData';
        let data = memberID + '/' + includeClosed;

        return this.prepGet<TicketWidgetItemArray>(referalMethod, this.baseUrl, ssApiUrls.Tickets_MemberWidgetsData, memberID.toString())
            .map((response) => {

                this.onTicketsMemberWidgetsData.next(response);
                return response;
            })
    }

    public GetTicketsByID(ticketID: number): Observable<IBaseResponse<TicketItem>> {

        let referalMethod = 'GetTicketsByID';

        return this.prepGet<TicketItem>(referalMethod, this.baseUrl, ssApiUrls.Ticket_ByID, ticketID.toString())
            .map(response => {

                this.onTicketByID.next(response);
                return response;
            }); ;
    }

    public GetTicketsByNR(ticketNR: string): Observable<IBaseResponse<TicketItem>> {

        let referalMethod = 'GetTicketsByNR';

        return this.prepGet<TicketItem>(referalMethod, this.baseUrl, ssApiUrls.Ticket_ByNR, ticketNR)
            .map(response => {

                this.onTicketByNR.next(response);
                return response;
            }); ;
    }


    public getTicketMyTotals(adminID: number): Observable<IBaseResponse<TicketTotals>> {

        let referalMethod = 'TicketAssignMember';

        return this.prepGet<TicketTotals>(referalMethod, this.baseUrl, ssApiUrls.Ticket_AdminTotals, adminID.toString())
            .map((response) => {

                this.onTicketAdminTotals.next(response);
                return response;
            })
    }

    public GetTicketDepartments(): Observable<IBaseResponse<TicketDepartmentArray>> {

        let referalMethod = 'GetTicketDepartments';

        return this.prepGet<TicketDepartmentArray>(referalMethod, this.baseUrl, ssApiUrls.Ticket_Departments)
            .map(response => {

                this.onTicketDepartments.next(response);
                return response;
            }); ;
    }


    public GetTicketGlobals(adminID: number, includeClosed: boolean = false): Observable<IBaseResponse<TicketGlobals>> {
        let referalMethod = 'GetTicketGlobals';
        let data = adminID.toString() + '/' + includeClosed;

        return this.prepGet<TicketGlobals>(referalMethod, this.baseUrl, ssApiUrls.Ticket_Globals, data)
            .map(response => {

                this.onTicketGlobals.next(response);
                return response;
            }); ;
    }


    public getTicketStatuses(): Observable<IBaseResponse<TicketStatusArray>> {

        let referalMethod = 'getTicketStatuses';

        return this.prepGet<TicketStatusArray>(referalMethod, this.baseUrl, ssApiUrls.Ticket_Statuses)
            .map(response => {

                this.onTicketStatuses.next(response);
                return response;
            }); ;
    }

    public GetTicketLogs(ticketID: number): Observable<IBaseResponse<TicketLogItemArray>> {
        let referalMethod = 'GetTicketLogs';

        return this.prepGet<TicketLogItemArray>(referalMethod, this.baseUrl, ssApiUrls.Ticket_LogsByID, ticketID.toString())
            .map((response) => {

                this.onTicketLogByID.next(response);
                return response;
            })
    }


    public TicketAssignMember(request: TicketAssignMemberRequest): Observable<IBaseResponse<StringResponse>> {

        let referalMethod = 'TicketAssignMember';

        return this.prepPATCH<StringResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Ticket_AssignMember)
            .map(response => {

                this.onTicketAssignMember.next(response);
                return response;
            }); ;
    }

    public TicketAssignAdmin(request: TicketAssignAdminRequest): Observable<IBaseResponse<StringResponse>> {

        let referalMethod = 'TicketAssignAdmin';

        return this.prepPATCH<StringResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Ticket_AssignAdmin)
            .map(response => {

                this.onTicketAssignAdmin.next(response)
                return response;
            });
    }


    public TicketUnassignFromMember(request: TicketAssignMemberRequest): Observable<IBaseResponse<StringResponse>> {

        let referalMethod = 'TicketUnassignFromMember';

        return this.prepPATCH<StringResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Ticket_UnAssignMember)
            .map(response => {

                this.onTicketUnAssignMember.next(response);
                return response;
            }); ;
    }


    public TicketUpdate(request: IUpdateTicketRequest): Observable<IBaseResponse<String>> {
        let referalMethod = 'TicketUpdate';

        return this.prepPATCH<String>(referalMethod, request, this.baseUrl, ssApiUrls.Ticket_Update)
            .map(response => {
                if (response.Result)
                    this.onTicketUpdate.next(response);
                return response;
            });
    }


    public TicketAddReply(request: IAddTicketReplyRequest): Observable<IBaseResponse<StringResponse>> {

        let referalMethod = 'TicketAddReply';

        return this.prepPOST<StringResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Ticket_AddReply)
            .map(response => {

                this.onTicketAddReply.next(response);
                return response;
            }); ;
    }





    public TicketOpenNew(request: IOpenNewTicketRequest): Observable<IBaseResponse<TicketItem>> {

        let referalMethod = 'TicketOpenNew';

        return this.prepPOST<TicketItem>(referalMethod, request, this.baseUrl, ssApiUrls.Ticket_OpenNew)
            .map(response => {
                if (response.Result)
                    this.onTicketOpenNew.next(response);
                return response;
            });
    }




    // admin

    public getAdmins(): Observable<IBaseResponse<AdminItemArray>> {
        let referalMethod = 'getAdmins';

        return this.prepGet<AdminItemArray>(referalMethod, this.baseUrl, ssApiUrls.Admin_AllAdmins)
            .map(response => {

                this.onAdminAllAdmins.next(response);
                return response;
            }); ;
    }


    public AdminsByPermissionType(permissionType: AdminPermissionTypes): Observable<IBaseResponse<AdminItemArray>> {
        let referalMethod = 'AdminsByPermissionType';

        return this.prepGet<AdminItemArray>(referalMethod, this.baseUrl, ssApiUrls.Admin_AdminsByPermissionType, permissionType.toString())
            .map(response => {

                this.onAdminAdminsByPermissionType.next(response);
                return response;
            }); ;
    }

    public UpdateAdmin(request: UpdateAdminRequest): Observable<IBaseResponse<number>> {
        let referalMethod = 'UpdateAdmin';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Admin_UpdateAdmin)
            .map(response => {

                this.onUpdateAdmin.next(response);
                return response;
            }); ;
    }


	public RemoveAdminAccess(request: RemoveAdminAccessRequest): Observable<IBaseResponse<number>> {
        let referalMethod = 'UpdateAdmin';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Admin_RemoveAdminAccess)
            .map(response => {

                this.onRemoveAdminAccess.next(response);
                return response;
            });
	}
	

    public GetSMTPByEmail(request: GetSMTPByEmailRequest): Observable<IBaseResponse<GetSMTPByEmailResponse>> {
        let referalMethod = 'GetSMTPByEmail';

        return this.prepPOST<GetSMTPByEmailResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Admin_GetSMTPByEmail)
            .map(response => {

                this.onGetSMTPByEmail.next(response);
                return response;
            }); ;
    }


    public UpdateSMTPByEmail(request: UpdateSMTPByEmailRequest): Observable<IBaseResponse<UpdateSMTPByEmailResponse>> {
        let referalMethod = 'UpdateSMTPByEmail';

        return this.prepPOST<UpdateSMTPByEmailResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Admin_UpdateSMTPByEmail)
            .map(response => {

                this.onUpdateSMTPByEmail.next(response);
                return response;
            }); ;
    }

    public TestSMTPSettings(): Observable<IBaseResponse<string>> {
        let referalMethod = 'TestSMTPSettings';

        return this.prepGet<string>(referalMethod, this.baseUrl, ssApiUrls.Admin_TestSMTPSettings)
            .map(response => {

                this.onTestSMTPSettings.next(response);
                return response;
            }); ;
    }

    public DeleteAdminPreference(request: DeleteAdminPreferenceRequest): Observable<IBaseResponse<string>> {
        let referalMethod = 'DeleteAdminPreference';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Admin_DeleteAdminPreference)
            .map(response => {

                this.onAdminDeleteAdminPreference.next(response);
                return response;
            }); ;
    }

    public DeleteAllAdminPreferences(adminID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'DeleteAllAdminPreferences';

        return this.prepDelete<string>(referalMethod, this.baseUrl, ssApiUrls.Admin_DeleteAllAdminPreferences, adminID.toString())
            .map(response => {
                this.onAdminDeleteAllAdminPreferences.next(response);
                return response;
            });

    }

    public GetAdminPreferenceByName(request: GetAdminPreferenceByNameRequest): Observable<IBaseResponse<AdminPreferenceItem>> {
        let referalMethod = 'GetAdminPreferenceByName';

        return this.prepPOST<AdminPreferenceItem>(referalMethod, request, this.baseUrl, ssApiUrls.Admin_GetAdminPreferenceByName)
            .map(response => {

                this.onAdminGetAdminPreferenceByName.next(response);
                return response;
            }); ;
    }

    public GetAdminPreferences(adminID: number): Observable<IBaseResponse<AdminPreferenceItemArray>> {
        let referalMethod = 'GetAdminPreferences';

        return this.prepGet<AdminPreferenceItemArray>(referalMethod, this.baseUrl, ssApiUrls.Admin_GetAdminPreferences, adminID.toString())
            .map((response) => {

                this.onAdminGetAdminPreferences.next(response);
                return response;
            })
    }

    public SaveAdminPreference(request: SaveAdminPreferenceRequest): Observable<IBaseResponse<string>> {
        let referalMethod = 'SaveAdminPreference';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Admin_SaveAdminPreference)
            .map(response => {

                this.onAdminSaveAdminPreference.next(response);
                return response;
            }); ;
    }

    public SaveAdminPreferences(request: SaveAdminPreferencesRequest): Observable<IBaseResponse<string>> {
        let referalMethod = 'SaveAdminPreferences';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Admin_SaveAdminPreferences)
            .map(response => {

                this.onAdminSaveAdminPreferences.next(response);
                return response;
            }); ;
    }

    // sales

    public GetSalesRepresentatives(request: GetSalesRepresentativesRequest): Observable<IBaseResponse<SalesRepresentativeArray>> {

        let referalMethod = 'SalesRepresentatives';

        return this.prepPOST<SalesRepresentativeArray>(referalMethod, request, this.baseUrl, ssApiUrls.Sales_SalesRepresentatives)
            .map(response => {
                this.onSalesRepresentatives.next(response);
                return response;
            });

    }

    public GetAbandonedCarts(): Observable<IBaseResponse<AbandonedCartItemArray>> {

        let referalMethod = 'GetAbandonedCarts';

        return this.prepGet<AbandonedCartItemArray>(referalMethod, this.baseUrl, ssApiUrls.Sales_GetAbandonedCarts)
            .map(response => {
                this.onSalesGetAbandonedCarts.next(response);
                return response;
            });

    }

    public GetGlobalMACWhitelists(): Observable<IBaseResponse<GlobalMACWhitelistBasicArray>> {

        let referalMethod = 'GlobalMACWhitelists';

        return this.prepGet<GlobalMACWhitelistBasicArray>(referalMethod, this.baseUrl, ssApiUrls.TOS_GlobalMACWhitelists)
            .map(response => {
                this.onTOSGlobalMACWhitelists.next(response);
                return response;
            });

    }

    public RemoveGlobalMACWhitelist(macAdress: string): Observable<IBaseResponse<string>> {
        let referalMethod = 'RemoveGlobalMACWhitelist';

        return this.prepGet<string>(referalMethod, this.baseUrl, ssApiUrls.TOS_RemoveGlobalMACWhitelist, macAdress)
            .map(response => {
                this.onTOSRemoveGlobalMACWhitelist.next(response);
                return response;
            });
    }

    public AddGlobalMACWhitelist(macAdress: string): Observable<IBaseResponse<string>> {
        let referalMethod = 'AddGlobalMACWhitelist';

        return this.prepGet<string>(referalMethod, this.baseUrl, ssApiUrls.TOS_AddGlobalMACWhitelist, macAdress)
            .map(response => {
                this.onTOSAddGlobalMACWhitelist.next(response);
                return response;
            });
    }

    public GetGlobalPhoneWhitelists(): Observable<IBaseResponse<GlobalPhoneWhitelistBasicArray>> {

        let referalMethod = 'GlobalPhoneWhitelists';

        return this.prepGet<GlobalPhoneWhitelistBasicArray>(referalMethod, this.baseUrl, ssApiUrls.TOS_GlobalPhoneWhitelists)
            .map(response => {
                this.onTOSGlobalPhoneWhitelists.next(response);
                return response;
            });

    }

    public RemoveGlobalPhoneWhitelist(phone: string): Observable<IBaseResponse<string>> {
        let referalMethod = 'RemoveGlobalPhoneWhitelist';

        return this.prepGet<string>(referalMethod, this.baseUrl, ssApiUrls.TOS_RemoveGlobalPhoneWhitelist, phone)
            .map(response => {
                this.onTOSRemoveGlobalPhoneWhitelist.next(response);
                return response;
            });
    }

    public AddGlobalPhoneWhitelist(phone: string): Observable<IBaseResponse<string>> {
        let referalMethod = 'AddGlobalPhoneWhitelist';

        return this.prepGet<string>(referalMethod, this.baseUrl, ssApiUrls.TOS_AddGlobalPhoneWhitelist, phone)
            .map(response => {
                this.onTOSAddGlobalPhoneWhitelist.next(response);
                return response;
            });
    }

    public GetGlobalAddressWhitelists(): Observable<IBaseResponse<GlobalAddressWhitelistBasicArray>> {

        let referalMethod = 'GlobalAddressWhitelists';

        return this.prepGet<GlobalAddressWhitelistBasicArray>(referalMethod, this.baseUrl, ssApiUrls.TOS_GlobalAddressWhitelists)
            .map(response => {
                this.onTOSGlobalAddressWhitelists.next(response);
                return response;
            });

    }

    public AddGlobalAddressWhitelist(request: AddGlobalAddressWhitelistRequest): Observable<IBaseResponse<string>> {
        let referalMethod = 'AddGlobalAddressWhitelist';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.TOS_AddGlobalAddressWhitelist)
            .map(response => {
                this.onTOSAddGlobalAddressWhitelist.next(response);
                return response;
            });
    }

    public EditGlobalAddressWhitelist(request: EditGlobalAddressWhitelistRequest): Observable<IBaseResponse<string>> {
        let referalMethod = 'EditGlobalAddressWhitelist';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.TOS_EditGlobalAddressWhitelist)
            .map(response => {
                this.onTOSEditGlobalAddressWhitelist.next(response);
                return response;
            });
    }

    public RemoveGlobalAddressWhitelist(id: number): Observable<IBaseResponse<string>> {
        let referalMethod = 'RemoveGlobalAddressWhitelist';

        return this.prepGet<string>(referalMethod, this.baseUrl, ssApiUrls.TOS_RemoveGlobalAddressWhitelist, id.toString())
            .map(response => {
                this.onTOSRemoveGlobalAddressWhitelist.next(response);
                return response;
            });
    }

    public HideAbandonedCart(cartID: string): Observable<IBaseResponse<string>> {
        let referalMethod = 'GetTicketLogs';

        return this.prepGet<string>(referalMethod, this.baseUrl, ssApiUrls.Sales_HideAbandonedCart, cartID)
            .map((response) => {

                this.onSalesHideAbandonedCart.next(response);
                return response;
            })
    }

    // products

    public GetStructureStudiosProductsBasics(): Observable<IBaseResponse<ProductItemBasicsArray>> {

        let referalMethod = 'GetStructureStudiosProductsBasics';

        return this.prepGet<ProductItemBasicsArray>(referalMethod, this.baseUrl, ssApiUrls.Products_StructureStudiosProductsBasics)
            .map(response => {
                this.onProductStructureStudiosProductsBasics.next(response);
                return response;
            });

    }

    public GetStructureStudiosProductsSettings(): Observable<IBaseResponse<ProductSettingsItemArray>> {

        let referalMethod = 'GetStructureStudiosProductsSettings';

        return this.prepGet<ProductSettingsItemArray>(referalMethod, this.baseUrl, ssApiUrls.Products_StructureStudiosSettings)
            .map(response => {
                this.onProductStructureStudiosProductsSettings.next(response);
                return response;
            });

    } 
    
    public SaveStructureStudiosProductSettings(request: ProductSettings): Observable<IBaseResponse<string>> {

        let referalMethod = 'SaveStructureStudiosProductSettings';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Products_SaveStructureStudiosSettings)
            .map(response => {
                this.onSaveStructureStudiosProductSettings.next(response);
                return response;
            });

    }

    public GetGISProducts(memberID: number): Observable<IBaseResponse<GISProductItemArray>> {

        let referalMethod = 'GetGISProducts';

        return this.prepGet<GISProductItemArray>(referalMethod, this.baseUrl, ssApiUrls.Products_GISProducts, memberID.toString())
            .map(response => {
                this.onProductGISProducts.next(response);
                return response;
            });

    }

    public GetGISAddonProducts(memberId: number): Observable<IBaseResponse<GISAddons>> {

        let referalMethod = 'GetAddonGISProducts';

        return this.prepGet<GISAddons>(referalMethod, this.baseUrl, ssApiUrls.Products_GISAddonProducts, memberId.toString())
            .map(response => {
                this.onProductGISAddonProducts.next(response);
                return response;
            });

    }


    // statistics

    public GetExistingProjectLicenseKeys(): Observable<IBaseResponse<string[]>> {

        let referalMethod = 'GetExistingProjectLicenseKeys';

        return this.prepGet<string[]>(referalMethod, this.baseUrl, ssApiUrls.Statistics_GetExistingProjectLicenseKeys)
            .map(response => {

                this.onStatisticsGetExistingProjectLicenseKeys.next(response);
                return response;
            });

    } 
   
    public MemberVersions(versionmode: string, archiveDate: Date): Observable<IBaseResponse<MemberVersionItemArray>> {

        let referalMethod = 'MemberVersions';

        let formatteddate = moment(archiveDate).format('YYYY-MM-DD');

        return this.prepGet<MemberVersionItemArray>(referalMethod, this.baseUrl, ssApiUrls.Statistics_MemberVersions + versionmode + "/" + formatteddate)
            .map(response => {

                this.onStatisticsMemberVersions.next(response);
                return response;
            });

    }

    public GetHoldStatistics(request: HoldStatsRequest): Observable<IBaseResponse<HoldStatisticsItemArray>> {

        let referalMethod = 'HoldStatistics';

        return this.prepPOST<HoldStatisticsItemArray>(referalMethod, request, this.baseUrl, ssApiUrls.Statistics_HoldStatistics)
            .map(response => {

                this.onStatisticsHoldStatistics.next(response);
                return response;
            });
    } 

    public StatisticsSales(request: SalesStatsRequest): Observable<IBaseResponse<SalesStatisticsResult>> {

        let referalMethod = 'StatisticsSales';

        return this.prepPOST<SalesStatisticsResult>(referalMethod, request, this.baseUrl, ssApiUrls.Statistics_Sales)
            .map(response => {

                if (response.Result)
                    SalesStatisticsResult.FixDates(response.Data);

                this.onStatisticsSales.next(response);
                return response;
            });

    }

    public StoreProjects(request: StoreProjectsRequest): Observable<IBaseResponse<string>> {
        
        let referalMethod = 'StoreProjects';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Statistics_StoreProjects)
            .map(response => {

                this.onStatisticsStoreProjects.next(response);
                return response;
                
            });
    }

    public GUIStatistics(request: GUIStatisticsRequest): Observable<IBaseResponse<GUIStatisticsResult>> {

        let referalMethod = 'GUIStatistics';

        return this.prepPOST<GUIStatisticsResult>(referalMethod, request, this.baseUrl, ssApiUrls.Statistics_GUIStatistics, 600000)
            .map(response => {


                if (response.Result)
                    GUIStatisticsResult.FixDates(response.Data);

                this.onStatisticsGUIStatistics.next(response);
                return response;
            });
    }

    public AssetStatistics(request: AssetStatisticsRequest): Observable<IBaseResponse<AssetStatisticsItemArray>> {

        let referalMethod = 'AssetStatistics';

        return this.prepPOST<AssetStatisticsItemArray>(referalMethod, request, this.baseUrl, ssApiUrls.Statistics_AssetStatistics)
            .map(response => {

                this.onStatisticsAssetStatistics.next(response);
                return response;
            });
    }

    public GetGracePeriodReport(): Observable<IBaseResponse<GracePeriodReportItemArray>> {

        let referalMethod = 'GetGracePeriodReport';

        return this.prepGet<GracePeriodReportItemArray>(referalMethod, this.baseUrl, ssApiUrls.Billing_GetGracePeriodReport)
            .map(response => {
                this.onBillingGetGracePeriodReport.next(response);
                return response;
            });

    }
    public ProcessAutomationBilling(): Observable<IBaseResponse<boolean>> {

        let referalMethod = 'ProcessAutomationBilling';

        return this.prepPOST<boolean>(referalMethod, null, this.baseUrl, ssApiUrls.Billing_ProcessAutomationBilling)
            .map(response => {

                this.onProcessAutomationBilling.next(response);
                return response;
            });

    }

    public StatisticsProductsTotals(request: ProductsTotalsRequest): Observable<IBaseResponse<ProductTotalsItemArray>> {

        let referalMethod = 'StatisticsProductsTotals';

        return this.prepPOST<ProductTotalsItemArray>(referalMethod, request, this.baseUrl, ssApiUrls.Statistics_ProductsTotals)
            .map(response => {

                this.onStatisticsProductsTotals.next(response);
                return response;
            });

    }


    // credit card
    public AddCreditCard(request: AddCreditCardRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'AddCreditCard';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.CCard_Add)
            .map(response => {

                this.onCreditCardAdd.next(response);
                return response;
            });

    }

    public DecryptCreditCard(request: DecryptCreditCardRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'DecryptCreditCard';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.CCard_Decrypt)
            .map(response => {
                this.onCreditCardDecrypt.next(response);
                return response;
            });

    }

    public DeleteCreditCard(creditCardID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'DeleteCreditCard';

        return this.prepDelete<string>(referalMethod, this.baseUrl, ssApiUrls.CCard_Delete, creditCardID.toString())
            .map(response => {
                this.onCreditCardDelete.next(response);
                return response;
            });

    }

    public EditCreditCard(request: CreditCardEditRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'EditCreditCard';

        return this.prepPATCH<string>(referalMethod, request, this.baseUrl, ssApiUrls.CCard_Edit)
            .map(response => {
                this.onCreditCardEdit.next(response);
                return response;
            });

    }

    public CreditCardSetAsDefault(creditCardID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'CreditCardSetAsDefault';

        return this.prepPATCH<string>(referalMethod, null, this.baseUrl, ssApiUrls.CCard_SetAsDefault + creditCardID)
            .map(response => {
                this.onCreditCardSetAsDefault.next(response);
                return response;
            });

    }

    public CreditCardSetActive(request: CreditCardSetActiveRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'CreditCardSetActive';

        return this.prepPATCH<string>(referalMethod, request, this.baseUrl, ssApiUrls.CCard_SetActive)
            .map(response => {
                this.onCreditCardSetActive.next(response);
                return response;
            });

    }

    public CreditCardHide(request: CreditCardSetHiddenRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'CreditCardHide';

        return this.prepPATCH<string>(referalMethod, request, this.baseUrl, ssApiUrls.CCard_SetHidden)
            .map(response => {
                this.onCreditCardSetHidden.next(response);
                return response;
            });

    }


    // GIS

    public GetGISOrderHistory(): Observable<IBaseResponse<GISOrderHistoryItemArray>> {

        let referalMethod = 'OrderHistory';

        return this.prepGet<GISOrderHistoryItemArray>(referalMethod, this.baseUrl, ssApiUrls.GIS_OrderHistory)
            .map(response => {
                this.onGISOrderHistory.next(response);
                return response;
            });

    }

    public DeleteGIS(gisID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'DeleteGIS';

        return this.prepDelete<string>(referalMethod, this.baseUrl, ssApiUrls.GIS_DeleteGIS, gisID.toString())
            .map(response => {
                this.onGISDeleteGIS.next(response);
                return response;
            });

    }

    public SwapGISCreditType(gisID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'SwapGISCreditType';

        return this.prepGet<string>(referalMethod, this.baseUrl, ssApiUrls.GIS_SwapGISCreditType, gisID.toString())
            .map(response => {
                this.onGISSwapGISCreditType.next(response);
                return response;
            });

    }

    public GISSinglePurchaseRefund(request: GISPurchaseRefundRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'GISSinglePurchaseRefund';

        return this.prepPATCH<string>(referalMethod, request, this.baseUrl, ssApiUrls.GIS_SinglePurchaseRefund)
            .map(response => {
                this.onGISSinglePurchaseRefund.next(response);
                return response;
            });

    }

    public GISAddFreeBundleCredits(request: AddFreeGISBundleCreditsRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'GISAddFreeBundleCredits';

        return this.prepPATCH<string>(referalMethod, request, this.baseUrl, ssApiUrls.GIS_AddFreeBundleCredits)
            .map(response => {
                this.onGISAddFreeBundleCredits.next(response);
                return response;
            });

    }

    public GISOrderGISBundle(request: OrderGISBundleRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'GISOrderGISBundle';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.GIS_OrderGISBundle)
            .map(response => {
                this.onGISOrderGIsBundle.next(response);
                return response;
            });

    }

    public GISAddonPurchase(request: GisAddonPurchaseRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'GISAddonPurchase';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.GIS_AddonPurchase)
            .map(response => {
                this.onGISAddonPurchase.next(response);
                return response;
            });

    }
    

    public GISUpdateMemberUsageLog(request: UpdateMemberUsageLogRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'UpdateMemberUsageLog';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.GIS_UpdateMemberUsageLog)
            .map(response => {
                this.onGISUpdateMemberUsageLog.next(response);
                return response;
            });

    }


    // history

    public AdminBrowseLogs(maxResults: number): Observable<IBaseResponse<AdminBrowseLogItemArray>> {

        let referalMethod = 'AdminBrowseLogs';

        return this.prepGet<AdminBrowseLogItemArray>(referalMethod, this.baseUrl, ssApiUrls.History_AdminBroseLogs, maxResults.toString())
            .map(response => {
                this.onHistoryAdminBrowseLogs.next(response);
                return response;
            });

    }

    public GlobalAdminBrowseLogs(request: GlobalAdminBrowseLogsRequest): Observable<IBaseResponse<AdminBrowseLogItemArray>> {

        let referalMethod = 'GlobalAdminBrowseLogs';

        return this.prepPOST<AdminBrowseLogItemArray>(referalMethod, request, this.baseUrl, ssApiUrls.History_GlobalAdminBroseLogs)
        .map(response => {
            this.onHistoryGlobalAdminBrowseLogs.next(response);
            return response;
        });

    }


    // search

    public SearchFull(input: string): Observable<IBaseResponse<FullSearchResponse>> {

        let referalMethod = 'SearchFull';
        let url = ssApiUrls.Search_Full + '/' + input;

        return this.prepGet<FullSearchResponse>(referalMethod, this.baseUrl, url)
            .map(response => {
                this.onSearchFull.next(response);
                return response;
            });

    }

    public SearchAdvanced(request: AdvancedSearchItem): Observable<IBaseResponse<GlobalSearchResults<AdvancedSearchResultMemberItemArray>>> {

        let referalMethod = 'SearchAdvanced';

        return this.prepPOST<GlobalSearchResults<AdvancedSearchResultMemberItemArray>>(referalMethod, request, this.baseUrl, ssApiUrls.Search_Advanced)
            .map(response => {

                if (response.Result)
                    AdvancedSearchResultMemberItemArray.FixDates(response.Data.Data);

                this.onSearchAdvanced.next(response);
                return response;
            });

    }

    public NewSearchPreset(request: NewSearchPresetRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'NewSearchPreset';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Search_NewSearchPreset)
            .map(response => {

                this.onSearchNewSearchPreset.next(response);
                return response;
            });
    }

    public RepeatAdminSearch(input: number): Observable<IBaseResponse<GlobalSearchResults<AdvancedSearchResultMemberItemArray>>> {

        let referalMethod = 'RepeatAdminSearch';
        let url = ssApiUrls.Search_RepeatAdminSearch + '/' + input;

        return this.prepGet<GlobalSearchResults<AdvancedSearchResultMemberItemArray>>(referalMethod, this.baseUrl, url)
            .map(response => {

                if (response.Result)
                    AdvancedSearchResultMemberItemArray.FixDates(response.Data.Data);

                this.onSearchRepeatAdminSearch.next(response);
                return response;
            });

    }

    public GetAdminSearchHistory(): Observable<IBaseResponse<AdminSearchItemArray>> {

        let referalMethod = 'GetAdminSearchHistory';

        return this.prepGet<AdminSearchItemArray>(referalMethod, this.baseUrl, ssApiUrls.Search_GetAdminSearchHistory)
            .map(response => {
                this.onSearchGetAdminSearchHistory.next(response);
                return response;
            });
    }

    public GetAdminSearchPresets(): Observable<IBaseResponse<AdminSearchItemArray>> {

        let referalMethod = 'GetAdminSearchPresets';

        return this.prepGet<AdminSearchItemArray>(referalMethod, this.baseUrl, ssApiUrls.Search_GetAdminSearchPresets)
            .map(response => {
                this.onSearchGetAdminSearchPresets.next(response);
                return response;
            });
    }


    public SearchHomePageProductBreakdown(request: SearchHomePageProductBreakdownRequest): Observable<IBaseResponse<GlobalSearchResults<AdvancedSearchResultMemberItemArray>>> {

        let referalMethod = 'HomePageProductBreakdown';

        return this.prepPOST<GlobalSearchResults<AdvancedSearchResultMemberItemArray>>(referalMethod, request, this.baseUrl, ssApiUrls.Search_HomePageProductBreakdown)
            .map(response => {

                if (response.Result)
                    AdvancedSearchResultMemberItemArray.FixDates(response.Data.Data);

                this.onSearchAdvanced.next(response);
                return response;
            });

    }

    public SearchHomePageVersionBreakdown(request: SearchHomePageVersionBreakdownRequest): Observable<IBaseResponse<GlobalSearchResults<AdvancedSearchResultMemberItemArray>>> {

        let referalMethod = 'HomePageVersionBreakdown';

        return this.prepPOST<GlobalSearchResults<AdvancedSearchResultMemberItemArray>>(referalMethod, request, this.baseUrl, ssApiUrls.Search_HomePageVersionBreakdown)
            .map(response => {

                if (response.Result)
                    AdvancedSearchResultMemberItemArray.FixDates(response.Data.Data);

                this.onSearchAdvanced.next(response);
                return response;
            });

    }

    public DeleteAdminSearch(AdminsearchID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'DeleteAdminSearch';

        return this.prepDelete<string>(referalMethod, this.baseUrl, ssApiUrls.Search_DeleteAdminSearch, AdminsearchID.toString())
            .map(response => {
                this.onDeleteAdminSearch.next(response);
                return response;
            });

    }

    // member
    public MemberUnlockLogin(request: UnlockLoginRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'MemberUnlockLogin';

        return this.prepPATCH<string>(referalMethod, request, this.baseUrl, ssApiUrls.Member_UnlockLogin)
            .map(response => {
                this.onMemberUnlockLogin.next(response);
                return response;
            });

    }

    public TransferChildToMember(request: TransferChildToMemberRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'TransferChildToMember';

        return this.prepPATCH<string>(referalMethod, request, this.baseUrl, ssApiUrls.Transfer_Child_To_Member)
            .map(response => {
                this.onTransferChildToMember.next(response);
                return response;
            });

    }


    public TransformDesignerToMember(request: TransformDesignerToMemberRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'TransformDesignerToMemberRequest';

        return this.prepPATCH<string>(referalMethod, request, this.baseUrl, ssApiUrls.Member_TransformDesignerToMember)
            .map(response => {
                this.onMemberTransformDesignerToMember.next(response);
                return response;
            });

    }

    public ForceChildToMember(request: ForceChildToMemberRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'ForceChildToMember';

        return this.prepPATCH<string>(referalMethod, request, this.baseUrl, ssApiUrls.Force_Child_To_Member)
            .map(response => {
                this.onForceChildToMember.next(response);
                return response;
            });

    }

    public MemberRequestReview(memberID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'RequestReview';

        return this.prepGet<string>(referalMethod, this.baseUrl, ssApiUrls.Member_RequestReview, memberID.toString())
            .map(response => {
                this.onMemberRequestReview.next(response);
                return response;
            });

    }

    public AISummarizeActivity(memberID: number): Observable<IBaseResponse<ActivitySummaryResponse>> {

        let referalMethod = 'AISummarizeActivity';

        return this.prepGet<ActivitySummaryResponse>(referalMethod, this.baseUrl, ssApiUrls.Member_AISummarizeActivity, memberID.toString())
            .map(response => {
                this.onMemberSummarizeActivity.next(response);
                return response;
            });

    }


    public AIProofreadNote(request: ProofreadNoteRequest): Observable<IBaseResponse<ProofreadNoteResponse>> {

        let referalMethod = 'AIProofreadNote';

        return this.prepPOST<ProofreadNoteResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Member_AIProofreadNote)
            .map(response => {
                this.onMemberProofreadNote.next(response);
                return response;
            });

    }

    public MemberDelete(memberID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'MemberDelete';

        return this.prepDelete<string>(referalMethod, this.baseUrl, ssApiUrls.Member_Delete, memberID.toString())
            .map(response => {
                this.onMemberDelete.next(response);
                return response;
            });

    }

    public MemberMerge(request: MemberMergeRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'MemberMerge';

        return this.prepPATCH<string>(referalMethod, request, this.baseUrl, ssApiUrls.Member_Merge)
            .map(response => {
                this.onMemberMerge.next(response);
                return response;
            });

    }

    public MemberAdd(request: AddMemberRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'MemberAdd';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Member_Add)
            .map(response => {
                this.onMemberAdd.next(response);
                return response;
            });

    }


    // licensing

    public ClearYardDeviceID(licenseID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'ClearYardDeviceID';
        let url = ssApiUrls.Licensing_ClearYardDeviceID + licenseID;

        return this.prepPATCH<string>(referalMethod, undefined, this.baseUrl, url)
            .map(response => {

                this.onLicenseClearYardDeviceID.next(response);
                return response;
            });

    }

    public LicenseFull(input: string): Observable<IBaseResponse<LicenseFullResponse>> {

        let referalMethod = 'LicenseFull';
        let url = ssApiUrls.Licensing_Full + input;

        return this.prepGet<LicenseFullResponse>(referalMethod, this.baseUrl, url)
            .map(response => {

                LicenseFullResponse.FixDates(response.Data);
                this.onLicensingFull.next(response);
                return response;
            });

    }

    public FileUploadsByMember(memberID: number): Observable<IBaseResponse<FileUploadItemArray>> {

        let referalMethod = 'FileUploads';
        let url = ssApiUrls.Licensing_FileUploads + memberID.toString();

        return this.prepGet<FileUploadItemArray>(referalMethod, this.baseUrl, url)
            .map(response => {

                FileUploadItemArray.FixDates(response.Data);
                this.onLicenseFileUploads.next(response);
                return response;
            });
    }

    public LicenseEdit(request: ILicenseEditRequest): Observable<IBaseResponse<String>> {
        let referalMethod = 'LicenseEdit';

        return this.prepPOST<String>(referalMethod, request, this.baseUrl, ssApiUrls.Licensing_Edit)
            .map(response => {
                this.onLicenseEdit.next(response);
                return response;
            });
	}
	
	
	public EditTransferDetails(request: LicenseEditTransferDetailsRequest): Observable<IBaseResponse<String>> {
        let referalMethod = 'LicenseEditTransferDetails';

        return this.prepPOST<String>(referalMethod, request, this.baseUrl, ssApiUrls.Licensing_EditTransferDetails)
            .map(response => {
                this.onLicenseEditTransferDetails.next(response);
                return response;
            });
	}
	

    public LicenseAdd(request: AddLicenseRequest): Observable<IBaseResponse<string>> {
        let referalMethod = 'LicenseAdd';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Licensing_Add)
            .map(response => {
                this.onLicensingAdd.next(response);
                return response;
            });
    }

    public LicenseGetNewSubscriptionData(memberID: number): Observable<IBaseResponse<NewSubscriptionDataResponse>> {

        let referalMethod = 'LicenseGetNewSubscriptionData';
        let url = ssApiUrls.Licensing_GetNewSubscriptionData + memberID;

        return this.prepGet<NewSubscriptionDataResponse>(referalMethod, this.baseUrl, url)
            .map(response => {

                this.onLicenseGetNewSubscriptionData.next(response);
                return response;
            });

    }

    public LicenseReActivate(request: ReactivateLicenseRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'LicenseReActivate';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Licensing_ReActivate)
            .map(response => {

                this.onLicenseReActivate.next(response);
                return response;
            });

    }

    public LicenseReActivateSimulation(licenseKey: string): Observable<IBaseResponse<LicenseReactivateSimulationResponse>> {

        let referalMethod = 'LicenseReActivateSimulation';
        let url = ssApiUrls.Licensing_ReActivate_Simulation + licenseKey;

        return this.prepGet<LicenseReactivateSimulationResponse>(referalMethod, this.baseUrl, url)
            .map(response => {

                if (response.Result)
                    LicenseReactivateSimulationResponse.FixDate(response.Data)

                this.onLicenseReActivateSimulation.next(response);
                return response;
            });

    }

    public LicenseReActivatev2(request: ReactivateLicenseRequestv2): Observable<IBaseResponse<string>> {

        let referalMethod = 'LicenseReActivatev2';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Licensing_ReActivatev2)
            .map(response => {

                this.onLicenseReActivatev2.next(response);
                return response;
            });

    }

    public LicenseReActivateSimulationv2(request: ReactivateSimulationRequestv2): Observable<IBaseResponse<LicenseReactivateSimulationResponsev2>> {

        let referalMethod = 'ReActivateSimulationv2';

        return this.prepPOST<LicenseReactivateSimulationResponsev2>(referalMethod, request, this.baseUrl, ssApiUrls.Licensing_ReActivate_Simulationv2)
            .map(response => {

                if (response.Result)
                    LicenseReactivateSimulationResponse.FixDate(response.Data)

                this.onLicenseReActivateSimulationv2.next(response);
                return response;
            });

    }

    public LicenseTransferMember(request: LicenseTransferMemberRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'LicenseTransferMember';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Licensing_LicenseTransferMember)
            .map(response => {

                this.onLicensingLicenseTransferMember.next(response);
                return response;
            });

    }

    public ReassignAndNotify(request: ReassignLicenseRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'ReassignAndNotify';

        return this.prepPATCH<string>(referalMethod, request, this.baseUrl, ssApiUrls.Licensing_Reassign)
            .map(response => {

                this.onLicenseReassignAndNotify.next(response);
                return response;
            });

    }

    public GetLicenseReport(request: LicenseReportRequest): Observable<IBaseResponse<LicenseReportItemArray>> {

        let referalMethod = 'GetLicenseReport';

        return this.prepPOST<LicenseReportItemArray>(referalMethod, request, this.baseUrl, ssApiUrls.Licensing_GetLicenseReport)
            .map(response => {

                this.onLicenseGetLicenseReport.next(response);
                return response;
            });
    }


	public GetLicensePCs(licenseID: number): Observable<IBaseResponse<LicensePCItemArray>> {

        let referalMethod = 'GetLicensePCs';
        let url = ssApiUrls.Licensing_GetLicensePCs + licenseID.toString();

        return this.prepGet<LicensePCItemArray>(referalMethod, this.baseUrl, url)
            .map(response => {
                this.onLicenseGetLicensePCs.next(response);
                return response;
            });
    }


    public DeleteLicensePC(licensePCID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'DeleteLicensePC';

        return this.prepDelete<string>(referalMethod, this.baseUrl, ssApiUrls.Licensing_DeleteLicensePC, licensePCID.toString())
            .map(response => {

                this.onLicenseDeleteLicensePC.next(response);
                return response;

            });

    }   

    public MakeLicensePCInactive(licensePCID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'MakeLicensePCInactive';

        return this.prepPATCH<string>(referalMethod, null, this.baseUrl, ssApiUrls.Licensing_MakeLicensePCInactive + licensePCID.toString())
            .map(response => {

                this.onLicenseMakeLicensePCInactive.next(response);
                return response;
            });

    }

    public MakeLicensePCUnavailable(licensePCID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'MakeLicensePCUnavailable';

        return this.prepPATCH<string>(referalMethod, null, this.baseUrl, ssApiUrls.Licensing_MakeLicensePCUnavailable + licensePCID.toString())
            .map(response => {

                this.onLicenseMakeLicensePCUnavailable.next(response);
                return response;
            });

	}
	
    public MakeLicensePCAvailable(licensePCID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'MakeLicensePCAvailable';

        return this.prepPATCH<string>(referalMethod, null, this.baseUrl, ssApiUrls.Licensing_MakeLicensePCAvailable + licensePCID.toString())
            .map(response => {

                this.onLicenseMakeLicensePCAvailable.next(response);
                return response;
            });

	}

    // email
    public GetEmailTemplatesBasicsAndFrom(): Observable<IBaseResponse<TemplatesAndFromResponse>> {

        let referalMethod = 'GetEmailTemplatesBasicsAndFrom';

        return this.prepGet<TemplatesAndFromResponse>(referalMethod, this.baseUrl, ssApiUrls.Email_TemplatesAndFrom)
            .map(response => {
                this.onEmailTemplatesAndFrom.next(response);
                return response;
            });

    }

    public GetEmailTemplateHTML(id: number): Observable<IBaseResponse<EmailTemplateFullItem>> {

        let referalMethod = 'GetEmailTemplateHTML';
        let url = ssApiUrls.Email_TemplateHTML + id;

        return this.prepGet<EmailTemplateFullItem>(referalMethod, this.baseUrl, url)
            .map(response => {
                this.onEmailTemplateHTML.next(response);
                return response;
            });

    }

    public GetEmailLogs(memberID: number): Observable<IBaseResponse<EmailLogItemBasicArray>> {

        let referalMethod = 'GetEmailLogs';
        let url = ssApiUrls.Email_GetEmailLogs + memberID;

        return this.prepGet<EmailLogItemBasicArray>(referalMethod, this.baseUrl, url)
            .map(response => {
                this.onEmailGetEmailLogs.next(response);
                return response;
            });

    }

    public GetEmailLog(logID: number): Observable<IBaseResponse<EmailLogItemBasic>> {

        let referalMethod = 'GetEmailLog';
        let url = ssApiUrls.Email_GetEmailLog + logID;

        return this.prepGet<EmailLogItemBasic>(referalMethod, this.baseUrl, url)
            .map(response => {
                this.onEmailGetEmailLog.next(response);
                return response;
            });

    }

    public SendEmail(request: SendEmailRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'SendEmail';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Email_SendEmail)
            .map(response => {

                this.onSendEmail.next(response);
                return response;
            });

    }

    public ResendEmail(request: ResendEmailRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'ResendEmail';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Email_ResendEmail)
            .map(response => {

                this.onResendEmail.next(response);
                return response;
            });

    }

    public InvoiceRefundableStatus(request: InvoiceRefundRequest): Observable<IBaseResponse<InvoiceRefundableStatusResponse>> {

        let referalMethod = 'InvoiceRefundableStatus';

        return this.prepPOST<InvoiceRefundableStatusResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Billing_GetInvoiceRefundableStatus)
            .map(response => {

                this.onBillingInvoiceRefundableStatus.next(response);
                return response;
            });

    }

    public InvoiceRefund(request: InvoiceRefundRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'InvoiceRefund';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Billing_RefundInvoice)
            .map(response => {

                this.onBillingInvoiceRefund.next(response);
                return response;
            });

    }

    public AddEmailTemplate(request: AddEmailTemplateRequest): Observable<IBaseResponse<number>> {
        let referalMethod = 'AddEmailTemplate';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Email_AddEmailTemplate)
            .map(response => {

                this.onEmailAddEmailTemplate.next(response);
                return response;
            }); ;
    }


    public UpdateEmailTemplate(request: UpdateEmailTemplateRequest): Observable<IBaseResponse<number>> {
        let referalMethod = 'UpdateEmailTemplate';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Email_UpdateEmailTemplate)
            .map(response => {

                this.onEmailUpdateEmailTemplate.next(response);
                return response;
            }); ;
    }


	public DuplicateEmailTemplate(request: DuplicateEmailTemplateRequest): Observable<IBaseResponse<number>> {
        let referalMethod = 'DuplicateEmailTemplate';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Email_DuplicateEmailTemplate)
            .map(response => {

                this.onEmailDuplicateEmailTemplate.next(response);
                return response;
            });
	}
	


    // billing

    public GetBillingDiscounts(): Observable<IBaseResponse<BillingDiscountsArray>> {

        let referalMethod = 'GetBillingDiscounts';

        return this.prepGet<BillingDiscountsArray>(referalMethod, this.baseUrl, ssApiUrls.Billing_GetDiscounts)
            .map(response => {

                this.onBillingGetDiscounts.next(response);

                return response;
            });

    }

    public GetMemberCredits(): Observable<IBaseResponse<BillingCreditsArray>> {

        let referalMethod = 'GetMemberCredits';

        return this.prepGet<BillingCreditsArray>(referalMethod, this.baseUrl, ssApiUrls.Billing_GetMemberCredits)
            .map(response => {

                this.onBillingGetMemberCredits.next(response);

                return response;
            });

    }

    public GetToChargeItems(request: GetToChargeRequest): Observable<IBaseResponse<ToChargeItemArray>> {

        let referalMethod = 'GetToCharge';

        return this.prepPOST<ToChargeItemArray>(referalMethod, request, this.baseUrl, ssApiUrls.Billing_GetToCharge)
            .map(response => {

                this.onBillingGetToCharge.next(response);

                return response;
            });

    }


	public RetryAutomatedBilling(): Observable<IBaseResponse<AutomationBillingHistoryItemArray>> {

        let referalMethod = 'RetryAutomatedBilling';

        return this.prepGet<AutomationBillingHistoryItemArray>(referalMethod, this.baseUrl, ssApiUrls.Billing_RetryAutomatedBilling)
            .map(response => {

                this.onBillingRetryAutomatedBilling.next(response);

                return response;
            });

    }


    public GetAutomationBillingHistory(request: GetAutomationBillingHistoryRequest): Observable<IBaseResponse<AutomationBillingHistoryItemArray>> {

        let referalMethod = 'GetAutomationBillingHistory';

        return this.prepPOST<AutomationBillingHistoryItemArray>(referalMethod, request, this.baseUrl, ssApiUrls.Billing_GetAutomationBillingHistory)
            .map(response => {

                this.onBillingGetAutomationBillingHistory.next(response);

                return response;
            });

    }

    public GetInvoicesByDate(request: GetInvoicesByDateRequest): Observable<IBaseResponse<InvoiceArray>> {
        let referalMethod = 'GetInvoicesByDate';

        return this.prepPOST<InvoiceArray>(referalMethod, request, this.baseUrl, ssApiUrls.Billing_GetInvoicesByDate)
            .map(response => {

                if (response.Data != undefined)
                    InvoiceArray.FixDates(response.Data);

                this.onBillingGetInvoicesByDate.next(response);

                return response;
            });

    }

    public GetLicenseInvoices(licenseID: number): Observable<IBaseResponse<InvoiceArray>> {

        let referalMethod = 'GetLicenseInvoices';

        return this.prepGet<InvoiceArray>(referalMethod, this.baseUrl, ssApiUrls.Billing_LicenseInvoices, licenseID.toString())
            .map(response => {

                if (response.Data != undefined)
                    InvoiceArray.FixDates(response.Data);

                this.onBillingLicenseInvoices.next(response);

                return response;
            });

    }

    public GetInvoices(memberID: string): Observable<IBaseResponse<InvoiceArray>> {

        let referalMethod = 'GetInvoices';
        let url = ssApiUrls.Billing_Invoices + memberID;

        return this.prepGet<InvoiceArray>(referalMethod, this.baseUrl, url)
            .map(response => {

                if (response.Data != undefined)
                    InvoiceArray.FixDates(response.Data);

                this.onBillingInvoices.next(response);

                return response;
            });

    }

    public GetInvoicePaymentGatewayLogs(invoiceID: number): Observable<IBaseResponse<InvoicePaymentGatewayLogArray>> {

        let referalMethod = 'GetInvoicePaymentGatewayLogs';
        let url = ssApiUrls.Billing_InvoicePaymentGatewayLogs + '/' + invoiceID;

        return this.prepGet<InvoicePaymentGatewayLogArray>(referalMethod, this.baseUrl, url)
            .map(response => {

                if (response.Data != undefined)
                    InvoicePaymentGatewayLogArray.FixDates(response.Data);

                this.onInvoicePaymentGatewayLogs.next(response);

                return response;
            });

    }

    public DeleteInvoices(invoiceID: string): Observable<IBaseResponse<string>> {

        let referalMethod = 'DeleteInvoices';

        return this.prepDelete<string>(referalMethod, this.baseUrl, ssApiUrls.Billing_DeleteInvoice, invoiceID)
            .map(response => {

                this.onBillingDeleteInvoice.next(response);
                return response;

            });

    }

    public AddTaxInvoice(invoiceID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'AddTaxInvoice';

        return this.prepGet<string>(referalMethod, this.baseUrl, ssApiUrls.Billing_AddTaxInvoice, invoiceID.toString())
            .map(response => {

                this.onBillingAddTaxInvoice.next(response);
                return response;

            });

    }

    public RemoveTaxInvoice(invoiceID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'RemoveTaxInvoice';

        return this.prepGet<string>(referalMethod, this.baseUrl, ssApiUrls.Billing_RemoveTaxInvoice, invoiceID.toString())
            .map(response => {

                this.onBillingRemoveTaxInvoice.next(response);
                return response;

            });

    }    
    public DeleteAutomationBillingActive(automationBillingActiveID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'DeleteAutomationBillingActive';

        return this.prepDelete<string>(referalMethod, this.baseUrl, ssApiUrls.Billing_DeleteAutomationBillingActive, automationBillingActiveID.toString())
            .map(response => {

                this.onBillingDeleteAutomationBillingActive.next(response);
                return response;

            });

    }

    public GetCredit(memberID: string): Observable<IBaseResponse<CreditItemArray>> {

        let referalMethod = 'GetCredit';
        let url = ssApiUrls.Billing_GetCredit + memberID;

        return this.prepGet<CreditItemArray>(referalMethod, this.baseUrl, url)
            .map(response => {

                if (response.Data != undefined)
                    CreditItemArray.FixDates(response.Data);

                this.onBillingGetCredit.next(response);

                return response;
            });

    }


    public AddInvoice(request: AddInvoiceRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'AddInvoice';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Billing_AddInvoice)
            .map(response => {

                this.onBillingAddInvoice.next(response);
                return response;
            });

    }


    public EditInvoice(request: EditInvoiceRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'EditInvoice';

        return this.prepPATCH<string>(referalMethod, request, this.baseUrl, ssApiUrls.Billing_EditInvoice)
            .map(response => {

                this.onBillingEditInvoice.next(response);
                return response;
            });

    }


    public TryInvoicePayment(request: InvoicePaymentRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'TryInvoicePayment';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Billing_TryInvoicePayment)
            .map(response => {

                this.onBillingTryInvoicePayment.next(response);
                return response;
            });

    }


    public AddCredit(request: AddCreditRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'AddCredit';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Billing_AddCredit)
            .map(response => {

                this.onBillingAddCredit.next(response);
                return response;
            });

    }

    public AddDiscountItem(request: AddDiscountItemRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'AddDiscountItem';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Billing_AddDiscountItem)
            .map(response => {

                this.onBillingAddDiscountItem.next(response);
                return response;
            });

    }

    public EditDiscountItem(request: EditDiscountItemRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'EditDiscountItem';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Billing_EditDiscountItem)
            .map(response => {

                this.onBillingEditDiscountItem.next(response);
                return response;
            });

    }

    public DeleteDiscountItem(request: DeleteDiscountItemRequest): Observable<IBaseResponse<string>> {
        let referalMethod = 'DeleteDiscountItem';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Billing_DeleteDiscountItem).map(response => {

            this.onBillingDeleteDiscountItem.next(response);
            return response

        })
    }

    public DeleteCredit(request: DeleteCreditRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'DeleteCredit';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Billing_DeleteCredit)
            .map(response => {

                this.onBillingDeleteCredit.next(response);
                return response;
            });

    }


    public GetGatewayLogParses(request: GetGatewayLogParsesRequest): Observable<IBaseResponse<GatewayLogParseArray>> {

        let referalMethod = 'GetGatewayLogParses';

        return this.prepPOST<GatewayLogParseArray>(referalMethod, request, this.baseUrl, ssApiUrls.Billing_GetGatewayLogParses)
            .map(response => {

                this.onBillingGetGatewayLogParses.next(response);
                return response;
            });

    }

    // notes

    public getConversationThreadMessages(conversationThreadID: number): Observable<IBaseResponse<ConversationThreadMessageArray>> {

        let referalMethod = 'getConversationThreadMessages';

        return this.prepGet<any>(referalMethod, this.baseUrl, ssApiUrls.Note_GetConversationThreadMessages, conversationThreadID.toString())
            .map(response => {
                ConversationThreadMessageArray.FixDates(response.Data);
                this.onGetConversationThreadMessages.next(response);
                return response;
            });
    }


    public getNotesHistory(noteID: number): Observable<IBaseResponse<NoteHistoryItemArray>> {

        let referalMethod = 'getNotesHistory';

        return this.prepGet<any>(referalMethod, this.baseUrl, ssApiUrls.Note_History, noteID.toString())
            .map(response => {
                NoteHistoryItemArray.FixDates(response.Data);
                this.onGetNoteHistory.next(response);
                return response;
            });
    }

    public getNotesByType(type: NoteTypes, relationID: number): Observable<IBaseResponse<NoteArray>> {

        let referalMethod = 'getNotesByType';
        let data = type + '/' + relationID;

        return this.prepGet<any>(referalMethod, this.baseUrl, ssApiUrls.Note_NotesByType, data)
            .map(response => {
                NoteArray.FixDates(response.Data);
                this.onGetNotesByType.next(response);
                return response;
            });
    }

    public getNote(noteID: number): Observable<IBaseResponse<Note>> {

        let referalMethod = 'getNote';

        return this.prepGet<any>(referalMethod, this.baseUrl, ssApiUrls.Note_Get, noteID.toString())
            .map(response => {

                Note.FixDates(response.Data);
                this.onGetNote.next(response);

                return response;
            });
    }

    public getAllNotesForMember(memberID: number): Observable<IBaseResponse<NotesAll>> {

        let referalMethod = 'getAllNotesForMember';

        return this.prepGet<NotesAll>(referalMethod, this.baseUrl, ssApiUrls.Note_All, memberID.toString())
            .map(response => {

                NotesAll.FixDates(response.Data);
                this.onSearchAllNotesForMember.next(response);

                return response;
            }); ;
    }

    public getAllNotesForFamily(memberID: number): Observable<IBaseResponse<NotesAll>> {

        let referalMethod = 'Family';

        return this.prepGet<NotesAll>(referalMethod, this.baseUrl, ssApiUrls.Note_Family, memberID.toString())
            .map(response => {

                NotesAll.FixDates(response.Data);
                this.onSearchAllNotesForFamily.next(response);

                return response;
            }); ;
    }

    public NoteEdit(request: INoteEditRequest): Observable<IBaseResponse<String>> {

        let referalMethod = 'NoteEdit';
        return this.prepPOST<String>(referalMethod, request, this.baseUrl, ssApiUrls.Note_Edit)
            .map(response => {
                this.onNoteEdit.next(response);
                return response;
            });

    }

    public NoteAdd(request: INoteAddRequest): Observable<IBaseResponse<String>> {

        let referalMethod = 'NoteAdd';
        return this.prepPOST<String>(referalMethod, request, this.baseUrl, ssApiUrls.Note_Add)
            .map(response => {
                this.onNoteAdd.next(response);
                return response;
            });
    }

    public NoteDelete(noteID: number): Observable<IBaseResponse<String>> {

        let referalMethod = 'NoteDelete';
        return this.prepDelete<String>(referalMethod, this.baseUrl, ssApiUrls.Note_Delete, noteID.toString())
            .map(response => {
                this.onNoteDelete.next(response);
                return response;
            });
    }


    public getMemberDashboard(id: number): Observable<IBaseResponse<MemberDashboard>> {

        let referalMethod = 'getMemberDashboard';

        return this.prepGet<MemberDashboard>(referalMethod, this.baseUrl, ssApiUrls.Member_Dashboard, id.toString())
            .map(response => {

                if (response.Result)
                    MemberDashboard.FixDates(response.Data);

                this.onMemberDashboard.next(response);
                return response;
            }); ;
    }


    public getTimeConditions(): Observable<IBaseResponse<TimeGroupArray>> {

        let referalMethod = 'getTimeConditions';

        return this.prepGet<TimeGroupArray>(referalMethod, this.baseUrl, ssApiUrls.Admin_TimeConditions)
            .map(response => {

                this.onAdminTimeConditions.next(response);
                return response;
            }); ;
    }


    public SearchLicenseBasic(key: string): Observable<IBaseResponse<LicenseSearchResponseArray>> {

        let referalMethod = 'SearchLicenseBasic';

        return this.prepGet<LicenseSearchResponseArray>(referalMethod, this.baseUrl, ssApiUrls.Search_License_Basic)
            .map(response => {

                this.onSearchLicenseBasic.next(response);
                return response;
            }); ;
    }

    public getAvailableTags(): Observable<IBaseResponse<TagArray>> {

        let referalMethod = 'getAvailableTags';

        return this.prepGet<TagArray>(referalMethod, this.baseUrl, ssApiUrls.Tag_AvailableTags)
            .map(response => {
                this.onSearchTagsAllTypes.next(response);
                return response;
            }); ;
    }


    public SearchLicenseFull(key: string): Observable<IBaseResponse<LicenseFullResponse>> {

        let referalMethod = 'SearchLicenseFull';

        return this.prepGet<LicenseFullResponse>(referalMethod, this.baseUrl, ssApiUrls.Search_License_Full)
            .map(response => {

                LicenseFullResponse.FixDates(response.Data);
                this.onSearchLicenseFull.next(response);
                return response;
            }); ;
    }

    public MemberFull(id: number): Observable<IBaseResponse<Member>> {

        let referalMethod = 'MemberFull';

        return this.prepGet<Member>(referalMethod, this.baseUrl, ssApiUrls.Member_Full, id.toString())
            .map(response => {

                this.onMemberFull.next(response);
                return response;
            }); ;
    }

    public getUpgradeLogs(licenseID: number): Observable<IBaseResponse<LicenseUpgradeLogArray>> {

        let referalMethod = 'getUpgradeLogs';

        return this.prepGet<LicenseUpgradeLogArray>(referalMethod, this.baseUrl, ssApiUrls.Licensing_UpgradeLogs, licenseID.toString())
            .map(response => {

                this.onAPIURLSearchUpgradeLogs.next(response);
                return response;
            }); ;
    }

    public getCCards(memberID: number): Observable<IBaseResponse<CreditCardArray>> {

        let referalMethod = 'getCCards';

        return this.prepGet<CreditCardArray>(referalMethod, this.baseUrl, ssApiUrls.CCard_Member, memberID.toString())
            .map(response => {

                this.onSearchCCards.next(response);
                return response;
            }); ;
    }

    public getUsableCCards(memberID: number): Observable<IBaseResponse<CreditCardArray>> {

        let referalMethod = 'getUsableCCards';

        return this.prepGet<CreditCardArray>(referalMethod, this.baseUrl, ssApiUrls.CCard_MemberUsable, memberID.toString())
            .map(response => {

                this.onSearchUsableCCards.next(response);
                return response;
            }); ;
    }

    public SearchMemberTags(memberID: number): Observable<IBaseResponse<TagArray>> {

        let referalMethod = 'SearchMemberTags';

        return this.prepGet<TagArray>(referalMethod, this.baseUrl, ssApiUrls.Search_Member_Tags, memberID.toString())
            .map(response => {

                this.onSearchMemberTags.next(response);
                return response;
            }); ;
    }

    public MemberGISUsageLog(memberID: number): Observable<IBaseResponse<GISUsageLogArray>> {
        // FIX IT!!!
        let referalMethod = 'MemberGISUsageLog';

        return this.prepGet<GISUsageLogArray>(referalMethod, this.baseUrl, ssApiUrls.GIS_MemberCreditsUsage, memberID.toString())
            .map(response => {

                this.onMemberGISCreditsUsage.next(response);
                return response;
            }); ;
    }

    public MemberGISBundleLog(memberID: number): Observable<IBaseResponse<GISBundleLogArray>> {

        let referalMethod = 'MemberGISBundleLog';

        return this.prepGet<GISBundleLogArray>(referalMethod, this.baseUrl, ssApiUrls.GIS_MemberBundlePurchaseLog, memberID.toString())
            .map(response => {
                this.onMemberGISBundleLog.next(response);
                return response;
            });
    }

    public MemberEdit(request: IMemberEditRequest): Observable<IBaseResponse<String>> {

        let referalMethod = 'MemberEdit';

        return this.prepPOST<String>(referalMethod, request, this.baseUrl, ssApiUrls.Member_Edit)
            .map(response => {
                this.onMemberEdit.next(response);
                return response;
            });
    }

    public MemberTagsEdit(request: IMemberTagsEditRequest): Observable<IBaseResponse<StringResponse>> {

        let referalMethod = 'MemberTagsEdit';

        return this.prepPOST<StringResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Tag_MemberEdit)
            .map(response => {
                this.onMemberTagsEdit.next(response);
                return response;
            });
    }

    public UpgradeSimulation(request: IUpgradeSimulationRequest): Observable<IBaseResponse<UpgradeSimulation>> {
        let referalMethod = 'UpgradeSimulation';

        return this.prepPOST<UpgradeSimulation>(referalMethod, request, this.baseUrl, ssApiUrls.Billing_UpgradeSimulation)
            .map(response => {
                this.onBillingUpgradeSimulation.next(response);
                return response;
            });
    }


    public getMemberNotes(id: number): Observable<IBaseResponse<NoteArray>> {
        let referalMethod = 'getMemberNotes';

        return this.prepGet<NoteArray>(referalMethod, this.baseUrl, ssApiUrls.Search_Member_Notes, id.toString())
            .map(response => {

                this.onSearchMemberNotes.next(response);
                return response;
            }); ;
    }

    public GetResetPasswordToken(request: GetMemberPasswordResetTokenRequest) {
        let referalMethod = 'GetResetPasswordToken';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Member_GetResetPasswordToken)
            .map(response => {
                this.onGetResetPasswordToken.next(response);
                return response;
            });
    }

    public getPins(adminID: number): Observable<IBaseResponse<PinArray>> {

        let referalMethod = 'SearchPins';

        return this.prepGet<PinArray>(referalMethod, this.baseUrl, ssApiUrls.Pins_ByAdminID, adminID.toString())
            .map(response => {

                this.onGetPins.next(response);
                return response;
            }); ;
    }

    public PinDelete(pinID: number): Observable<IBaseResponse<Number>> {

        let referalMethod = 'PinDelete';

        return this.prepDelete<Number>(referalMethod, this.baseUrl, ssApiUrls.Pins_Delete, pinID.toString())
            .map(response => {

                this.onPinDelete.next(response);

                return response;
            });
    }

    public PinAdd(request: IPinAddRequest): Observable<IBaseResponse<PinItem>> {

        let referalMethod = 'PinAdd';

        return this.prepPOST<PinItem>(referalMethod, request, this.baseUrl, ssApiUrls.Pins_Add)
            .map(response => {
                this.onPinAdd.next(response);
                return response;
            });
    }

    public getPin(pinID: number): Observable<IBaseResponse<PinItem>> {

        let referalMethod = 'SearchPinByID';

        return this.prepGet<PinItem>(referalMethod, this.baseUrl, ssApiUrls.Pins_Get, pinID.toString())
            .map(response => {

                this.onGetPin.next(response);
                return response;
            }); ;
    }



    public AuthenticationCheckCookie(): Observable<IBaseResponse<LoginResponse>> {
        let referalMethod = 'AuthenticationCheckCookie';

        return this.prepGet<LoginResponse>(referalMethod, this.baseUrl, ssApiUrls.Authentication_Check_Cookie)
            .map(response => {

                this.onAuthenticationCheckCookie.next(response);
                return response;
            }); ;
    }



    public SearchTransferLogs(licenseID: number): Observable<IBaseResponse<LicenseTransferLogArray>> {

        let referalMethod = 'TicketOpenNew';

        return this.prepGet<LicenseTransferLogArray>(referalMethod, this.baseUrl, ssApiUrls.Licensing_TransferLogs, licenseID.toString())
            .map(response => {
                this.onSearchTransferLogs.next(response);
                return response;
            })

    }

    public AddOnHistory(licenseID: number): Observable<IBaseResponse<AddOnHistoryItemArray>> {

        let referalMethod = 'AddOnHistory';

        return this.prepGet<AddOnHistoryItemArray>(referalMethod, this.baseUrl, ssApiUrls.Licensing_AddOnHistory, licenseID.toString())
            .map(response => {
                this.onAddOnHistory.next(response);
                return response;
            })

    }

    public AdminLogsByMemberID(memberID: number): Observable<IBaseResponse<AdminLogItemArray>> {

        let referalMethod = 'AdminLogsByMemberID';

        return this.prepGet<AdminLogItemArray>(referalMethod, this.baseUrl, ssApiUrls.AdminLogs_AdminLogsByMemberID, memberID.toString())
            .map(response => {

                if (response.Result)
                    AdminLogItemArray.FixDates(response.Data);

                this.onLogsAdminLogsByMemberID.next(response);
                return response;
            })

    }

    public AdminLogsByTicketID(memberID: number): Observable<IBaseResponse<AdminLogItemArray>> {

        let referalMethod = 'AdminLogsByTicketID';

        return this.prepGet<AdminLogItemArray>(referalMethod, this.baseUrl, ssApiUrls.AdminLogs_AdminLogsByTicketID, memberID.toString())
            .map(response => {

                if (response.Result)
                    AdminLogItemArray.FixDates(response.Data);

                this.onLogsAdminLogsByTicketID.next(response);
                return response;
            })

    }

    public LogsByMemberID(memberID: number): Observable<IBaseResponse<LogsResponse>> {

        let referalMethod = 'LogsByMemberID';

        return this.prepGet<LogsResponse>(referalMethod, this.baseUrl, ssApiUrls.AdminLogs_LogsByMemberID, memberID.toString())
            .map(response => {
                if (response.Result) {

                    if (response.Data.AdminLogs != undefined)
                        AdminLogItemArray.FixDates(response.Data.AdminLogs);

                    if (response.Data.MemberLogs != undefined)
                        MemberLogItemArray.FixDates(response.Data.MemberLogs);

                    if (response.Data.AuthenticationLogs != undefined)
                        AuthenticationLogItemArray.FixDates(response.Data.AuthenticationLogs);
                }

                this.onLogsByMemberID.next(response);
                return response;
            })

    }

    // training

    public GetTrainingClassByID(trainingclassID: number): Observable<IBaseResponse<TrainingClass>> {

        let referalMethod = 'GetTrainingClassByID';

        return this.prepGet<TrainingClass>(referalMethod, this.baseUrl, ssApiUrls.Training_GetTrainingClassByID, trainingclassID.toString())
            .map(response => {
                this.onTrainingClassByID.next(response);
                return response;
            });

    }

    public GetAdminTrainingClasses(): Observable<IBaseResponse<TrainingClassArray>> {

        let referalMethod = 'GetAdminTrainingClasses';

        return this.prepGet<TrainingClassArray>(referalMethod, this.baseUrl, ssApiUrls.Training_GetAdminTrainingClasses)
            .map(response => {
                this.onGetAdminTrainingClasses.next(response);
                return response;
            });

    }

    public GetTrainers(): Observable<IBaseResponse<AdminItemArray>> {

        let referalMethod = 'GetTrainers';

        return this.prepGet<AdminItemArray>(referalMethod, this.baseUrl, ssApiUrls.Training_GetTrainers)
            .map(response => {
                this.onGetTrainers.next(response);
                return response;
            });

    }

    
    public GetAttendanceTracking(request: GetAttendanceTrackingRequest): Observable<IBaseResponse<TrainingAttendanceArray>> {

        let referalMethod = 'GetAttendanceTracking';

        return this.prepPOST<TrainingAttendanceArray>(referalMethod, request, this.baseUrl, ssApiUrls.Training_GetAttendanceTracking)
            .map(response => {
                this.onGetAttendanceTracking.next(response);
                return response;
            });
    }

    public GetTrainingEventBasicsByClassID(request: GetTrainingEventBasicsByClassIDRequest): Observable<IBaseResponse<TrainingEventArray>> {

        let referalMethod = 'GetTrainingEventBasicsByClassID';

        return this.prepPOST<TrainingEventArray>(referalMethod, request, this.baseUrl, ssApiUrls.Training_GetTrainingEventBasicsByClassID)
            .map(response => {
                this.onGetTrainingEventBasicsByClassID.next(response);
                return response;
            });
    }

    public GetAdminTrainingCalendar(request: TrainingCalendarRequest): Observable<IBaseResponse<AdminTrainingCalendarResponse>> {

        let referalMethod = 'GetAdminTrainingCalendarRequest';

        return this.prepPOST<AdminTrainingCalendarResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Training_GetAdminTrainingCalendar)
            .map(response => {
                this.onGetAdminTrainingCalendar.next(response);
                return response;
            });
    }

    public AddTrainingClass(request: AddTrainingClassRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'AddTrainingClass';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Training_AddTrainingClass)
            .map(response => {
                this.onAddTrainingClass.next(response);
                return response;
            });
    }

    public UpdateTrainingClass(request: UpdateTrainingClassRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'UpdateTrainingClass';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Training_UpdateTrainingClass)
            .map(response => {
                this.onUpdateTrainingClass.next(response);
                return response;
            });
    }

    public RescheduleTrainingEvent(request: RescheduleTrainingEventRequest): Observable<IBaseResponse<RescheduleTrainingEventResponse>> {

        let referalMethod = 'RescheduleTrainingEvent';

        return this.prepPOST<RescheduleTrainingEventResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Training_RescheduleTrainingEvent)
            .map(response => {
                this.onRescheduleTrainingEvent.next(response);
                return response;
            });
    }

    public GetTrainingEventByID(trainingeventID: number): Observable<IBaseResponse<TrainingEvent>> {

        let referalMethod = 'GetTrainingEventByID';

        return this.prepGet<TrainingEvent>(referalMethod, this.baseUrl, ssApiUrls.Training_GetTrainingEventByID, trainingeventID.toString())
            .map(response => {
                this.onTrainingEventByID.next(response);
                return response;
            });

    }

    public DeleteTrainingEvent(trainingeventID: number): Observable<IBaseResponse<DeleteTrainingEventResponse>> {

        let referalMethod = 'DeleteTrainingEvent';

        return this.prepDelete<DeleteTrainingEventResponse>(referalMethod, this.baseUrl, ssApiUrls.Training_DeleteTrainingEvent, trainingeventID.toString())
            .map(response => {
                this.onDeleteTrainingEvent.next(response);
                return response;
            });

    }

    public DeleteTrainingClass(trainingclassID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'DeleteTrainingClass';

        return this.prepDelete<string>(referalMethod, this.baseUrl, ssApiUrls.Training_DeleteTrainingClass, trainingclassID.toString())
            .map(response => {
                this.onDeleteTrainingClass.next(response);
                return response;
            });

    }

    public DeleteEmailTemplate(emailtemplateID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'DeleteEmailTemplate';

        return this.prepDelete<string>(referalMethod, this.baseUrl, ssApiUrls.Email_DeleteEmailTemplate, emailtemplateID.toString())
            .map(response => {
                this.onEmailDeleteEmailTemplate.next(response);
                return response;
            });

    }

    public UpdateTrainingEventSubscriptionStatuses(request: UpdateTrainingEventSubscriptionStatusesRequestArray): Observable<IBaseResponse<UpdateTrainingEventSubscriptionStatusesResponse>> {

        let referalMethod = 'UpdateTrainingEventSubscriptionStatuses';

        return this.prepPOST<UpdateTrainingEventSubscriptionStatusesResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Training_UpdateTrainingEventSubscriptionStatuses)
            .map(response => {
                this.onUpdateTrainingEventSubscriptionStatuses.next(response);
                return response;
            });
    }

    public AddTrainingEvent(request: AddTrainingEventRequest): Observable<IBaseResponse<AddTrainingEventResponse>> {

        let referalMethod = 'AddTrainingEvent';

        return this.prepPOST<AddTrainingEventResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Training_AddTrainingEvent)
            .map(response => {
                this.onAddTrainingEvent.next(response);
                return response;
            });
    }

    public UpdateTrainingEvent(request: UpdateTrainingEventRequest): Observable<IBaseResponse<UpdateTrainingEventResponse>> {

        let referalMethod = 'UpdateTrainingEvent';

        return this.prepPOST<UpdateTrainingEventResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Training_UpdateTrainingEvent)
            .map(response => {
                this.onUpdateTrainingEvent.next(response);
                return response;
            });
    }

    public AddTrainingEventSubscription(request: AddTrainingEventSubscriptionOnlyRequest): Observable<IBaseResponse<AddTrainingEventSubscriptionResponse>> {

        let referalMethod = 'AddTrainingEventSubscription';

        return this.prepPOST<AddTrainingEventSubscriptionResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Training_AddTrainingEventSubscription)
            .map(response => {
                this.onAddTrainingEventSubscription.next(response);
                return response;
            });
    }

    public UpdateTrainingEventSubscription(request: UpdateTrainingEventSubscriptionRequest): Observable<IBaseResponse<UpdateTrainingEventSubscriptionResponse>> {

        let referalMethod = 'UpdateTrainingEventSubscription';

        return this.prepPOST<UpdateTrainingEventSubscriptionResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Training_UpdateTrainingEventSubscription)
            .map(response => {
                this.onUpdateTrainingEventSubscription.next(response);
                return response;
            });
    }

    public SendTestEmailsForTrainingEvent(request: SendTestEmailsForTrainingEventRequest): Observable<IBaseResponse<string>> {
        let referalMethod = 'SendTestEmailsForTrainingEvent';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Training_SendTestEmailsForTrainingEvent)
            .map(response => {
                this.onSendTestEmailsForTrainingEvent.next(response);
                return response;
            });
    }

    public SendRealEmailsForTrainingEvent(request: SendRealEmailsForTrainingEventRequest): Observable<IBaseResponse<string>> {
        let referalMethod = 'SendRealEmailsForTrainingEvent';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Training_SendRealEmailsForTrainingEvent)
            .map(response => {
                this.onSendRealEmailsForTrainingEvent.next(response);
                return response;
            });
    }

    public PreviewEmailsForTrainingEvent(request: PreviewEmailsForTrainingEventRequest): Observable<IBaseResponse<TrainingPreviewEmailsResponse>> {
        let referalMethod = 'PreviewEmailsForTrainingEvent';

        return this.prepPOST<TrainingPreviewEmailsResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Training_PreviewEmailsForTrainingEvent)
            .map(response => {
                this.onPreviewEmailsForTrainingEvent.next(response);
                return response;
            });
    }

    public CertificateGenerationForTrainingEventSubscription(trainingEventSubscriptionID: number): Observable<IBaseResponse<TrainingEventSubscriptionCertificateResponse>> {

        let referalMethod = 'CertificateGenerationForTrainingEventSubscription';

        return this.prepGet<TrainingEventSubscriptionCertificateResponse>(referalMethod, this.baseUrl, ssApiUrls.Training_CertificateGenerationForTrainingEventSubscription, trainingEventSubscriptionID.toString())
            .map(response => {
                this.onCertificateGenerationForTrainingEventSubscription.next(response);
                return response;
            });

    }

    public APSPCertificateGenerationForTrainingEventSubscription(trainingEventSubscriptionID: number): Observable<IBaseResponse<TrainingEventSubscriptionCertificateResponse>> {

        let referalMethod = 'APSPCertificateGenerationForTrainingEventSubscription';

        return this.prepGet<TrainingEventSubscriptionCertificateResponse>(referalMethod, this.baseUrl, ssApiUrls.Training_APSPCertificateGenerationForTrainingEventSubscription, trainingEventSubscriptionID.toString())
            .map(response => {
                this.onAPSPCertificateGenerationForTrainingEventSubscription.next(response);
                return response;
            });

    }

    public CertificateGenerationForTrainingEvent(trainingEventID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'CertificateGenerationForTrainingEvent';

        return this.prepGet<string>(referalMethod, this.baseUrl, ssApiUrls.Training_CertificateGenerationForTrainingEvent, trainingEventID.toString())
            .map(response => {
                this.onCertificateGenerationForTrainingEvent.next(response);
                return response;
            });

    }

    public CertificateRemovalForTrainingEventSubscription(trainingEventSubscriptionID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'CertificateRemovalForTrainingEventSubscription';

        return this.prepGet<string>(referalMethod, this.baseUrl, ssApiUrls.Training_CertificateRemovalForTrainingEventSubscription, trainingEventSubscriptionID.toString())
            .map(response => {
                this.onCertificateRemovalForTrainingEventSubscription.next(response);
                return response;
            });

    }

    public SendEmailForTrainingEventSubscription(request: SendEmailForTrainingEventSubscriptionRequest): Observable<IBaseResponse<string>> {
        let referalMethod = 'SendEmailForTrainingEventSubscription';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Training_SendEmailForTrainingEventSubscription)
            .map(response => {
                this.onSendEmailForTrainingEventSubscription.next(response);
                return response;
            });
    }

    public GetTrainingHistoryForMember(memberID: number): Observable<IBaseResponse<TrainingHistoryResponseArray>> {

        let referalMethod = 'GetTrainingHistoryForMember';

        return this.prepGet<TrainingHistoryResponseArray>(referalMethod, this.baseUrl, ssApiUrls.Training_GetTrainingHistoryForMember, memberID.toString())
            .map(response => {
                this.onGetTrainingHistoryForMember.next(response);
                return response;
            });

    }

    // YARD

    public GetMobileFilesByLicenseID(licenseID: number): Observable<IBaseResponse<MobileFilesItemArray>> {

        let referalMethod = 'GetMobileFilesByLicenseID';

        return this.prepGet<MobileFilesItemArray>(referalMethod, this.baseUrl, ssApiUrls.Yard_GetMobileFilesByLicenseID, licenseID.toString())
            .map(response => {
                this.onGetMobileFilesByLicenseID.next(response);
                return response;
            });

    }


    public GetMobileFilesByMemberID(MemberID: number): Observable<IBaseResponse<MobileFilesItemArray>> {

        let referalMethod = 'GetMobileFilesByMemberID';

        return this.prepGet<MobileFilesItemArray>(referalMethod, this.baseUrl, ssApiUrls.Yard_GetMobileFilesByMemberID, MemberID.toString())
            .map(response => {
                this.onGetMobileFilesByMemberID.next(response);
                return response;
            });

    }

    public CancelYARD(request: CancelYardRequest): Observable<IBaseResponse<string>> {
        let referalMethod = 'Cancel';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Yard_Cancel)
            .map(response => {
                this.onYARDCancel.next(response);
                return response;
            });
    }

    // Updater
    public AddUpdaterVersion(request: AddUpdaterVersionRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'AddUpdaterVersion';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Updater_AddUpdaterVersion)
            .map(response => {
                this.onUpdaterAddUpdaterVersion.next(response);
                return response;
            });
    }

    public AddVersionHardwareRequirement(request: AddVersionHardwareRequirementRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'AddVersionHardwareRequirement';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Updater_AddVersionHardwareRequirement)
            .map(response => {
                this.onUpdaterAddVersionHardwareRequirement.next(response);
                return response;
            });
    } 

    public AddUpdateVersionForceGroup(request: AddUpdateVersionForceGroupRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'AddUpdateVersionForceGroup';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Updater_AddUpdateVersionForceGroup)
            .map(response => {
                this.onUpdaterAddUpdateVersionForceGroup.next(response);
                return response;
            });
    } 


    public EditUpdateVersionForceGroup(request: EditUpdateVersionForceGroupRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'EditUpdateVersionForceGroup';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Updater_EditUpdateVersionForceGroup)
            .map(response => {
                this.onUpdaterEditUpdateVersionForceGroup.next(response);
                return response;
            });
    }

   
    public UpdateVideoCardBenchmark(request: UpdateVideoCardBenchmarkRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'UpdateVideoCardBenchmark';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Updater_UpdateVideoCardBenchmark)
            .map(response => {
                this.onUpdaterUpdateVideoCardBenchmark.next(response);
                return response;
            });
    }
    
    public UpdateVersionHardwareRequirement(request: UpdateVersionHardwareRequirementRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'UpdateVersionHardwareRequirement';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Updater_UpdateVersionHardwareRequirement)
            .map(response => {
                this.onUpdaterUpdateVersionHardwareRequirement.next(response);
                return response;
            });
    }
    
    public UpdateCPUBenchmark(request: UpdateCPUBenchmarkRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'UpdateCPUBenchmark';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Updater_UpdateCPUBenchmark)
            .map(response => {
                this.onUpdaterUpdateCPUBenchmark.next(response);
                return response;
            });
    }
   
    public AddVideoCardBenchmark(request: AddVideoCardBenchmarkRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'AddVideoCardBenchmark';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Updater_AddVideoCardBenchmark)
            .map(response => {
                this.onUpdaterAddVideoCardBenchmark.next(response);
                return response;
            });
    }
       
    public AddCPUBenchmark(request: AddCPUBenchmarkRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'AddCPUBenchmark';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Updater_AddCPUBenchmark)
            .map(response => {
                this.onUpdaterAddCPUBenchmark.next(response);
                return response;
            });
    }

    public DeleteVersionHardwareRequirement(versionHardwareRequirementID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'DeleteVersionHardwareRequirement';

        return this.prepDelete<string>(referalMethod, this.baseUrl, ssApiUrls.Updater_DeleteVersionHardwareRequirement, versionHardwareRequirementID.toString())
            .map(response => {
                this.onUpdaterDeleteVersionHardwareRequirement.next(response);
                return response;
            });

    } 

    public DeleteUpdateVersionForceGroup(updateVersionForceGroupID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'DeleteUpdateVersionForceGroup';

        return this.prepDelete<string>(referalMethod, this.baseUrl, ssApiUrls.Updater_DeleteUpdateVersionForceGroup, updateVersionForceGroupID.toString())
            .map(response => {
                this.onUpdaterDeleteUpdateVersionForceGroup.next(response);
                return response;
            });

    } 

    public UpdateUpdaterVersion(request: UpdateUpdaterVersionRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'UpdateUpdaterVersion';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Updater_UpdateUpdaterVersion)
            .map(response => {
                this.onUpdaterUpdateUpdaterVersion.next(response);
                return response;
            });
    }

    public GetUpdaterVersions(): Observable<IBaseResponse<UpdaterVersionItemArray>> {

        let referalMethod = 'GetUpdaterVersions';

        return this.prepGet<UpdaterVersionItemArray>(referalMethod, this.baseUrl, ssApiUrls.Updater_GetUpdaterVersions)
            .map(response => {
                this.onUpdaterGetUpdaterVersions.next(response);
                return response;
            });

    }
   
    public GetPostponeGroups(): Observable<IBaseResponse<PostponeGroupItemArray>> {

        let referalMethod = 'GetPostponeGroups';

        return this.prepGet<PostponeGroupItemArray>(referalMethod, this.baseUrl, ssApiUrls.Updater_GetPostponeGroups)
            .map(response => {
                this.onUpdaterGetPostponeGroups.next(response);
                return response;
            });

    } 
   
    public GetHardwareChecks(): Observable<IBaseResponse<HardwareCheckItemArray>> {

        let referalMethod = 'GetHardwareChecks';

        return this.prepGet<HardwareCheckItemArray>(referalMethod, this.baseUrl, ssApiUrls.Updater_GetHardwareChecks)
            .map(response => {
                this.onUpdaterGetHardwareChecks.next(response);
                return response;
            });

    } 

    public GetBenchmarks(request: GetBenchmarksRequest): Observable<IBaseResponse<GetBenchmarksResponse>> {
        let referalMethod = 'GetBenchmarks';

        return this.prepPOST<GetBenchmarksResponse>(referalMethod, request, this.baseUrl, ssApiUrls.Updater_GetBenchmarks)
            .map(response => {

                if (response.Result){
                    VideoCardBenchmarkItemArray.FixDates(response.Data.VideoCardBenchmarkItems);                
                    CPUBenchmarkItemArray.FixDates(response.Data.CPUBenchmarkItems);
                }
                
                this.onUpdaterGetBenchmarks.next(response);
                return response;
            });
    }

    public CheckUpdatePackageStatus(updatePackageID: number): Observable<IBaseResponse<CheckUpdatePackageStatusResponse>> {

        let referalMethod = 'CheckUpdatePackageStatus';

        return this.prepGet<CheckUpdatePackageStatusResponse>(referalMethod, this.baseUrl, ssApiUrls.Updater_CheckUpdatePackageStatus, updatePackageID.toString())
            .map(response => {
                this.onUpdaterCheckUpdatePackageStatus.next(response);
                return response;
            });

    }

    public DeleteInstructionItem(instructionItemID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'DeleteInstructionItem';

        return this.prepDelete<string>(referalMethod, this.baseUrl, ssApiUrls.Updater_DeleteInstructionItem, instructionItemID.toString())
            .map(response => {
                this.onUpdaterDeleteInstructionItem.next(response);
                return response;
            });

    }

    public DeleteUpdaterVersion(updaterVersionID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'DeleteUpdaterVersion';

        return this.prepDelete<string>(referalMethod, this.baseUrl, ssApiUrls.Updater_DeleteUpdaterVersion, updaterVersionID.toString())
            .map(response => {
                this.onUpdaterDeleteUpdateVersion.next(response);
                return response;
            });

    }

    public GetActiveVersions(): Observable<IBaseResponse<VersionItemArray>> {

        let referalMethod = 'GetActiveVersions';

        return this.prepGet<VersionItemArray>(referalMethod, this.baseUrl, ssApiUrls.Updater_GetActiveVersions)
            .map(response => {
                this.onUpdaterGetActiveVersions.next(response);
                return response;
            });

    }

    public GetActiveV3Versions(): Observable<IBaseResponse<VersionItemArray>> {

        let referalMethod = 'GetActiveV3Versions';

        return this.prepGet<VersionItemArray>(referalMethod, this.baseUrl, ssApiUrls.Updater_GetActiveV3Versions)
            .map(response => {
                this.onUpdaterGetActiveV3Versions.next(response);
                return response;
            });

    }

    public AddVersionWithPath(request: AddVersionWithPathRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'AddVersionWithPath';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Updater_AddVersionWithPath)
            .map(response => {
                this.onUpdaterAddVersionWithPath.next(response);
                return response;
            });
    }

    public UpdateVersionWithPath(request: UpdateVersionWithPathRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'UpdateVersionWithPath';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Updater_UpdateVersionWithPath)
            .map(response => {
                this.onUpdaterUpdateVersionWithPath.next(response);
                return response;
            });
    }

    public AddUpdatePackage(request: AddUpdatePackageRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'AddUpdatePackage';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Updater_AddUpdatePackage)
            .map(response => {
                this.onUpdaterAddUpdatePackage.next(response);
                return response;
            });
    }


    public EditUpdatePackage(request: EditUpdatePackageRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'EditUpdatePackage';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.Updater_EditUpdatePackage)
            .map(response => {
                this.onUpdaterEditUpdatePackage.next(response);
                return response;
            });
    }

    public FinalizeUpdatePackage(UpdatePackageItemID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'FinalizeUpdatePackage';

        return this.prepGet<string>(referalMethod, this.baseUrl, ssApiUrls.Updater_FinalizeUpdatePackage, UpdatePackageItemID.toString())
            .map(response => {
                this.onUpdaterFinalizeUpdatePackage.next(response);
                return response;
            });

    }

    public GetUpdatePackageInstructions(request: GetUpdatePackageInstructionsRequest): Observable<IBaseResponse<InstructionSet>> {

        let referalMethod = 'GetUpdatePackageInstructions';

        return this.prepPOST<InstructionSet>(referalMethod, request, this.baseUrl, ssApiUrls.Updater_GetUpdatePackageInstructions)
            .map(response => {
                this.onUpdaterGetUpdatePackageInstructions.next(response);
                return response;
            });
    }

    public RestartUpdatePackage(UpdatePackageItemID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'RestartUpdatePackage';

        return this.prepGet<string>(referalMethod, this.baseUrl, ssApiUrls.Updater_RestartUpdatePackage, UpdatePackageItemID.toString())
            .map(response => {
                this.onUpdaterRestartUpdatePackage.next(response);
                return response;
            });

    }

    public MakeUpdatePackageAvailable(UpdatePackageItemID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'MakeUpdatePackageAvailable';

        return this.prepGet<string>(referalMethod, this.baseUrl, ssApiUrls.Updater_MakeUpdatePackageAvailable, UpdatePackageItemID.toString())
            .map(response => {
                this.onUpdaterMakeUpdatePackageAvailable.next(response);
                return response;
            });

    }

    public DeleteUpdatePackage(UpdatePackageItemID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'DeleteUpdatePackage';

        return this.prepGet<string>(referalMethod, this.baseUrl, ssApiUrls.Updater_DeleteUpdatePackage, UpdatePackageItemID.toString())
            .map(response => {
                this.onUpdaterDeleteUpdatePackage.next(response);
                return response;
            });

    }

    public GetUpdateClientSettings(): Observable<IBaseResponse<UpdateClientSettingsItemArray>> {

        let referalMethod = 'GetUpdateClientSettings';

        return this.prepGet<UpdateClientSettingsItemArray>(referalMethod, this.baseUrl, ssApiUrls.Updater_GetUpdateClientSettings)
            .map(response => {
                this.onUpdaterGetUpdateClientSettings.next(response);
                return response;
            });

    }

    public GetUpdatePackages(): Observable<IBaseResponse<UpdatePackageItemArray>> {

        let referalMethod = 'GetUpdatePackages';

        return this.prepGet<UpdatePackageItemArray>(referalMethod, this.baseUrl, ssApiUrls.Updater_GetUpdatePackages)
            .map(response => {
                this.onUpdaterGetUpdatePackages.next(response);
                return response;
            });

    }

    public GetUpdateVersionForceGroups(): Observable<IBaseResponse<UpdateVersionForceGroupItemArray>> {

        let referalMethod = 'GetUpdateVersionForceGroups';

        return this.prepGet<UpdateVersionForceGroupItemArray>(referalMethod, this.baseUrl, ssApiUrls.Updater_GetUpdateVersionForceGroups)
            .map(response => {
                this.onUpdaterGetUpdateVersionForceGroups.next(response);
                return response;
            });

    }
    
    public GetUpdateVersionForceGroupsV3(): Observable<IBaseResponse<UpdateVersionForceGroupItemArray>> {

        let referalMethod = 'GetUpdateVersionForceGroupsV3';

        return this.prepGet<UpdateVersionForceGroupItemArray>(referalMethod, this.baseUrl, ssApiUrls.Updater_GetUpdateVersionForceGroupsV3)
            .map(response => {
                this.onUpdaterGetUpdateVersionForceGroupsV3.next(response);
                return response;
            });

    }

    public GetUpdaterVersionForceGroups(): Observable<IBaseResponse<UpdaterVersionForceGroupItemArray>> {

        let referalMethod = 'GetUpdaterVersionForceGroups';

        return this.prepGet<UpdaterVersionForceGroupItemArray>(referalMethod, this.baseUrl, ssApiUrls.Updater_GetUpdaterVersionForceGroups)
            .map(response => {
                this.onUpdaterGetUpdaterVersionForceGroups.next(response);
                return response;
            });

    }

    public GetLicenseTrial(licenseKey: string) : Observable<IBaseResponse<TrialLicenseResponse>> 
    {
        let referalMethod = 'GetLicenseTrial';

        return this.prepGet<TrialLicenseResponse>(referalMethod, this.baseUrl, ssApiUrls.Trial_GetForLicense, licenseKey)
            .map(response => {
                this.onTrialGetForLicense.next(response);
                return response;
            });
        
    }

    // LIVEHUB
    public GetLiveHubConnections(request: GetLiveHubConnectionsRequest): Observable<IBaseResponse<LiveHubConnectionItemArray>> {
        let referalMethod = 'GetConnections';

        return this.prepPOST<LiveHubConnectionItemArray>(referalMethod, request, this.baseUrl, ssApiUrls.LiveHub_GetConnections)
            .map(response => {
                this.onLiveHubGetConnections.next(response);
                return response;
            });
    }

    public GetLiveHubUpdateLogs(logQuantity: number): Observable<IBaseResponse<UpdateSuccessArray>> {
        let referalMethod = 'GetUpdateLogs';

        return this.prepGet<UpdateSuccessArray>(referalMethod, this.baseUrl, ssApiUrls.LiveHub_GetUpdateLogs, logQuantity.toString())
            .map(response => {
                this.onLiveHubGetUpdateLogs.next(response);

                if (response.Result)
                    UpdateSuccessArray.FixDates(response.Data);                

                return response;
                
            });

    }

    // WAREHOUSE
    public GetProductTotalHistory(request: GetProductTotalHistoryRequest): Observable<IBaseResponse<ProductTotalHistoryItemArray>> {
        let referalMethod = 'GetProductTotalHistory';

        return this.prepPOST<ProductTotalHistoryItemArray>(referalMethod, request, this.baseUrl, ssApiUrls.Warehouse_GetProductTotalHistory)
            .map(response => {
                this.onGetProductTotalHistory.next(response);
                return response;
            });
    }

    public GetErrors(request: GetErrorsRequest): Observable<IBaseResponse<ErrorItemArray>> {
        let referalMethod = 'GetErrors';

        return this.prepPOST<ErrorItemArray>(referalMethod, request, this.baseUrl, ssApiUrls.Warehouse_GetErrors)
            .map(response => {
                this.onGetWarehouseErrors.next(response);
                return response;
            });
    } 

    // VIDEOCARD
    public GetLicenseVideoCards(request: GetLicenseVideoCardsRequest): Observable<IBaseResponse<LicenseVideoCardItemArray>> {
        let referalMethod = 'GetLicenseVideoCards';

        return this.prepPOST<LicenseVideoCardItemArray>(referalMethod, request, this.baseUrl, ssApiUrls.VideoCard_GetLicenseVideoCards)
            .map(response => {
                this.onGetLicenseVideoCards.next(response);
                return response;
            });
    }

    //POOL STUDIO
    public GetBubbles(request: GetBubblesRequest): Observable<IBaseResponse<BubbleItemArray>> {
        let referalMethod = 'GetBubbles';

        return this.prepPOST<BubbleItemArray>(referalMethod, request, this.baseUrl, ssApiUrls.PoolStudio_GetBubbles)
            .map(response => {
                this.onPoolStudioGetBubbles.next(response);

                if (response.Result)
                    BubbleItemArray.FixDates(response.Data);                

                return response;
            });
    }
    
    public GetBubbleGroups(): Observable<IBaseResponse<BubbleGroupItemArray>> {
        let referalMethod = 'GetBubbleGroups';

        return this.prepGet<BubbleGroupItemArray>(referalMethod, this.baseUrl, ssApiUrls.PoolStudio_GetBubbleGroups)
            .map(response => {
                this.onPoolStudioGetBubbleGroups.next(response);
                return response;
            });
    }    

    public AddBubble(request: AddBubbleRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'AddBubble';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.PoolStudio_AddBubble)
            .map(response => {
                this.onPoolStudioAddBubble.next(response);
                return response;
            });
    }    

    public UpdateBubble(request: EditBubbleRequest): Observable<IBaseResponse<number>> {

        let referalMethod = 'UpdateBubble';

        return this.prepPOST<number>(referalMethod, request, this.baseUrl, ssApiUrls.PoolStudio_UpdateBubble)
            .map(response => {
                this.onPoolStudioUpdateBubble.next(response);
                return response;
            });
    }

    public DeleteBubble(bubbleID: number): Observable<IBaseResponse<string>> {

        let referalMethod = 'DeleteBubble';

        return this.prepDelete<string>(referalMethod, this.baseUrl, ssApiUrls.PoolStudio_DeleteBubble, bubbleID.toString())
            .map(response => {
                this.onPoolStudioDeleteBubble.next(response);
                return response;
            });

    }

    

    public SetTrial(request: TrialSetRequest): Observable<IBaseResponse<string>> {

        let referalMethod = 'SetTrial';

        return this.prepPOST<string>(referalMethod, request, this.baseUrl, ssApiUrls.Trial_Set)
            .map(response => {
                this.onTrialSet.next(response);
                return response;
            });
    }

}
